import React from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { withRouter } from "react-router-dom";
import DatePicker from "react-datepicker";
import Moment from "moment";
import axios from "axios";
import AddIcon from "../UIComponents/AddIcon";
import MinusIcon from "../UIComponents/MinusIcon";
import Modal from "react-bootstrap/Modal";
import { validateFields } from "../Utils/utilities";
import { RadioGroup, Radio, FormControlLabel } from "@material-ui/core";
import API from "../helpers/api";
import $ from "jquery";
import {
  getEquipmentNameList,
  getPortNameList,
  getApplicableServiceTypeList,
  getApplicableServiceTypeListWithInterval,
  getEquipmentServiceTypeListWithInterval,
  getEquipmentDropDownList,
  getServiceDates,
  getEquipmentNameListAndId,
  getMakeList,
  getModelsList,
  getModelsOtherList,
} from "../Actions/helpersAPI";
import {
  getPortAndCountry,
  getShipPortAndCountry,
} from "../Actions/ServiceProviderAPI";
import {
  getEquipmentServiceTypeList,
  uploadAttachments,
} from "../Actions/CommonAPI";
import {
  postAnnualCertificate,
  postBiannualCertificate,
  postFiveYearlyCertificate,
  postTenYearlyCertificate,
  deleteAttachmentInBucket
} from "../Actions/CommonAPI";
import swal from "sweetalert";
import Autocomplete from "react-autocomplete";
import MaterialAutocomplete from "@mui/material/Autocomplete";
import { Multiselect } from "multiselect-react-dropdown";
import { confirmAlert } from "react-confirm-alert";
import { isNumberValid } from "../Common/CommonFunction";
import TextField from "@mui/material/TextField";
import e from "cors";
import i18n from "./DropdownLanguage/i18n";

let currentuser = JSON.parse(localStorage.getItem("currentUser"));
let valueCheck = false;

class newEquipment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openAlert: false,
      modelOthers: false,
      isContractApplicableYes: false,
      isContractApplicableNo: false,
      make: "",
      openOwnerRequirement: false,
      isOwner: true,
      modalIsOpen: false,
      ship: false,
      shore: false,
      modelValidation: false,
      makeValidation: false,
      rescueMakeValidation: false,
      rescueModelValidation: false,
      rescueDavitMakeValidation: false,
      lifeMakeValidation: false,
      lifeModelValidation: false,
      lifeDavitMakeValidation: false,
      equipmentinfo: {
        shipId: 0,
        isContractApplicable: false,
        equipmentName: "",
        equipmentId: 0,
        lifeboatMake: "",
        lifeboatModel: "",
        davitwinchMake: "",
        lifeboatMakeId: 0,
        lifeboatModelId: 0,
        davitwinchMakeId: 0,
        lifeboatRelease: "",
        rescueboatMake: "",
        rescueboatModel: "",
        rescueboatdavitwinchMake: "",
        rescueboatMakeId: 0,
        rescueboatModelId: 0,
        rescueboatdavitwinchMakeId: 0,
        rescueboatRelease: "",
        dateOfBuild: "",
        makeId: 0,
        modelId: 0,
        quantity: "",
        unit: "",
        equipmentType: "",
        capacity: "",
        category: "",
        serviceDetails: [],
        applicableServices: [],
        make: "",
        model: "",
        createdBy: currentuser.name,
        equipmentContractTypeId: 0,
      },
      annual: false,
      biannual: false,
      fiveyearly: false,
      tenyearly: false,
      serviceType: [],
      applicableServiceEquipType: [
      ],
      lastannualServiceCertificate: "",
      lastbiannualServiceCertificate: "",
      last5yearlyServiceCertificate: "",
      last10yearlyServiceCertificate: "",
      Annual: {
        serviceType: "annually",
        lastDonePort: "",
        attachmentName: "",
        attachmentGuid: "",
        lastDoneDate: "",
        nextDueDate: "",
      },
      Biannual: {
        serviceType: "biannually",
        lastDonePort: "",
        attachmentName: "",
        attachmentGuid: "",
        lastDoneDate: "",
        nextDueDate: "",
      },
      Fiveyearly: {
        serviceType: "fiveyearly",
        lastDonePort: "",
        attachmentName: "",
        attachmentGuid: "",
        lastDoneDate: "",
        nextDueDate: "",
      },
      Tenyearly: {
        serviceType: "tenyearly",
        lastDonePort: "",
        attachmentName: "",
        attachmentGuid: "",
        lastDoneDate: "",
        nextDueDate: "",
      },
      file1: "",
      file2: "",
      file3: "",
      file4: "",
      DatePickerIsOpen: false,
      lastannualDatePickerIsOpen: false,
      nextannualDatePickerIsOpen: false,
      lastbiannualDatePickerIsOpen: false,
      nextbiannualDatePickerIsOpen: false,
      lastFiveYearDatePickerIsOpen: false,
      nextFiveYearDatePickerIsOpen: false,
      lastTenYearDatePickerIsOpen: false,
      nextTenYearDatePickerIsOpen: false,
      equipmentArray: [],
      index: 0,
      annualIndex: 0,
      biannualIndex: 0,
      fiveyearlyIndex: 0,
      tenyearlyIndex: 0,
      dropDown: {
        EquipmentName: "",
        EquipmentType: "",
        Category: "",
        Capacity: "",
        makeId: 0,
        davitwinchMakeId: 0,
      },
      interval: 0,
      serviceDate: "",
      AddServiceYear: [
        {
          shipId: 0,
          equipmentId: 0,
          Id: 0,
          serviceTypeId: 0,
          serviceTypeName: "",
          servicetypelist: [],
          isShore: false,
          IsShip: false,
          radioButton: "",
          isDeleted: false,
        },
      ],
      MakeModelList: [
        {
          id: 0,
          name: "Others",
        },
      ],
      ServiceTypeList: [],
      selectedServiceYears: [],
      inValidFields: [],
      openLifeMake: false,
      openEquipment: false,
      openEquipmentType: false,
      openLifeBoatModel: false,
      openDavitMake: false,
      openRescueMake: false,
      rescueWinchMake: false,
      equipemntConfigTypeList: [],
      selectedEquipmentTypes: []
    };
    this.handleManufacturingDate = this.handleManufacturingDate.bind(this);
    this.handleServiceDateChange = this.handleServiceDateChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handlenextServiceDateChange =
      this.handlenextServiceDateChange.bind(this);
    this.openDatePicker = this.openDatePicker.bind(this);
    this.openannualDatePicker = this.openannualDatePicker.bind(this);
    this.nextannualDatePicker = this.nextannualDatePicker.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleAnnualInputChange = this.handleAnnualInputChange.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
    this.AddEquipment = this.AddEquipment.bind(this);
    this.UpdateEquipment = this.UpdateEquipment.bind(this);
    this.renderPortTitle = this.renderPortTitle.bind(this);
    this.renderCountryTitle = this.renderCountryTitle.bind(this);
    this.renderServiceProviderTitle = this.renderServiceProviderTitle.bind(this);
    this.renderEquipmentTitle = this.renderEquipmentTitle.bind(this);
    this.renderEquipmentTypeTitle = this.renderEquipmentTypeTitle.bind(this);
  }
  async componentDidMount() {
    console.log(this.props.flagclass);
    let _this = this;
    const { dispatch, EquipmentObject, editEquipment, match, t } = _this.props;
    let url = `${API.equipmentLookups}?lookupType=${"EquipmentCategoryType"}`;
    axios.get(url).then((response) => {
      this.setState({ equipemntConfigTypeList: response.data || [] });
    });
    if (EquipmentObject?.equipmentName) {
      this.state.dropDown.EquipmentName = EquipmentObject.equipmentName;
      this.state.dropDown.Capacity = EquipmentObject.capacity;
      this.state.dropDown.Category = EquipmentObject.category;
      this.state.dropDown.EquipmentType = EquipmentObject.equipmentType;
      if (EquipmentObject.equipmentName.toLowerCase().includes("lifeboat")) {
        $("#ModelHide").addClass("none");
        $("#MakeHide").addClass("none");
        $("#LifeBoatEquipment").removeClass("lifeBoat-hide");
        $("#LifeBoatEquipment1").removeClass("lifeBoat-hide");
        $("#LifeBoatEquipment2").removeClass("lifeBoat-hide");
        $("#LifeBoatEquipment3").removeClass("lifeBoat-hide");
        // $("#categoryequiptype").addClass("categorylifeboat");
        this.state.dropDown.makeId = EquipmentObject.lifeboatMakeId ? EquipmentObject.lifeboatMakeId : 0;
        this.state.dropDown.davitwinchMakeId = EquipmentObject.davitwinchMakeId ? EquipmentObject.davitwinchMakeId : 0;
        this.setState({})
        dispatch(getEquipmentDropDownList(_this.state.dropDown));
      }
      else if (EquipmentObject.equipmentName.toLowerCase().includes("rescue boat")) {
        $("#ModelHide").addClass("none");
        $("#MakeHide").addClass("none");
        $("#categoryequiptype").removeClass("categorylifeboat");
        $("#rescueboatEquipment").removeClass("lifeBoat-hide");
        $("#rescueboatEquipment1").removeClass("lifeBoat-hide");
        $("#rescueboatEquipment2").removeClass("lifeBoat-hide");
        $("#rescueboatEquipment3").removeClass("lifeBoat-hide");
        this.state.dropDown.makeId = EquipmentObject.rescueboatMakeId ? EquipmentObject.rescueboatMakeId : 0;
        this.state.dropDown.davitwinchMakeId = EquipmentObject.rescueboatdavitwinchMakeId ? EquipmentObject.rescueboatdavitwinchMakeId : 0;
        this.setState({})
        dispatch(getEquipmentDropDownList(_this.state.dropDown));
      } else {
        $("#ModelHide").removeClass("none");
        $("#MakeHide").removeClass("none");
        $("#LifeBoatEquipment").addClass("lifeBoat-hide");
        $("#LifeBoatEquipment1").addClass("lifeBoat-hide");
        $("#LifeBoatEquipment2").addClass("lifeBoat-hide");
        $("#LifeBoatEquipment3").addClass("lifeBoat-hide");
        $("#rescueboatEquipment").addClass("lifeBoat-hide");
        $("#rescueboatEquipment1").addClass("lifeBoat-hide");
        $("#rescueboatEquipment2").addClass("lifeBoat-hide");
        $("#rescueboatEquipment3").addClass("lifeBoat-hide");
        this.state.dropDown.makeId = EquipmentObject.makeId ? EquipmentObject.makeId : 0;
        this.state.dropDown.davitwinchMakeId = 0;
        this.setState({})
        dispatch(getEquipmentDropDownList(_this.state.dropDown));
        console.log(this.props.applicableServiceType, 'check')
      }
    }
    if (EquipmentObject?.equipmentName) {
      if (EquipmentObject.equipmentName.toLowerCase().includes("lifeboat")) {
        this.getEquipmentServiceTypeListbuilt(
          EquipmentObject.equipmentId ? EquipmentObject.equipmentId : 0,
          EquipmentObject.shipId,
          EquipmentObject.lifeboatMakId ? EquipmentObject.lifeboatMakeId : 0,
          EquipmentObject.lifeboatModelId ? EquipmentObject.lifeboatModelId : 0,
          EquipmentObject.davitwinchMakeId ? EquipmentObject.davitwinchMakeId : 0,
        )

      } else if (EquipmentObject?.equipmentName.toLowerCase().includes("rescue boat")) {
        this.getEquipmentServiceTypeListbuilt(
          EquipmentObject.equipmentId ? EquipmentObject.equipmentId : 0,
          EquipmentObject.shipId,
          EquipmentObject.rescueboatMakeId ? EquipmentObject.rescueboatMakeId : 0,
          EquipmentObject.rescueboatModelId ? EquipmentObject.rescueboatModelId : 0,
          EquipmentObject.rescueboatdavitwinchMakeId ? EquipmentObject.rescueboatdavitwinchMakeId : 0,
        )
      } else {
        this.getApplicableServiceTypeListbuilt(
          EquipmentObject.equipmentId ? EquipmentObject.equipmentId : 0,
          EquipmentObject.shipId,
          EquipmentObject.makeId ? EquipmentObject.makeId : 0,
          EquipmentObject.modelId ? EquipmentObject.modelId : 0
        )
      }
      dispatch({ type: "getEquipmentDetails", data: this.state.servicetype });
    }
    dispatch(getEquipmentNameListAndId());
    dispatch(getEquipmentNameList());
    dispatch(getPortNameList());
    /*    dispatch(getMakeList()); */
    $(document).on("keyup", "#quantity", function () {
      var pattern = /^(0|[0-9][0-9]*)$/;
      if (!pattern.test($("#quantity").val())) {
        $("#quantityErrMsg").text(`${t("ErrorMessage.InvalidMsg")}`);
        let invalid = _this.state.inValidFields;
        _this.setState({
          invalidFields: invalid.push("quantity"),
        });
      } else {
        $("#quantityErrMsg").text("");
        let invalid = _this.state.inValidFields;
        let length = _this.state.inValidFields.length;
        var index = invalid.indexOf("quantity");
        if (index != -1) {
          invalid.splice(index, length);
        }
        _this.setState({ invalidFields: invalid });
      }
    });
    await axios.get(`${API.GetServiceTypeList}`).then((res) => {
      let list = [];
      let serviceTypeList = [];
      res.data.map((item, index) => {
        let listItem = item.serviceTypes.split(" ");
        let order = (listItem[0]);
        let id = item.id;
        list.push({
          id,
          order,
        });
      });

      let mainList = list.sort(function (a, b) {
        return a.order - b.order;
      });
      mainList.map((item, i) => {
        let serviceTypes = item.order + " yearly";
        item = item.id;
        serviceTypeList.push({
          item,
          serviceTypes,
        });
      });
      this.state.AddServiceYear[0].servicetypelist = serviceTypeList;
      this.setState({ ServiceTypeList: serviceTypeList }, () => {
        console.log("dropdown", this.state.dropDown)
      });

    });
    // dispatch(getPortAndCountry(port));
    //    dispatch(getEquipmentDropDownList(this.state.dropDown));
  }
  componentDidUpdate() {
    window.onpopstate = (e) => {
      //your code...
      this.props.dispatch({ type: "ShowSidePan", data: false });
      this.props.history.push("/Home/ShipManagementNewItem");
    };
  }
  getApplicableServiceTypeListbuilt = (equipmentId, shipId, makeId, modelId) => {
    const { dispatch, EquipmentObject, editEquipment, match, t } = this.props;
    let url = `${API.ServiceTypeInterval}V2?shipid=${shipId}&equipmentId=${equipmentId}&makeId=${makeId}&modelId=${modelId}&flagId=${this.props.flagclass.flag}&classIds=${this.props.flagclass.class}`;
    axios
      .get(url)
      .then((response) => {
        this.props.dispatch({
          type: "getServiceTypeIntervalListSuccess",
          data: response.data,
        });
        if (EquipmentObject.applicableServices.length === 0) {
          // response.data.forEach((_, index) => {
          //   if (this.state.applicableServiceEquipType[index]) {
          //     this.state.applicableServiceEquipType[index].applicableEquipType = {};
          //   } else {
          //     // Initialize an object if it doesn't exist at the current index
          //     this.state.applicableServiceEquipType[index] = { applicableEquipType: {} };
          //   }
          // });
          this.setState({ applicableServiceEquipType: [] });
        }
        else {
          const updatedState = response.data.map(item => {
            const match = EquipmentObject.applicableServices.find(
              secondItem =>
                secondItem.serviceTypeId === item.serviceTypeId &&
                secondItem.serviceType === item.serviceType
            );
            // return match ? match : {};
            if (match) {
              console.log(match);
              return {
                applicableEquipType: {
                  lookUpId: match.equipmentContractTypeId,
                  lookUpName: match.equipmentContractTypeName
                },
                serviceType: match.serviceType,
                serviceTypeId: match.serviceTypeId
              }
            }
            else {
              console.log("No match");
              return {
                applicableEquipType: {
                  lookUpId: 0,
                  lookUpName: ""
                },
                serviceType: "",
                serviceTypeId: 0
              }
            }
          });
          this.setState({ applicableServiceEquipType: updatedState }, () => {
            console.log(this.state.applicableServiceEquipType);
          });
        }

      })
      .catch((error) => {
        this.props.dispatch({
          type: "getServiceTypeIntervalListFailure",
          error: "ERROR",
        });
      });
  };
  getEquipmentServiceTypeListbuilt = (equipmentId, shipId, makeId, modelId, davitwinchMakeId) => {
    const { dispatch, EquipmentObject, editEquipment, match, t } = this.props;
    let url = `${API.EquipmentServiceIntervalList}V2?shipid=${shipId}&equipmentId=${equipmentId}&makeId=${makeId ?? 0}&modelId=${modelId ?? 0}&davitWinchMakeId=${davitwinchMakeId ?? 0}&flagId=${this.props.flagclass.flag}&classIds=${this.props.flagclass.class}`;
    axios
      .get(url)
      .then((response) => {
        this.props.dispatch({
          type: "getServiceTypeIntervalListSuccess",
          data: response.data,
        });
        if (EquipmentObject.applicableServices.length === 0) {
          this.setState({ applicableServiceEquipType: [] });
        }
        else {
          const updatedState = response.data.map(item => {
            const match = EquipmentObject.applicableServices.find(
              secondItem =>
                secondItem.serviceTypeId === item.serviceTypeId &&
                secondItem.serviceType === item.serviceType
            );
            // return match ? match : {};
            if (match) {
              console.log(match);
              return {
                applicableEquipType: {
                  lookUpId: match.equipmentContractTypeId,
                  lookUpName: match.equipmentContractTypeName
                },
                serviceType: match.serviceType,
                serviceTypeId: match.serviceTypeId
              }
            }
            // else {
            //   console.log("No match");
            //   return {
            //     applicableEquipType: {
            //       lookUpId: 0,
            //       lookUpName: ""
            //     },
            //     serviceType: "",
            //     serviceTypeId: 0
            //   }
            // }
          });
          this.setState({ applicableServiceEquipType: updatedState }, () => {
            console.log(this.state.applicableServiceEquipType);
          });
        }

      })
      .catch((error) => {
        this.props.dispatch({
          type: "getServiceTypeIntervalListFailure",
          error: "ERROR",
        });
      });
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      dispatch,
      annualAttachment,
      biannualAttachment,
      fiveyearlyAttachment,
      tenyearlyAttachment,
      EquipmentArray,
      applicableServiceType,
      EquipmentObject,
      ServiceDate,
      CountryList,
      PortList,
      ServiceProviderPortList,
      ServiceProviderId,
      serviceAttachment,
      EquipmentDropDownList,
    } = nextProps;

    if (CountryList) {
      prevState["CountryList" + CountryList.type] = CountryList.data;
    }
    if (PortList) {
      prevState["PortList" + PortList.type] = PortList.data;
    }
    if (ServiceProviderPortList) {
      prevState["ServiceProviderList" + ServiceProviderPortList.type] =
        ServiceProviderPortList.data;
    }
    if (ServiceProviderId) {
      prevState["ServiceProviderId" + ServiceProviderId.type] =
        ServiceProviderId.data;
    }
    if (EquipmentObject && EquipmentObject !== "") {
      prevState.AddServiceYear[0].shipId = EquipmentObject.shipId;
      prevState.AddServiceYear[0].equipmentId = EquipmentObject.equipmentId;
      prevState.equipmentinfo.shipId = EquipmentObject.shipId;
      prevState.equipmentinfo.equipmentContractTypeId = EquipmentObject?.equipmentContractTypeId ? EquipmentObject?.equipmentContractTypeId : 0;
      prevState.equipmentinfo.equipmentName = EquipmentObject.equipmentName;
      prevState.equipmentinfo.equipmentId = EquipmentObject.equipmentId;
      prevState.equipmentinfo.lifeboatRelease = EquipmentObject.lifeboatRelease ? EquipmentObject.lifeboatRelease : "";
      prevState.equipmentinfo.davitwinchMake = EquipmentObject.davitwinchMake ? EquipmentObject.davitwinchMake : "";
      prevState.equipmentinfo.davitwinchMakeId = EquipmentObject.davitwinchMakeId ? EquipmentObject.davitwinchMakeId : 0;
      prevState.equipmentinfo.lifeboatMake = EquipmentObject.lifeboatMake ? EquipmentObject.lifeboatMake : "";
      prevState.equipmentinfo.lifeboatMakeId = EquipmentObject.lifeboatMakeId ? EquipmentObject.lifeboatMakeId : 0;
      prevState.equipmentinfo.lifeboatModel = EquipmentObject.lifeboatModel ? EquipmentObject.lifeboatModel : "";
      prevState.equipmentinfo.lifeboatModelId = EquipmentObject.lifeboatModelId ? EquipmentObject.lifeboatModelId : 0;
      prevState.equipmentinfo.rescueboatMake = EquipmentObject.rescueboatMake ? EquipmentObject.rescueboatMake : "";
      prevState.equipmentinfo.rescueboatMakeId = EquipmentObject.rescueboatMakeId ? EquipmentObject.rescueboatMakeId : 0;
      prevState.equipmentinfo.rescueboatModel = EquipmentObject.rescueboatModel ? EquipmentObject.rescueboatModel : "";
      prevState.equipmentinfo.rescueboatModelId = EquipmentObject.rescueboatModelId ? EquipmentObject.rescueboatModelId : 0;
      prevState.equipmentinfo.rescueboatdavitwinchMake = EquipmentObject.rescueboatdavitwinchMake ? EquipmentObject.rescueboatdavitwinchMake : "";
      prevState.equipmentinfo.rescueboatdavitwinchMakeId = EquipmentObject.rescueboatdavitwinchMakeId ? EquipmentObject.rescueboatdavitwinchMakeId : 0;
      prevState.equipmentinfo.rescueboatRelease = EquipmentObject.rescueboatRelease ? EquipmentObject.rescueboatRelease : "";
      prevState.equipmentinfo.dateOfBuild = EquipmentObject.dateOfBuild ? EquipmentObject.dateOfBuild : "";
      prevState.equipmentinfo.makeId = EquipmentObject.makeId ? EquipmentObject.makeId : 0;
      prevState.equipmentinfo.modelId = EquipmentObject.modelId ? EquipmentObject.modelId : 0;
      prevState.equipmentinfo.make = EquipmentObject.make ? EquipmentObject.make : "";
      prevState.equipmentinfo.model = EquipmentObject.model ? EquipmentObject.model : "";
      prevState.equipmentinfo.quantity = EquipmentObject.quantity;
      prevState.equipmentinfo.unit = EquipmentObject.unit;
      prevState.equipmentinfo.equipmentType = EquipmentObject.equipmentType;
      prevState.equipmentinfo.capacity = EquipmentObject.capacity;
      prevState.equipmentinfo.category = EquipmentObject.category;
      prevState.equipmentinfo.serviceDetails = EquipmentObject.serviceDetails;
      prevState.isContractApplicableYes = EquipmentObject.isContractApplicable;
      prevState.isContractApplicableNo = !EquipmentObject.isContractApplicable;
      prevState.index = EquipmentArray && EquipmentArray.findIndex((x) => x.equipmentName === EquipmentObject.equipmentName);
      prevState.annualIndex = EquipmentObject &&
        EquipmentObject.serviceDetails && EquipmentObject.serviceDetails.findIndex((x) => x.serviceType === "annually");
      prevState.biannualIndex = EquipmentObject &&
        EquipmentObject.serviceDetails &&
        EquipmentObject.serviceDetails.findIndex((x) => x.serviceType === "biannually");
      prevState.fiveyearlyIndex =
        EquipmentObject &&
        EquipmentObject.serviceDetails &&
        EquipmentObject.serviceDetails.findIndex((x) => x.serviceType === "fiveyearly");
      prevState.tenyearlyIndex =
        EquipmentObject &&
        EquipmentObject.serviceDetails && EquipmentObject.serviceDetails.findIndex((x) => x.serviceType === "tenyearly");
      EquipmentObject.serviceDetails &&
        EquipmentObject.serviceDetails.map((f, index) => {
          let servicename = f.serviceType.replace(/ +/g, "");
          prevState["lastDoneCountry" + servicename] = f.lastDoneCountry;
          prevState["lastDoneServiceProvider" + servicename] =
            f.lastDoneServiceProvider;
          prevState["lastDoneDate" + servicename] = f.lastDoneDate;
          prevState["lastDonePort" + servicename] = f.lastDonePort;
          prevState["nextDueDate" + servicename] = f.nextDueDate;
          prevState["attachmentName" + servicename] = f.attachmentName;
          prevState["attachmentGuid" + servicename] = f.attachmentGuid;
          prevState["lastannualServiceCertificate" + servicename] =
            f.attachmentName;
        });

      // EquipmentObject.applicableServices.map((item, index) => {
      //   if (!prevState.applicableServiceEquipType[index]) {
      //     // Initialize with an object if it doesn't exist
      //     prevState.applicableServiceEquipType[index] = { applicableEquipType: null, serviceTypeid: 0, serviceType: "" };
      //   }
      //   prevState.applicableServiceEquipType[index].applicableEquipType = { lookUpId: item.equipmentContractTypeId ?? 0, lookUpName: item.equipmentContractTypeName ?? "" };
      //   prevState.applicableServiceEquipType[index].serviceTypeId = item.serviceTypeId ?? 0;
      //   prevState.applicableServiceEquipType[index].serviceType = item.serviceType ?? "";

      // })
      //dispatch({ type: "getServiceTypeListSuccess", data: null });
      // if (EquipmentObject?.equipmentName) {
      //   if (EquipmentObject.equipmentName.toLowerCase().includes("lifeboat")) {
      //     dispatch(
      //       getEquipmentServiceTypeListWithInterval(
      //         EquipmentObject.equipmentId ? EquipmentObject.equipmentId : 0,
      //         EquipmentObject.shipId,
      //         EquipmentObject.lifeboatMakId ? EquipmentObject.lifeboatMakeId : 0,
      //         EquipmentObject.lifeboatModelId ? EquipmentObject.lifeboatModelId : 0,
      //         EquipmentObject.davitwinchMakeId ? EquipmentObject.davitwinchMakeId : 0,
      //       ));

      //   } else if (EquipmentObject?.equipmentName.toLowerCase().includes("rescue boat")) {
      //     dispatch(
      //       getEquipmentServiceTypeListWithInterval(
      //         EquipmentObject.equipmentId ? EquipmentObject.equipmentId : 0,
      //         EquipmentObject.shipId,
      //         EquipmentObject.rescueboatMakeId ? EquipmentObject.rescueboatMakeId : 0,
      //         EquipmentObject.rescueboatModelId ? EquipmentObject.rescueboatModelId : 0,
      //         EquipmentObject.rescueboatdavitwinchMakeId ? EquipmentObject.rescueboatdavitwinchMakeId : 0,
      //       ));
      //   } else {
      //     dispatch(
      //       getApplicableServiceTypeListWithInterval(
      //         EquipmentObject.equipmentId ? EquipmentObject.equipmentId : 0,
      //         EquipmentObject.shipId,
      //         EquipmentObject.makeId ? EquipmentObject.makeId : 0,
      //         EquipmentObject.modelId ? EquipmentObject.modelId : 0
      //       ));
      //   }
      //   dispatch({ type: "getEquipmentDetails", data: prevState.servicetype });
      // }

    }
    if (valueCheck == false && prevState?.equipemntConfigTypeList?.length > 0) {
      valueCheck = true;
      const equipContractObj = prevState.equipemntConfigTypeList?.filter(r => r.lookUpId == prevState.equipmentinfo?.equipmentContractTypeId)[0];
      prevState.selectedEquipmentTypes = equipContractObj ? equipContractObj : [];
    }
    if (ServiceDate) {
      applicableServiceType &&
        applicableServiceType.map((servicename, index) => {
          let servicenames = servicename.serviceType.replace(/ +/g, "");
          if (servicenames === ServiceDate.serviceType) {
            prevState["lastDoneDate" + servicenames] = Moment(
              new Date(Date.parse(ServiceDate.serviceDate))).format("YYYY-MM-DD");
            prevState["nextDueDate" + servicenames] = Moment(
              new Date(Date.parse(ServiceDate.nextDueDate))).format("YYYY-MM-DD");
          }
          dispatch({ type: "getServiceDateSuccess", data: null });
        });
    }
    // if (applicableServiceType) {
    //     applicableServiceType && applicableServiceType.map(r => {
    //         if (r.serviceType === "annually") {
    //             prevState.annual = true;
    //         }
    //         if (r.serviceType === "biannually") {
    //             prevState.biannual = true;
    //         }
    //         if (r.serviceType === "fiveyearly") {
    //             prevState.fiveyearly = true;
    //         }
    //         if (r.serviceType === "tenyearly") {
    //             prevState.tenyearly = true;
    //         }
    //     })
    // dispatch({ type: "getServiceTypeListSuccess", data: null });
    // }

    if (serviceAttachment && serviceAttachment !== "") {
      let servicename = serviceAttachment[0].Id.replace(/ +/g, "");
      prevState["attachmentServicePhoto" + servicename] = serviceAttachment;
      dispatch({
        type: "serviceAttachmentUploadSuccess",
        data: "",
      });
    }
    if (annualAttachment && annualAttachment !== "") {
      let servicename = annualAttachment.Id.replace(/ +/g, "");
      prevState["attachmentName" + servicename] = annualAttachment.FileName;
      prevState["attachmentGuid" + servicename] = annualAttachment.Guid;
      dispatch({ type: "annualAttachmentUploadSuccess", data: "" });
    }
    if (biannualAttachment) {
      prevState.Biannual.attachmentName = biannualAttachment.FileName;
      prevState.Biannual.attachmentGuid = biannualAttachment.Guid;
    }
    if (fiveyearlyAttachment) {
      prevState.Fiveyearly.attachmentName = fiveyearlyAttachment.FileName;
      prevState.Fiveyearly.attachmentGuid = fiveyearlyAttachment.Guid;
    }
    if (tenyearlyAttachment) {
      prevState.Tenyearly.attachmentName = tenyearlyAttachment.FileName;
      prevState.Tenyearly.attachmentGuid = tenyearlyAttachment.Guid;
    }
    if (EquipmentArray && EquipmentArray.length) {
      prevState.equipmentArray = EquipmentArray;
    }
    if (prevState.file1 !== "") {
      dispatch(postAnnualCertificate(prevState.file1));
      prevState.file1 = "";
    }
    if (prevState.file2 !== "") {
      dispatch(postBiannualCertificate(prevState.file2));
      prevState.file2 = "";
    }
    if (prevState.file3 !== "") {
      dispatch(postFiveYearlyCertificate(prevState.file3));
      prevState.file3 = "";
    }
    if (prevState.file4 !== "") {
      dispatch(postTenYearlyCertificate(prevState.file4));
      prevState.file4 = "";
    }
  }
  populateState = () => {
    // const updatedState = this.state.applicableServiceEquipType.map((service, index) => ({
    //   // [service.serviceType]: this.state.applicableServiceEquipType[index] && this.state.applicableServiceEquipType[index].applicalbleEuipType
    //   //   ? this.state.applicableServiceEquipType[index].applicalbleEuipType
    //   //   : { lookUpId: 0, lookUpName: "" }
    // if (!service) {
    //   return {
    //     serviceTypeId: 0,
    //     serviceType: "",
    //     equipmentContractTypeId: 0,
    //     eqipmentContractTypeName: ""
    //   };
    // }
    //   return {
    //     serviceTypeId: service?.serviceTypeId ?? 0,
    //     serviceType: service?.serviceType ?? "",
    //     equipmentContractTypeId: service.applicalbleEquipType.lookUpId ?? 0,
    //     eqipmentContractTypeName: service.applicalbleEquipType.lookUpName ?? ""
    //   };
    // }));
    const updatedState = this.state.applicableServiceEquipType.map((service, index) => {
      // Ensure service is not null or undefined; provide default values if it is
      if (!service) {
        return {
          serviceTypeId: 0,
          serviceType: "",
          equipmentContractTypeId: 0,
          equipmentContractTypeName: ""
        };
      }

      const applicableEquipType = service.applicableEquipType || {};
      return {
        serviceTypeId: service.serviceTypeId ?? 0,
        serviceType: service.serviceType ?? "",
        equipmentContractTypeId: applicableEquipType.lookUpId ?? 0,
        equipmentContractTypeName: applicableEquipType.lookUpName ?? ""
      };
    });
    this.state.equipmentinfo.applicableServices = updatedState;
  };

  checkArrayConditions(array1, array2) {
    // Check if the lengths of the arrays are the same
    if (array1.length !== array2.length) {
      return false;
    }

    // Check if all objects in `array1` satisfy the conditions
    const allValid = array1.every(obj =>
      obj.applicableEquipType && // Ensure the property exists
      obj.applicableEquipType.lookUpId !== 0 &&
      obj.applicableEquipType.lookUpName !== ''
    );

    return allValid;
  }
  // validateAndSetMessage(array1, array2) {
  //   let hasError = false;
  //   array1.forEach((item1, index) => {
  //     
  //     const item2 = array2[index];
  //     if (item1 || item2) {
  //       const condition1 = item1 && item1.equipmentContractTypeId !== 0;
  //       const condition2 = item2 && item2.lastDoneDate && item2.nextDueDate;

  //       if (condition1 || condition2) {
  //         if (!item2.lastDoneDate) {
  //           $(`#lastDoneDateError${index}`).text("Last Done Date is required.");
  //           hasError = true;
  //         } else {
  //           $(`#lastDoneDateError${index}`).text("");
  //         }

  //         if (!item2.nextDueDate) {
  //           $(`#nextDueDateError${index}`).text("Next Due Date is required.");
  //           hasError = true;
  //         } else {
  //           $(`#nextDueDateError${index}`).text("");
  //         }

  //         if (!item2.lastDoneCountry) {
  //           $(`#lastDoneCountryError${index}`).text("Last Done Country is required.");
  //           hasError = true;
  //         } else {
  //           $(`#lastDoneCountryError${index}`).text("");
  //         }

  //         if (!item2.lastDonePort) {
  //           $(`#lastDonePortError${index}`).text("Last Done Port is required.");
  //           hasError = true;
  //         } else {
  //           $(`#lastDonePortError${index}`).text("");
  //         }

  //         if (!item2.lastDoneServiceProvider) {
  //           $(`#lastDoneServiceProviderError${index}`).text("Last Done Service Provider is required.");
  //           hasError = true;
  //         } else {
  //           $(`#lastDoneServiceProviderError${index}`).text("");
  //         }

  //         // Check for equipmentContractTypeId condition on item1
  //         if (item1 && item1.equipmentContractTypeId === 0) {
  //           $(`#equipmentContractTypeError${index}`).text("Equipment Contract Type ID is required.");
  //           hasError = true;
  //         } else {
  //           $(`#equipmentContractTypeError${index}`).text("");
  //         }
  //       }
  //     }
  //   });

  //   return hasError; // Return true if any validation failed, false otherwise
  // }
  validateAndSetMessage(array1, array2) {
    const {t}=this.props;
    let hasError = false;
    if (!this.props.applicableServiceType) {
      return hasError;
    }

    this.props.applicableServiceType.forEach((i, index) => {
      // const item1 = array1[index];
      // const item2 = array2[index];
      const item1 = array1.find((x) => x?.serviceType === i.serviceType);
      const item2 = array2.find((x) => x?.serviceType === i.serviceType);

      // Check if either item1 or item2 is missing
      if (item1 || item2) {
        // If either item1 or item2 is missing, update error messages for both items
        if (!item1) {
          $(`#equipmentContractTypeError${index}`).text(t('EquipPage.EquipmentTypeIsRequired'));
          hasError = true;
        } else {
          if (item1.equipmentContractTypeId === 0) {
            $(`#equipmentContractTypeError${index}`).text(t('EquipPage.EquipmentTypeIsRequired'));
            hasError = true;
          } else {
            $(`#equipmentContractTypeError${index}`).text("");
          }
        }

        if (!item2) {
          $(`#lastDoneDateError${index}`).text(t('EquipPage.LastDoneDateIsRequired'));
          $(`#nextDueDateError${index}`).text(t('EquipPage.NextDueDateIsRequired'));
          $(`#lastDoneCountryError${index}`).text(t('EquipPage.LastDoneCountryIsRequired'));
          $(`#lastDonePortError${index}`).text(t('EquipPage.LastDonePortIsRequired'));
          $(`#lastDoneServiceProviderError${index}`).text(t('EquipPage.LastDoneServiceProviderIsRequired'));
          hasError = true;
        } else {
          // Validate fields for item2 if condition2 is met
          if (!item2.lastDoneDate) {
            $(`#lastDoneDateError${index}`).text(t('EquipPage.LastDoneDateIsRequired'));
            hasError = true;
          } else {
            $(`#lastDoneDateError${index}`).text("");
          }

          if (!item2.nextDueDate) {
            $(`#nextDueDateError${index}`).text(t('EquipPage.NextDueDateIsRequired'));
            hasError = true;
          } else {
            $(`#nextDueDateError${index}`).text("");
          }

          if (!item2.lastDoneCountry) {
            $(`#lastDoneCountryError${index}`).text(t('EquipPage.LastDoneCountryIsRequired'));
            hasError = true;
          } else {
            $(`#lastDoneCountryError${index}`).text("");
          }

          if (!item2.lastDonePort) {
            $(`#lastDonePortError${index}`).text(t('EquipPage.LastDonePortIsRequired'));
            hasError = true;
          } else {
            $(`#lastDonePortError${index}`).text("");
          }

          if (!item2.lastDoneServiceProvider) {
            $(`#lastDoneServiceProviderError${index}`).text(t('EquipPage.LastDoneServiceProviderIsRequired'));
            hasError = true;
          } else {
            $(`#lastDoneServiceProviderError${index}`).text("");
          }

          // Validate fields for item1 if condition1 is met

        }
      }
      else {
        $(`#lastDoneDateError${index}`).text(t('EquipPage.LastDoneDateIsRequired'));
        $(`#nextDueDateError${index}`).text(t('EquipPage.NextDueDateIsRequired'));
        $(`#lastDoneCountryError${index}`).text(t('EquipPage.LastDoneCountryIsRequired'));
        $(`#lastDonePortError${index}`).text(t('EquipPage.LastDonePortIsRequired'));
        $(`#lastDoneServiceProviderError${index}`).text(t('EquipPage.LastDoneServiceProviderIsRequired'));
        $(`#equipmentContractTypeError${index}`).text(t('EquipPage.EquipmentTypeIsRequired'));
        hasError = true;
      }
    });

    return hasError; // Return true if any validation failed, false otherwise
  }


  AddEquipment() {
    // const { Annual, Biannual, Fiveyearly, Tenyearly } = this.state;
    this.populateState();
    // var applicablecheck = !this.checkArrayConditions(this.state.applicableServiceEquipType, this.props.applicableServiceType);

    const { applicableServiceType, t } = this.props;
    let serviceflag = false;
    if (this.state.equipmentinfo.equipmentName.toLowerCase().includes("lifeboat")) {
      if (this.state.equipmentinfo.davitwinchMake !== "" || this.state.equipmentinfo.lifeboatMake !== "" || this.state.equipmentinfo.lifeboatModel !== "") {
        if (this.state.equipmentinfo.davitwinchMake !== "") {
          let resultArray = this.props.MakeList?.length === 0 ? this.state.MakeModelList : this.props.MakeList;
          if (resultArray.filter(item => item.name === this.state.equipmentinfo.davitwinchMake).length === 0) {
            $("#LifeDavitValidationErrMsg").text(t('CommonText.Pleaseselectvalidmake'))
            this.state.lifeDavitMakeValidation = true;
            this.setState({})
          } else {
            $("#LifeDavitValidationErrMsg").text("")
            this.state.lifeDavitMakeValidation = false;
            this.setState({})
          }
        }
        if (this.state.equipmentinfo.lifeboatMake !== "") {
          let resultArray = this.props.MakeList?.length === 0 ? this.state.MakeModelList : this.props.MakeList;
          if (resultArray.filter(item => item.name === this.state.equipmentinfo.lifeboatMake).length === 0) {
            $("#LifeMakeValidationErrMsg").text(t('CommonText.Pleaseselectvalidmake'))
            this.state.lifeMakeValidation = true;
            this.setState({})
          } else {
            $("#LifeMakeValidationErrMsg").text("")
            this.state.lifeMakeValidation = false;
            this.setState({})
          }
        }
        if (this.state.equipmentinfo.lifeboatModel !== "") {
          let resultArray = this.props.ModelList?.length === 0 ?
            this.state.MakeModelList : this.props.ModelList;
          if (resultArray.filter(item => item.name === this.state.equipmentinfo.lifeboatModel).length === 0) {
            $("#LifeModelValidationErrMsg").text(t('CommonText.Pleaseselectvalidmodel'))
            this.state.lifeModelValidation = true;
            this.setState({})
          } else {
            $("#LifeModelValidationErrMsg").text("")
            this.state.lifeModelValidation = false;
            this.setState({})
          }
        }
      }
    } else if (this.state.equipmentinfo.equipmentName.toLowerCase().includes("rescue boat")) {
      if (this.state.equipmentinfo.rescueboatdavitwinchMake !== "" || this.state.equipmentinfo.rescueboatMake !== "" || this.state.equipmentinfo.rescueboatModel !== "") {
        if (this.state.equipmentinfo.rescueboatdavitwinchMake !== "") {
          let resultArray = this.props.MakeList?.length === 0 ? this.state.MakeModelList : this.props.MakeList;
          if (resultArray.filter(item => item.name === this.state.equipmentinfo.rescueboatdavitwinchMake).length === 0) {
            $("#rescueDavitValidationErrMsg").text(t('CommonText.Pleaseselectvalidmake'))
            this.state.rescueDavitMakeValidation = true;
            this.setState({})
          } else {
            $("#rescueDavitValidationErrMsg").text("")
            this.state.rescueDavitMakeValidation = false;
            this.setState({})
          }
        }
        if (this.state.equipmentinfo.rescueboatMake !== "") {
          let resultArray = this.props.MakeList?.length === 0 ? this.state.MakeModelList : this.props.MakeList;
          if (resultArray.filter(item => item.name === this.state.equipmentinfo.rescueboatMake).length === 0) {
            $("#rescueMakeValidationErrMsg").text(t('CommonText.Pleaseselectvalidmake'))
            this.state.rescueMakeValidation = true;
            this.setState({})
          } else {
            $("#rescueMakeValidationErrMsg").text("")
            this.state.rescueMakeValidation = false;
            this.setState({})
          }
        }
        if (this.state.equipmentinfo.rescueboatModel !== "") {
          let resultArray = this.props.ModelList?.length === 0 ? this.state.MakeModelList : this.props.ModelList;
          if (resultArray.filter(item => item.name === this.state.equipmentinfo.rescueboatModel).length === 0) {
            $("#rescueModelValidationErrMsg").text(t('CommonText.Pleaseselectvalidmodel'))
            this.state.rescueModelValidation = true;
            this.setState({})
          } else {
            $("#rescueModelValidationErrMsg").text("")
            this.state.rescueModelValidation = false;
            this.setState({})
          }
        }
      }
    } else {
      if (this.state.equipmentinfo.make !== "" || this.state.equipmentinfo.model !== "") {
        if (this.state.equipmentinfo.make !== "") {
          let resultArray = this.props.MakeList?.length === 0 ? this.state.MakeModelList : this.props.MakeList;
          if (resultArray.filter(item => item.name === this.state.equipmentinfo.make).length === 0) {
            $("#MakeValidationErrMsg").text(t('CommonText.Pleaseselectvalidmake'))
            this.state.makeValidation = true;
            this.setState({})
          } else {
            $("#MakeValidationErrMsg").text("")
            this.state.makeValidation = false;
            this.setState({})
          }
        }
        if (this.state.equipmentinfo.model !== "") {
          let resultArray = this.props.ModelList?.length === 0 ? this.state.MakeModelList : this.props.ModelList;
          if (resultArray.filter(item => item.name === this.state.equipmentinfo.model).length === 0) {
            $("#ModelValidationErrMsg").text(t('CommonText.Pleaseselectvalidmodel'))
            this.state.modelValidation = true;
            this.setState({})
          } else {
            $("#ModelValidationErrMsg").text("")
            this.state.modelValidation = false;
            this.setState({})
          }
        }
      }
    }
    if (
      this.state.equipmentinfo.equipmentName.toLowerCase().includes("lifeboat")
    ) {
      if (
        this.state.equipmentinfo.equipmentName === "" ||
        this.state.equipmentinfo.lifeboatMake === "" ||
        this.state.equipmentinfo.lifeboatModel === "" ||
        this.state.equipmentinfo.davitwinchMake === "" ||
        this.state.equipmentinfo.lifeboatRelease === "" ||
        this.state.equipmentinfo.equipmentType === "" ||
        this.state.equipmentinfo.capacity === "" ||
        this.state.equipmentinfo.category === "" ||
        this.state.equipmentinfo.dateOfBuild === "" ||
        this.state.equipmentinfo.quantity === "" ||
        isNumberValid(this.state.equipmentinfo.quantity) === false ||
        this.state.equipmentinfo.unit === "" ||
        this.state.lifeDavitMakeValidation === true ||
        this.state.lifeMakeValidation === true ||
        this.state.lifeModelValidation === true 
        /*  this.state.equipmentinfo.make === "" ||
         this.state.equipmentinfo.model === " " */
      ) {
        this.state.equipmentinfo.equipmentName === ""
          ? $("#EquipmentErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#EquipmentErrMsg").text("");
        this.state.equipmentinfo.lifeboatMake === ""
          ? $("#lifeboatmakeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#LifeMakeValidationErrMsg").text("")
          : $("#lifeboatmakeErrMsg").text("");
        this.state.equipmentinfo.lifeboatModel === ""
          ? $("#lifeboatmodelErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#LifeModelValidationErrMsg").text("")
          : $("#lifeboatmodelErrMsg").text("");
        this.state.equipmentinfo.davitwinchMake === ""
          ? $("#davitwinchmakeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#LifeDavitValidationErrMsg").text("")
          : $("#davitwinchmakeErrMsg").text("");
        this.state.equipmentinfo.lifeboatRelease === ""
          ? $("#lifeboatreleaseErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#lifeboatreleaseErrMsg").text("");
        this.state.equipmentinfo.equipmentType === ""
          ? $("#equipmenttypeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#equipmenttypeErrMsg").text("");
        this.state.equipmentinfo.capacity === ""
          ? $("#capacityErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#capacityErrMsg").text("");
        this.state.equipmentinfo.category === ""
          ? $("#categoryErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#categoryErrMsg").text("");
        this.state.equipmentinfo.dateOfBuild === ""
          ? $("#ManufactureDateErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#ManufactureDateErrMsg").text("");
        if (this.state.equipmentinfo.quantity === "") {
          $("#EquipquantityErrMsg").text("");
          $("#EquipquantityErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
        } else if (isNumberValid(this.state.equipmentinfo.quantity)) {
          $("#EquipquantityErrMsg").text("")
        } else {
          $("#EquipquantityErrMsg").text("");
          $("#EquipquantityErrMsg").text(`${t("ErrorMessage.NumberMsg")}`)
        }
        // this.state.equipmentinfo.quantity === ""
        //   ?
        //   ($("#EquipquantityErrMsg").text(""),
        //     $("#EquipquantityErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`))
        //   : isNumberValid(this.state.equipmentinfo.quantity) ? $("#EquipquantityErrMsg").text("") :
        //     ($("#EquipquantityErrMsg").text(""),
        //       $("#EquipquantityErrMsg").text(`${t("ErrorMessage.NumberMsg")}`))
        this.state.equipmentinfo.unit === ""
          ? $("#EquipunitErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#EquipunitErrMsg").text("");
        this.state.isContractApplicableNo === false && this.state.isContractApplicableYes === false ?
          $("#contractErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#contractErrMsg").text("");
        /*   this.state.equipmentinfo.make === ""
            ? $("#MakeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
            : $("#MakeErrMsg").text("");
          this.state.equipmentinfo.model === ""
            ? $("#ModelErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
            : $("#ModelErrMsg").text(""); */
        return;
      } else {
        $("#LifeModelValidationErrMsg").text("");
        $("#LifeMakeValidationErrMsg").text("");
        $("#LifeDavitValidationErrMsg").text("");
        $("#EquipmentErrMsg").text("");
        $("#lifeboatmakeErrMsg").text("");
        $("#lifeboatmodelErrMsg").text("");
        $("#davitwinchmakeErrMsg").text("");
        $("#lifeboatreleaseErrMsg").text("");
        $("#categoryErrMsg").text("");
        $("#equipmenttypeErrMsg").text("");
        $("#capacityErrMsg").text("");
        $("#ManufactureDateErrMsg").text("");
        $("#contractErrMsg").text("");
        /* $("#MakeErrMsg").text("");
        $("#ModelErrMsg").text(""); */
        $("#EquipquantityErrMsg").text("");
        $("#EquipunitErrMsg").text("");
        $("#EquipmentTypeErrMsg").text('');
      }
      if (applicableServiceType && applicableServiceType.length > 0) {
        for (var i = 0; i < applicableServiceType.length; i++) {
          this.state.Annual = {};
          var servicetype = applicableServiceType[i].serviceType.replace(
            / +/g,
            ""
          );
          if (
            this.state["lastDoneDate" + servicetype] ||
            this.state["nextDueDate" + servicetype]
          ) {
            this.state.Annual["lastDoneDate"] =
              this.state["lastDoneDate" + servicetype];
            this.state.Annual["lastDonePort"] =
              this.state["lastDonePort" + servicetype];
            this.state.Annual["portId"] =
              this.state["lastDonePortid" + servicetype];

            this.state.Annual["lastDoneServiceProvider"] =
              this.state["lastDoneServiceProvider" + servicetype];
            this.state.Annual["lastDoneCountry"] =
              this.state["lastDoneCountry" + servicetype];
            this.state.Annual["serviceProviderId"] =
              this.state["ServiceProviderId" + servicetype] &&
                this.state["ServiceProviderId" + servicetype].length !== 0
                ? this.state["ServiceProviderId" + servicetype][0]
                  .serviceProviderId
                : 0;

            this.state.Annual["nextDueDate"] =
              this.state["nextDueDate" + servicetype];
            this.state.Annual["serviceType"] =
              applicableServiceType[i].serviceType;
            this.state.Annual["attachmentName"] =
              this.state["attachmentName" + servicetype];
            this.state.Annual["attachmentGuid"] =
              this.state["attachmentGuid" + servicetype];
            this.state.Annual["serviceImages"] = this.state[
              "attachmentServicePhoto" + servicetype
            ]
              ? this.state["attachmentServicePhoto" + servicetype].map((i) => {
                i.equipmentServiceId =
                  this.state["equipmentServiceId" + servicetype];
                i.attachmentName = i.FileName;
                i.attachmentGuid = i.Guid;
                i.createdBy = currentuser.name;
                return i;
              })
              : [];
            this.state.equipmentinfo.serviceDetails.push(this.state.Annual);
          }
          // else {
          //   serviceflag = true;
          //   this.state.equipmentinfo.serviceDetails = [];
          // }
        }
      }

      // if (!serviceflag && this.state.equipmentinfo.serviceDetails.length > 0) {
      // this.state.equipmentArray=[];
      let bool = this.validateAndSetMessage(this.state.equipmentinfo.applicableServices, this.state.equipmentinfo.serviceDetails);
      if (!bool) {
        if (this.state.equipmentinfo?.quantity?.toString()?.charAt(0) != undefined && this.state.equipmentinfo?.toString()?.quantity?.charAt(0) === '0') {
          let value = this.state.equipmentinfo.quantity.replace(/\b0+/g, '');;
          this.state.equipmentinfo.quantity = parseInt(value);
          if (this.state.isContractApplicableNo === true) {
            this.state.equipmentinfo.isContractApplicable = false;
          } else if (this.state.isContractApplicableYes == true) {
            this.state.equipmentinfo.isContractApplicable = true;
          }
          this.setState({})
          this.setState({
            ...this.state,
            equipmentinfo: {
              ...this.state.equipmentinfo,
              quantity: parseInt(this.state.equipmentinfo.quantity)
            }
          })
          this.state.equipmentArray.push(this.state.equipmentinfo);
          this.props.dispatch({
            type: "getEquipmentArray",
            data: this.state.equipmentArray,
          });
          valueCheck = false;
        } else {
          if (this.state.isContractApplicableNo === true) {
            this.state.equipmentinfo.isContractApplicable = false;
          } else if (this.state.isContractApplicableYes == true) {
            this.state.equipmentinfo.isContractApplicable = true;
          }
          this.setState({})
          this.setState({
            ...this.state,
            equipmentinfo: {
              ...this.state.equipmentinfo,
              quantity: parseInt(this.state.equipmentinfo.quantity)
            }
          })
          this.state.equipmentArray.push(this.state.equipmentinfo);
          this.props.dispatch({
            type: "getEquipmentArray",
            data: this.state.equipmentArray,
          });
          valueCheck = false;


        }
        this.setState({
          dropDown: {
            EquipmentName: "",
            EquipmentType: "",
            Category: "",
            Capacity: "",
            makeId: 0,
            davitwinchMakeId: 0,
          },
        });
        console.log("equip", this.state.equipmentArray);
        this.hideSidePanel();
      }
      else {
        this.setState(prevState => ({
          equipmentinfo: {
            ...prevState.equipmentinfo, // spread the previous state to keep other properties intact
            serviceDetails: [] // update serviceDetails with an empty array
          }
        }));
      }
    } else if (this.state.equipmentinfo.equipmentName.toLowerCase().includes("rescue boat")) {
      {
        if (
          this.state.equipmentinfo.equipmentName === "" ||
          this.state.equipmentinfo.rescueboatMake === "" ||
          this.state.equipmentinfo.rescueboatModel === "" ||
          this.state.equipmentinfo.rescueboatdavitwinchMake === "" ||
          this.state.equipmentinfo.rescueboatRelease === "" ||
          this.state.equipmentinfo.equipmentType === "" ||
          this.state.equipmentinfo.capacity === "" ||
          this.state.equipmentinfo.category === "" ||
          this.state.equipmentinfo.dateOfBuild === "" ||
          this.state.equipmentinfo.quantity === "" ||
          isNumberValid(this.state.equipmentinfo.quantity) === false ||
          this.state.equipmentinfo.unit === "" ||
          this.state.rescueDavitMakeValidation === true ||
          this.state.rescueMakeValidation === true ||
          this.state.rescueModelValidation === true 
          /* ||
          this.state.equipmentinfo.make === "" ||
          this.state.equipmentinfo.model === " " */
        ) {
          this.state.equipmentinfo.equipmentName === ""
            ? $("#EquipmentErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
            : $("#EquipmentErrMsg").text("");
          this.state.equipmentinfo.rescueboatMake === ""
            ? $("#rescueboatmakeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#rescueMakeValidationErrMsg").text("")
            : $("#rescueboatmakeErrMsg").text("");
          this.state.equipmentinfo.rescueboatModel === ""
            ? $("#rescueboatmodelErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#rescueModelValidationErrMsg").text("")
            : $("#rescueboatmodelErrMsg").text("");
          this.state.equipmentinfo.rescueboatdavitwinchMake === ""
            ? $("#rescueboatdavitwinchmakeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#rescueDavitValidationErrMsg").text("")
            : $("#rescueboatdavitwinchmakeErrMsg").text("");
          this.state.equipmentinfo.rescueboatRelease === ""
            ? $("#rescueboatreleaseErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
            : $("#rescueboatreleaseErrMsg").text("");
          this.state.equipmentinfo.equipmentType === ""
            ? $("#equipmenttypeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
            : $("#equipmenttypeErrMsg").text("");
          this.state.equipmentinfo.capacity === ""
            ? $("#capacityErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
            : $("#capacityErrMsg").text("");
          this.state.equipmentinfo.category === ""
            ? $("#categoryErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
            : $("#categoryErrMsg").text("");
          this.state.equipmentinfo.dateOfBuild === ""
            ? $("#ManufactureDateErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
            : $("#ManufactureDateErrMsg").text("");
          if (this.state.equipmentinfo.quantity === "") {
            $("#EquipquantityErrMsg").text("");
            $("#EquipquantityErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          } else if (isNumberValid(this.state.equipmentinfo.quantity)) {
            $("#EquipquantityErrMsg").text("")
          } else {
            $("#EquipquantityErrMsg").text("");
            $("#EquipquantityErrMsg").text(`${t("ErrorMessage.NumberMsg")}`)
          }
          this.state.equipmentinfo.unit === ""
            ? $("#EquipunitErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
            : $("#EquipunitErrMsg").text("");
          this.state.isContractApplicableNo === false && this.state.isContractApplicableYes === false ?
            $("#contractErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
            : $("#contractErrMsg").text("");
          /* this.state.equipmentinfo.make === ""
            ? $("#MakeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
            : $("#MakeErrMsg").text("");
          this.state.equipmentinfo.model === ""
            ? $("#ModelErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
            : $("#ModelErrMsg").text(""); */
          return;
        } else {
          $("#rescueModelValidationErrMsg").text("");
          $("#rescueMakeValidationErrMsg").text("");
          $("#rescueDavitValidationErrMsg").text("");
          $("#EquipmentErrMsg").text("");
          $("#rescueboatmakeErrMsg").text("");
          $("#rescueboatmodelErrMsg").text("");
          $("#rescueboatdavitwinchmakeErrMsg").text("");
          $("#rescueboatreleaseErrMsg").text("");
          $("#categoryErrMsg").text("");
          $("#equipmenttypeErrMsg").text("");
          $("#capacityErrMsg").text("");
          $("#ManufactureDateErrMsg").text("");
          $("#EquipunitErrMsg").text("");
          $("#contractErrMsg").text("");
          /* $("#MakeErrMsg").text("");
          $("#ModelErrMsg").text(""); */
          $("#EquipquantityErrMsg").text("");
          $("#EquipmentTypeErrMsg").text('');
        }
        if (applicableServiceType && applicableServiceType.length > 0) {
          for (var i = 0; i < applicableServiceType.length; i++) {
            this.state.Annual = {};
            var servicetype = applicableServiceType[i].serviceType.replace(
              / +/g,
              ""
            );
            if (
              this.state["lastDoneDate" + servicetype] ||
              this.state["nextDueDate" + servicetype]
            ) {
              this.state.Annual["lastDoneDate"] =
                this.state["lastDoneDate" + servicetype];
              this.state.Annual["lastDonePort"] =
                this.state["lastDonePort" + servicetype];
              this.state.Annual["portId"] =
                this.state["lastDonePortid" + servicetype];

              this.state.Annual["lastDoneServiceProvider"] =
                this.state["lastDoneServiceProvider" + servicetype];
              this.state.Annual["lastDoneCountry"] =
                this.state["lastDoneCountry" + servicetype];
              this.state.Annual["serviceProviderId"] =
                this.state["ServiceProviderId" + servicetype] &&
                  this.state["ServiceProviderId" + servicetype].length !== 0
                  ? this.state["ServiceProviderId" + servicetype][0]
                    .serviceProviderId
                  : 0;

              this.state.Annual["nextDueDate"] =
                this.state["nextDueDate" + servicetype];
              this.state.Annual["serviceType"] =
                applicableServiceType[i].serviceType;
              this.state.Annual["attachmentName"] =
                this.state["attachmentName" + servicetype];
              this.state.Annual["attachmentGuid"] =
                this.state["attachmentGuid" + servicetype];
              this.state.Annual["serviceImages"] = this.state[
                "attachmentServicePhoto" + servicetype
              ]
                ? this.state["attachmentServicePhoto" + servicetype].map((i) => {
                  i.equipmentServiceId =
                    this.state["equipmentServiceId" + servicetype];
                  i.attachmentName = i.FileName;
                  i.attachmentGuid = i.Guid;
                  i.createdBy = currentuser.name;
                  return i;
                })
                : [];
              this.state.equipmentinfo.serviceDetails.push(this.state.Annual);
            }
          }
        }

        // if (!serviceflag && this.state.equipmentinfo.serviceDetails.length > 0) {
        // this.state.equipmentArray=[];
        let bool = this.validateAndSetMessage(this.state.equipmentinfo.applicableServices, this.state.equipmentinfo.serviceDetails);
        if (!bool) {
          if (this.state.equipmentinfo?.quantity?.toString()?.charAt(0) != undefined && this.state.equipmentinfo?.toString()?.quantity?.charAt(0) === '0') {
            let value = this.state.equipmentinfo.quantity.replace(/\b0+/g, '');
            this.state.equipmentinfo.quantity = parseInt(value);
            if (this.state.isContractApplicableNo === true) {
              this.state.equipmentinfo.isContractApplicable = false;
            } else if (this.state.isContractApplicableYes == true) {
              this.state.equipmentinfo.isContractApplicable = true;
            }
            this.setState({})
            this.setState({
              ...this.state,
              equipmentinfo: {
                ...this.state.equipmentinfo,
                quantity: parseInt(this.state.equipmentinfo.quantity)
              }
            })
            this.state.equipmentArray.push(this.state.equipmentinfo);
            this.props.dispatch({
              type: "getEquipmentArray",
              data: this.state.equipmentArray,
            });
            valueCheck = false;


          } else {
            if (this.state.isContractApplicableNo === true) {
              this.state.equipmentinfo.isContractApplicable = false;
            } else if (this.state.isContractApplicableYes == true) {
              this.state.equipmentinfo.isContractApplicable = true;
            }
            this.setState({})
            this.setState({
              ...this.state,
              equipmentinfo: {
                ...this.state.equipmentinfo,
                quantity: parseInt(this.state.equipmentinfo.quantity)
              }
            })
            this.state.equipmentArray.push(this.state.equipmentinfo);
            this.props.dispatch({
              type: "getEquipmentArray",
              data: this.state.equipmentArray,
            });
            valueCheck = false;

          }
          this.setState({
            dropDown: {
              EquipmentName: "",
              EquipmentType: "",
              Category: "",
              Capacity: "",
              makeId: 0,
              davitwinchMakeId: 0,
            },
          });
          console.log("equip", this.state.equipmentArray);
          this.hideSidePanel();
        }
        else {
          this.setState(prevState => ({
            equipmentinfo: {
              ...prevState.equipmentinfo, // spread the previous state to keep other properties intact
              serviceDetails: [] // update serviceDetails with an empty array
            }
          }));
        }
      }

    }
    else {
      if (
        this.state.equipmentinfo.equipmentName === "" ||
        this.state.equipmentinfo.equipmentType === "" ||
        this.state.equipmentinfo.capacity === "" ||
        this.state.equipmentinfo.category === "" ||
        this.state.equipmentinfo.dateOfBuild === "" ||
        this.state.equipmentinfo.quantity === "" ||
        isNumberValid(this.state.equipmentinfo.quantity) === false ||
        this.state.equipmentinfo.make === "" ||
        this.state.equipmentinfo.model === " " ||
        this.state.equipmentinfo.unit === "" ||
        this.state.modelValidation === true ||
        this.state.makeValidation === true 
      ) {
        this.state.equipmentinfo.equipmentName === ""
          ? $("#EquipmentErrMsg").text(t("ErrorMessage.RequiredMsg"))
          : $("#EquipmentErrMsg").text("");
        this.state.equipmentinfo.equipmentType === ""
          ? $("#equipmenttypeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#equipmenttypeErrMsg").text("");
        this.state.equipmentinfo.capacity === ""
          ? $("#capacityErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#capacityErrMsg").text("");
        this.state.equipmentinfo.category === ""
          ? $("#categoryErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#categoryErrMsg").text("");
        this.state.equipmentinfo.dateOfBuild === ""
          ? $("#ManufactureDateErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#ManufactureDateErrMsg").text("");
        if (this.state.equipmentinfo.quantity === "") {
          $("#EquipquantityErrMsg").text("");
          $("#EquipquantityErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
        } else if (isNumberValid(this.state.equipmentinfo.quantity)) {
          $("#EquipquantityErrMsg").text("")
        } else {
          $("#EquipquantityErrMsg").text("");
          $("#EquipquantityErrMsg").text(`${t("ErrorMessage.NumberMsg")}`)
        }
        this.state.equipmentinfo.make === ""
          ? $("#MakeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#MakeValidationErrMsg").text("")
          : $("#MakeErrMsg").text("");
        this.state.equipmentinfo.model === ""
          ? $("#ModelErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#ModelValidationErrMsg").text("")
          : $("#ModelErrMsg").text("");
        this.state.equipmentinfo.unit === ""
          ? $("#EquipunitErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#EquipunitErrMsg").text("");
        this.state.isContractApplicableNo === false && this.state.isContractApplicableYes === false ?
          $("#contractErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#contractErrMsg").text("");
        return;
      } else {
        $("#ModelValidationErrMsg").text("")
        $("#MakeValidationErrMsg").text("")
        $("#EquipmentErrMsg").text("");
        $("#categoryErrMsg").text("");
        $("#equipmenttypeErrMsg").text("");
        $("#capacityErrMsg").text("");
        $("#contractErrMsg").text("");
        $("#ManufactureDateErrMsg").text("");
        $("#MakeErrMsg").text("");
        $("#ModelErrMsg").text("");
        $("#EquipquantityErrMsg").text("");
        $("#EquipunitErrMsg").text("");
        $("#EquipmentTypeErrMsg").text('');
      }
      if (applicableServiceType && applicableServiceType.length > 0) {
        for (var i = 0; i < applicableServiceType.length; i++) {
          this.state.Annual = {};
          var servicetype = applicableServiceType[i].serviceType.replace(
            / +/g,
            ""
          );
          if (
            this.state["lastDoneDate" + servicetype] ||
            this.state["nextDueDate" + servicetype]
          ) {
            this.state.Annual["lastDoneDate"] =
              this.state["lastDoneDate" + servicetype];
            this.state.Annual["lastDonePort"] =
              this.state["lastDonePort" + servicetype];
            this.state.Annual["portId"] =
              this.state["lastDonePortid" + servicetype];
            this.state.Annual["lastDoneServiceProvider"] =
              this.state["lastDoneServiceProvider" + servicetype];
            this.state.Annual["lastDoneCountry"] =
              this.state["lastDoneCountry" + servicetype];
            this.state.Annual["serviceProviderId"] =
              this.state["ServiceProviderId" + servicetype] &&
                this.state["ServiceProviderId" + servicetype].length !== 0 ? this.state["ServiceProviderId" + servicetype][0].serviceProviderId : 0;
            this.state.Annual["nextDueDate"] =
              this.state["nextDueDate" + servicetype];
            this.state.Annual["serviceType"] =
              applicableServiceType[i].serviceType;
            this.state.Annual["attachmentName"] =
              this.state["attachmentName" + servicetype];
            this.state.Annual["attachmentGuid"] =
              this.state["attachmentGuid" + servicetype];
            this.state.Annual["serviceImages"] = this.state["attachmentServicePhoto" + servicetype]
              ? this.state["attachmentServicePhoto" + servicetype].map((i) => {
                i.equipmentServiceId =
                  this.state["equipmentServiceId" + servicetype];
                i.attachmentName = i.FileName;
                i.attachmentGuid = i.Guid;
                i.createdBy = currentuser.name;
                return i;
              })
              : [];
            this.state.equipmentinfo.serviceDetails.push(this.state.Annual);
          }
          // else {
          //   serviceflag = true;
          //   this.state.equipmentinfo.serviceDetails = [];
          // }
        }
      }
      // if (!serviceflag && this.state.equipmentinfo.serviceDetails.length > 0) {
      // this.state.equipmentArray=[];
      //console.log(this.state.equipmentinfo.quantity.charAt(0))
      let bool = this.validateAndSetMessage(this.state.equipmentinfo.applicableServices, this.state.equipmentinfo.serviceDetails);
      if (!bool) {
        if (this.state.equipmentinfo?.quantity?.toString()?.charAt(0) != undefined && this.state.equipmentinfo?.toString()?.quantity?.charAt(0) === '0') {
          if (this.state.isContractApplicableNo === true) {
            this.state.equipmentinfo.isContractApplicable = false;
          } else if (this.state.isContractApplicableYes == true) {
            this.state.equipmentinfo.isContractApplicable = true;
          }
          let value = this.state.equipmentinfo.quantity.replace(/\b0+/g, '');
          this.state.equipmentinfo.quantity = parseInt(value);
          this.setState({}, () => {
            //console.log("beforezero",this.state.equipmentinfo)
          })
          this.state.equipmentArray.push(this.state.equipmentinfo);
          this.props.dispatch({
            type: "getEquipmentArray",
            data: this.state.equipmentArray,
          });
          valueCheck = false;
        } else {
          if (this.state.isContractApplicableNo === true) {
            this.state.equipmentinfo.isContractApplicable = false;
          } else if (this.state.isContractApplicableYes == true) {
            this.state.equipmentinfo.isContractApplicable = true;
          }
          this.state.equipmentinfo.quantity = parseInt(this.state.equipmentinfo.quantity);
          this.setState({})
          this.state.equipmentArray.push(this.state.equipmentinfo);
          this.props.dispatch({
            type: "getEquipmentArray",
            data: this.state.equipmentArray,
          });
          valueCheck = false;
        }
        this.setState({
          dropDown: {
            EquipmentName: "",
            EquipmentType: "",
            Category: "",
            Capacity: "",
            makeId: 0,
            davitwinchMakeId: 0
          },
        });
        console.log("equip", this.state.equipmentArray);
        this.hideSidePanel();
      }
      else {
        this.setState(prevState => ({
          equipmentinfo: {
            ...prevState.equipmentinfo, // spread the previous state to keep other properties intact
            serviceDetails: [] // update serviceDetails with an empty array
          }
        }));
      }
    }
    // } else {
    //   swal("Error!", "Service details is mandatory.", "warning");
    // }

    // if (this.state.annual) {
    //     if (Annual.lastDoneDate !== '' && Annual.nextDueDate !== ''
    //         && Annual.attachmentName !== '' && Annual.attachmentGuid !== '' && Annual.lastDonePort !== '') {
    //         this.state.equipmentinfo.serviceDetails.push(Annual);
    //     } else {
    //         serviceflag = true;
    //         this.state.equipmentinfo.serviceDetails = [];
    //     }
    // }
    // if (this.state.biannual) {
    //     if (Biannual.lastDoneDate !== '' && Biannual.nextDueDate !== ''
    //         && Biannual.attachmentName !== '' && Biannual.attachmentGuid !== '' && Biannual.lastDonePort !== '') {
    //         this.state.equipmentinfo.serviceDetails.push(Biannual);
    //     } else {
    //         serviceflag = true;
    //         this.state.equipmentinfo.serviceDetails = [];
    //     }
    // }
    // if (this.state.fiveyearly) {
    //     if (Fiveyearly.lastDoneDate !== '' && Fiveyearly.nextDueDate !== ''
    //         && Fiveyearly.attachmentName !== '' && Fiveyearly.attachmentGuid !== '' && Fiveyearly.lastDonePort !== '') {
    //         this.state.equipmentinfo.serviceDetails.push(Fiveyearly);
    //     } else {
    //         serviceflag = true;
    //         this.state.equipmentinfo.serviceDetails = [];
    //     }
    // }
    // if (this.state.tenyearly) {
    //     if (Tenyearly.lastDoneDate !== '' && Tenyearly.nextDueDate !== ''
    //         && Tenyearly.attachmentName !== '' && Tenyearly.attachmentGuid !== '' && Tenyearly.lastDonePort !== '') {
    //         this.state.equipmentinfo.serviceDetails.push(Tenyearly);
    //     } else {
    //         serviceflag = true;
    //         this.state.equipmentinfo.serviceDetails = [];
    //     }
    // }
    // this.setState({});
    // if (!serviceflag && this.state.equipmentinfo.serviceDetails.length > 0) {
    //     this.state.equipmentArray.push(this.state.equipmentinfo);
    //     this.props.dispatch({ type: "getEquipmentArray", data: this.state.equipmentArray });
    //     console.log("equip", this.state.equipmentArray);
    //     this.hideSidePanel();
    // } else {
    //     swal('Error!', 'Service details is mandatory.', 'warning');
    // }
    console.log(this.state.equipmentArray, 'check')
  }

  onEquipTypeChange = (e, values, serviceIndex, serviceName) => {

    let updated = [...this.state.applicableServiceEquipType]
    updated[serviceIndex] = {
      ...updated[serviceIndex],
      applicableEquipType: values || { lookUpId: 0, lookUpName: '' },
      serviceTypeId: serviceName.serviceTypeId,
      serviceType: serviceName.serviceType
    };
    this.setState({
      applicableServiceEquipType: updated
    },
      () => { console.log(this.state.applicableServiceEquipType, 'check') }
    );

  }

  UpdateEquipment() {
    this.populateState();
    let serviceflag = false;
    const { index } = this.state;
    const { applicableServiceType, t } = this.props;
    if (this.state.equipmentinfo.equipmentName.toLowerCase().includes("lifeboat")) {
      if (this.state.equipmentinfo.davitwinchMake !== "" || this.state.equipmentinfo.lifeboatMake !== "" || this.state.equipmentinfo.lifeboatModel !== "") {
        if (this.state.equipmentinfo.davitwinchMake !== "") {
          let resultArray = this.props.MakeList?.length === 0 ? this.state.MakeModelList : this.props.MakeList;
          if (resultArray.filter(item => item.name === this.state.equipmentinfo.davitwinchMake).length === 0) {
            $("#LifeDavitValidationErrMsg").text(t('CommonText.Pleaseselectvalidmake'))
            this.state.lifeDavitMakeValidation = true;
            this.setState({})
          } else {
            $("#LifeDavitValidationErrMsg").text("")
            this.state.lifeDavitMakeValidation = false;
            this.setState({})
          }
        }
        if (this.state.equipmentinfo.lifeboatMake !== "") {
          let resultArray = this.props.MakeList?.length === 0 ? this.state.MakeModelList : this.props.MakeList;
          if (resultArray.filter(item => item.name === this.state.equipmentinfo.lifeboatMake).length === 0) {
            $("#LifeMakeValidationErrMsg").text(t('CommonText.Pleaseselectvalidmake'))
            this.state.lifeMakeValidation = true;
            this.setState({})
          } else {
            $("#LifeMakeValidationErrMsg").text("")
            this.state.lifeMakeValidation = false;
            this.setState({})
          }
        }
        if (this.state.equipmentinfo.lifeboatModel !== "") {
          let resultArray = this.props.ModelList?.length === 0 ? this.state.MakeModelList : this.props.ModelList;
          if (resultArray.filter(item => item.name === this.state.equipmentinfo.lifeboatModel).length === 0) {
            $("#LifeModelValidationErrMsg").text(t('CommonText.Pleaseselectvalidmodel'))
            this.state.lifeModelValidation = true;
            this.setState({})
          } else {
            $("#LifeModelValidationErrMsg").text("")
            this.state.lifeModelValidation = false;
            this.setState({})
          }
        }
      }
    } else if (this.state.equipmentinfo.equipmentName.toLowerCase().includes("rescue boat")) {
      if (this.state.equipmentinfo.rescueboatdavitwinchMake !== "" || this.state.equipmentinfo.rescueboatMake !== "" || this.state.equipmentinfo.rescueboatModel !== "") {
        if (this.state.equipmentinfo.rescueboatdavitwinchMake !== "") {
          let resultArray = this.props.MakeList?.length === 0 ? this.state.MakeModelList : this.props.MakeList;
          if (resultArray.filter(item => item.name === this.state.equipmentinfo.rescueboatdavitwinchMake).length === 0) {
            $("#rescueDavitValidationErrMsg").text(t('CommonText.Pleaseselectvalidmake'))
            this.state.rescueDavitMakeValidation = true;
            this.setState({})
          } else {
            $("#rescueDavitValidationErrMsg").text("")
            this.state.rescueDavitMakeValidation = false;
            this.setState({})
          }
        }
        if (this.state.equipmentinfo.rescueboatMake !== "") {
          let resultArray = this.props.MakeList?.length === 0 ? this.state.MakeModelList : this.props.MakeList;
          if (resultArray.filter(item => item.name === this.state.equipmentinfo.rescueboatMake).length === 0) {
            $("#rescueMakeValidationErrMsg").text(t('CommonText.Pleaseselectvalidmake'))
            this.state.rescueMakeValidation = true;
            this.setState({})
          } else {
            $("#rescueMakeValidationErrMsg").text("")
            this.state.rescueMakeValidation = false;
            this.setState({})
          }
        }
        if (this.state.equipmentinfo.rescueboatModel !== "") {
          let resultArray = this.props.ModelList?.length === 0 ? this.state.MakeModelList : this.props.ModelList;
          if (resultArray.filter(item => item.name === this.state.equipmentinfo.rescueboatModel).length === 0) {
            $("#rescueModelValidationErrMsg").text(t('CommonText.Pleaseselectvalidmodel'))
            this.state.rescueModelValidation = true;
            this.setState({})
          } else {
            $("#rescueModelValidationErrMsg").text("")
            this.state.rescueModelValidation = false;
            this.setState({})
          }
        }
      }
    } else {
      if (this.state.equipmentinfo.make !== "" || this.state.equipmentinfo.model !== "") {
        if (this.state.equipmentinfo.make !== "") {
          let resultArray = this.props.MakeList?.length === 0 ? this.state.MakeModelList : this.props.MakeList;
          if (resultArray.filter(item => item.name === this.state.equipmentinfo.make).length === 0) {
            $("#MakeValidationErrMsg").text(t('CommonText.Pleaseselectvalidmake'))
            this.state.makeValidation = true;
            this.setState({})
          } else {
            $("#MakeValidationErrMsg").text("")
            this.state.makeValidation = false;
            this.setState({})
          }
        }
        if (this.state.equipmentinfo.model !== "") {
          let resultArray = this.props.ModelList?.length === 0 ? this.state.MakeModelList : this.props.ModelList;
          if (resultArray.filter(item => item.name === this.state.equipmentinfo.model).length === 0) {
            $("#ModelValidationErrMsg").text(t('CommonText.Pleaseselectvalidmodel'))
            this.state.modelValidation = true;
            this.setState({})
          } else {
            $("#ModelValidationErrMsg").text("")
            this.state.modelValidation = false;
            this.setState({})
          }
        }
      }

    }
    if (
      this.state.equipmentinfo.equipmentName.toLowerCase().includes("lifeboat")
    ) {
      if (
        this.state.equipmentinfo.equipmentName === "" ||
        this.state.equipmentinfo.lifeboatMake === "" ||
        this.state.equipmentinfo.lifeboatModel === "" ||
        this.state.equipmentinfo.davitwinchMake === "" ||
        this.state.equipmentinfo.lifeboatRelease === "" ||
        this.state.equipmentinfo.equipmentType === "" ||
        this.state.equipmentinfo.capacity === "" ||
        this.state.equipmentinfo.category === "" ||
        this.state.equipmentinfo.dateOfBuild === "" ||
        this.state.equipmentinfo.quantity === "" ||
        isNumberValid(this.state.equipmentinfo.quantity) === false ||
        this.state.equipmentinfo.unit === "" ||
        this.state.lifeDavitMakeValidation === true ||
        this.state.lifeMakeValidation === true ||
        this.state.lifeModelValidation === true 
        /*   this.state.equipmentinfo.make === "" ||
          this.state.equipmentinfo.model === " " */
      ) {
        this.state.equipmentinfo.equipmentName === ""
          ? $("#EquipmentErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#EquipmentErrMsg").text("");
        this.state.equipmentinfo.lifeboatMake === ""
          ? $("#lifeboatmakeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#LifeMakeValidationErrMsg").text("")
          : $("#lifeboatmakeErrMsg").text("");
        this.state.equipmentinfo.lifeboatModel === ""
          ? $("#lifeboatmodelErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#LifeModelValidationErrMsg").text("")
          : $("#lifeboatmodelErrMsg").text("");
        this.state.equipmentinfo.davitwinchMake === ""
          ? $("#davitwinchmakeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#LifeDavitValidationErrMsg").text("")
          : $("#davitwinchmakeErrMsg").text("");
        this.state.equipmentinfo.lifeboatRelease === ""
          ? $("#lifeboatreleaseErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#lifeboatreleaseErrMsg").text("");
        this.state.equipmentinfo.equipmentType === ""
          ? $("#equipmenttypeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#equipmenttypeErrMsg").text("");
        this.state.equipmentinfo.capacity === ""
          ? $("#capacityErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#capacityErrMsg").text("");
        this.state.equipmentinfo.category === ""
          ? $("#categoryErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#categoryErrMsg").text("");
        this.state.equipmentinfo.dateOfBuild === ""
          ? $("#ManufactureDateErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#ManufactureDateErrMsg").text("");
        if (this.state.equipmentinfo.quantity === "") {
          $("#EquipquantityErrMsg").text("");
          $("#EquipquantityErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
        } else if (isNumberValid(this.state.equipmentinfo.quantity)) {
          $("#EquipquantityErrMsg").text("")
        } else {
          $("#EquipquantityErrMsg").text("");
          $("#EquipquantityErrMsg").text(`${t("ErrorMessage.NumberMsg")}`)
        }
        this.state.equipmentinfo.unit === ""
          ? $("#EquipunitErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#EquipunitErrMsg").text("");
        this.state.isContractApplicableNo === false && this.state.isContractApplicableYes === false ?
          $("#contractErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#contractErrMsg").text("");
        /*   this.state.equipmentinfo.make === ""
            ? $("#MakeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
            : $("#MakeErrMsg").text("");
          this.state.equipmentinfo.model === ""
            ? $("#ModelErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
            : $("#ModelErrMsg").text(""); */
        return;
      } else {
        $("#LifeModelValidationErrMsg").text("");
        $("#LifeMakeValidationErrMsg").text("");
        $("#LifeDavitValidationErrMsg").text("");
        $("#EquipmentErrMsg").text("");
        $("#lifeboatmakeErrMsg").text("");
        $("#lifeboatmodelErrMsg").text("");
        $("#davitwinchmakeErrMsg").text("");
        $("#lifeboatreleaseErrMsg").text("");
        $("#categoryErrMsg").text("");
        $("#equipmenttypeErrMsg").text("");
        $("#capacityErrMsg").text("");
        $("#ManufactureDateErrMsg").text("");
        $("#EquipunitErrMsg").text("");
        $("#contractErrMsg").text("");
        /*  $("#MakeErrMsg").text("");
         $("#ModelErrMsg").text(""); */
        $("#EquipquantityErrMsg").text("");
        $("#EquipmentTypeErrMsg").text('');
      }
      if (applicableServiceType && applicableServiceType.length > 0) {
        this.state.equipmentinfo.serviceDetails = [];
        for (var i = 0; i < applicableServiceType.length; i++) {
          this.state.Annual = {};
          var servicetype = applicableServiceType[i].serviceType.replace(
            / +/g,
            ""
          );
          if (
            this.state["lastDoneDate" + servicetype] ||
            this.state["nextDueDate" + servicetype] ||
            this.state["lastDonePort" + servicetype] ||
            this.state["lastDoneCountry" + servicetype] ||
            this.state["lastDoneServiceProvider" + servicetype]
          ) {
            this.state.Annual["lastDoneDate"] =
              this.state["lastDoneDate" + servicetype];
            this.state.Annual["lastDonePort"] =
              this.state["lastDonePort" + servicetype];
            this.state.Annual["portId"] =
              this.state["lastDonePortid" + servicetype];
            this.state.Annual["lastDoneServiceProvider"] =
              this.state["lastDoneServiceProvider" + servicetype];
            this.state.Annual["lastDoneCountry"] =
              this.state["lastDoneCountry" + servicetype];
            this.state.Annual["serviceProviderId"] =
              this.state["lastDoneServiceProvider" + servicetype] &&
                this.state["ServiceProviderId" + servicetype] &&
                this.state["ServiceProviderId" + servicetype].length !== 0
                ? this.state["ServiceProviderId" + servicetype][0]
                  .serviceProviderId
                : 0;
            this.state.Annual["nextDueDate"] =
              this.state["nextDueDate" + servicetype];
            this.state.Annual["serviceType"] =
              applicableServiceType[i].serviceType;
            this.state.Annual["attachmentName"] =
              this.state["attachmentName" + servicetype];
            this.state.Annual["attachmentGuid"] =
              this.state["attachmentGuid" + servicetype];
            this.state.equipmentinfo.serviceDetails.push(this.state.Annual);
          } else {
            serviceflag = true;
            this.state.equipmentinfo.serviceDetails = [];
          }
        }
      }
      // if (!serviceflag && this.state.equipmentinfo.serviceDetails.length > 0) {
      let bool = this.validateAndSetMessage(this.state.equipmentinfo.applicableServices, this.state.equipmentinfo.serviceDetails);
      if (!bool) {
        if (this.state.equipmentinfo?.quantity?.toString()?.charAt(0) != undefined && this.state.equipmentinfo?.toString()?.quantity?.charAt(0) === '0') {
          let value = this.state.equipmentinfo.quantity.replace(/\b0+/g, '');
          this.state.equipmentinfo.quantity = parseInt(value);
          if (this.state.isContractApplicableNo === true) {
            this.state.equipmentinfo.isContractApplicable = false;
          } else if (this.state.isContractApplicableYes == true) {
            this.state.equipmentinfo.isContractApplicable = true;
          }
          this.setState({})
          this.setState({
            ...this.state,
            equipmentinfo: {
              ...this.state.equipmentinfo,
              quantity: parseInt(this.state.equipmentinfo.quantity)
            }
          }, () => {
            this.state.equipmentArray[index] = this.state.equipmentinfo;
            this.props.dispatch({
              type: "getEquipmentArray",
              data: this.state.equipmentArray,
            });
            valueCheck = false;
            this.hideSidePanel();
          })
        } else {
          if (this.state.isContractApplicableNo === true) {
            this.state.equipmentinfo.isContractApplicable = false;
          } else if (this.state.isContractApplicableYes == true) {
            this.state.equipmentinfo.isContractApplicable = true;
          }
          this.setState({})
          this.setState({
            ...this.state,
            equipmentinfo: {
              ...this.state.equipmentinfo,
              quantity: parseInt(this.state.equipmentinfo.quantity)
            }
          }, () => {
            this.state.equipmentArray[index] = this.state.equipmentinfo;
            this.props.dispatch({
              type: "getEquipmentArray",
              data: this.state.equipmentArray,
            });
            valueCheck = false;
            this.hideSidePanel();
          })
        }
        console.log("equip", this.state.equipmentArray);
        // this.hideSidePanel();
        // } else {
        //   swal("Error!", "Service details is mandatory.", "warning");
        // }
        this.setState({});

        // this.setState({
        //   dropDown: {
        //     EquipmentName: "",
        //     EquipmentType: "",
        //     Category: "",
        //     Capacity: "",
        //     makeId: 0,
        //     davitwinchMakeId: 0
        //   },
        // });
        console.log("equip", this.state.equipmentArray);
      }
      else {
        this.setState(prevState => ({
          equipmentinfo: {
            ...prevState.equipmentinfo, // spread the previous state to keep other properties intact
            serviceDetails: [] // update serviceDetails with an empty array
          }
        }));
      }
      // this.hideSidePanel();
    }
    else if (
      this.state.equipmentinfo.equipmentName.toLowerCase().includes("rescue boat")
    ) {
      if (
        this.state.equipmentinfo.equipmentName === "" ||
        this.state.equipmentinfo.rescueboatMake === "" ||
        this.state.equipmentinfo.rescueboatModel === "" ||
        this.state.equipmentinfo.rescueboatdavitwinchMake === "" ||
        this.state.equipmentinfo.rescueboatRelease === "" ||
        this.state.equipmentinfo.equipmentType === "" ||
        this.state.equipmentinfo.capacity === "" ||
        this.state.equipmentinfo.category === "" ||
        this.state.equipmentinfo.dateOfBuild === "" ||
        this.state.equipmentinfo.quantity === "" ||
        isNumberValid(this.state.equipmentinfo.quantity) === false ||
        this.state.equipmentinfo.unit === "" ||
        this.state.rescueDavitMakeValidation === true ||
        this.state.rescueMakeValidation === true ||
        this.state.rescueModelValidation === true 
        /*  ||
        this.state.equipmentinfo.make === "" ||
        this.state.equipmentinfo.model === " " */
      ) {
        this.state.equipmentinfo.equipmentName === ""
          ? $("#EquipmentErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#EquipmentErrMsg").text("");
        this.state.equipmentinfo.rescueboatMake === ""
          ? $("#rescueboatmakeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#rescueMakeValidationErrMsg").text("")
          : $("#rescueboatmakeErrMsg").text("");
        this.state.equipmentinfo.rescueboatModel === ""
          ? $("#rescueboatmodelErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#rescueModelValidationErrMsg").text("")
          : $("#rescueboatmodelErrMsg").text("");
        this.state.equipmentinfo.rescueboatdavitwinchMake === ""
          ? $("#rescueboatdavitwinchmakeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#rescueDavitValidationErrMsg").text("")
          : $("#rescueboatdavitwinchmakeErrMsg").text("");
        this.state.equipmentinfo.rescueboatRelease === ""
          ? $("#rescueboatreleaseErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#rescueboatreleaseErrMsg").text("");
        this.state.equipmentinfo.equipmentType === ""
          ? $("#equipmenttypeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#equipmenttypeErrMsg").text("");
        this.state.equipmentinfo.capacity === ""
          ? $("#capacityErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#capacityErrMsg").text("");
        this.state.equipmentinfo.category === ""
          ? $("#categoryErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#categoryErrMsg").text("");
        this.state.equipmentinfo.dateOfBuild === ""
          ? $("#ManufactureDateErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#ManufactureDateErrMsg").text("");
        if (this.state.equipmentinfo.quantity === "") {
          $("#EquipquantityErrMsg").text("");
          $("#EquipquantityErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
        } else if (isNumberValid(this.state.equipmentinfo.quantity)) {
          $("#EquipquantityErrMsg").text("")
        } else {
          $("#EquipquantityErrMsg").text("");
          $("#EquipquantityErrMsg").text(`${t("ErrorMessage.NumberMsg")}`)
        }
        this.state.equipmentinfo.unit === ""
          ? $("#EquipunitErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#EquipunitErrMsg").text("");
        this.state.isContractApplicableNo === false && this.state.isContractApplicableYes === false ?
          $("#contractErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#contractErrMsg").text("");
        /*  this.state.equipmentinfo.make === ""
           ? $("#MakeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
           : $("#MakeErrMsg").text("");
         this.state.equipmentinfo.model === ""
           ? $("#ModelErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
           : $("#ModelErrMsg").text(""); */
        return;
      } else {
        $("#rescueModelValidationErrMsg").text("");
        $("#rescueMakeValidationErrMsg").text("");
        $("#rescueDavitValidationErrMsg").text("");
        $("#EquipmentErrMsg").text("");
        $("#rescueboatmakeErrMsg").text("");
        $("#rescueboatmodelErrMsg").text("");
        $("#rescueboatdavitwinchmakeErrMsg").text("");
        $("#rescueboatreleaseErrMsg").text("");
        $("#categoryErrMsg").text("");
        $("#equipmenttypeErrMsg").text("");
        $("#capacityErrMsg").text("");
        $("#ManufactureDateErrMsg").text("");
        $("#EquipunitErrMsg").text("");
        $("#contractErrMsg").text("");
        /*         $("#MakeErrMsg").text("");
                $("#ModelErrMsg").text(""); */
        $("#EquipquantityErrMsg").text("");
        $("#EquipmentTypeErrMsg").text('');
      }
      if (applicableServiceType && applicableServiceType.length > 0) {
        this.state.equipmentinfo.serviceDetails = [];
        for (var i = 0; i < applicableServiceType.length; i++) {
          this.state.Annual = {};
          var servicetype = applicableServiceType[i].serviceType.replace(
            / +/g,
            ""
          );
          if (
            this.state["lastDoneDate" + servicetype] ||
            this.state["nextDueDate" + servicetype] ||
            this.state["lastDonePort" + servicetype] ||
            this.state["lastDoneCountry" + servicetype] ||
            this.state["lastDoneServiceProvider" + servicetype]
          ) {
            this.state.Annual["lastDoneDate"] =
              this.state["lastDoneDate" + servicetype];
            this.state.Annual["lastDonePort"] =
              this.state["lastDonePort" + servicetype];
            this.state.Annual["portId"] =
              this.state["lastDonePortid" + servicetype];
            this.state.Annual["lastDoneServiceProvider"] =
              this.state["lastDoneServiceProvider" + servicetype];
            this.state.Annual["lastDoneCountry"] =
              this.state["lastDoneCountry" + servicetype];
            this.state.Annual["serviceProviderId"] =
              this.state["lastDoneServiceProvider" + servicetype] &&
                this.state["ServiceProviderId" + servicetype] &&
                this.state["ServiceProviderId" + servicetype].length !== 0
                ? this.state["ServiceProviderId" + servicetype][0]
                  .serviceProviderId
                : 0;
            this.state.Annual["nextDueDate"] =
              this.state["nextDueDate" + servicetype];
            this.state.Annual["serviceType"] =
              applicableServiceType[i].serviceType;
            this.state.Annual["attachmentName"] =
              this.state["attachmentName" + servicetype];
            this.state.Annual["attachmentGuid"] =
              this.state["attachmentGuid" + servicetype];
            this.state.equipmentinfo.serviceDetails.push(this.state.Annual);
          } else {
            serviceflag = true;
            this.state.equipmentinfo.serviceDetails = [];
          }
        }
      }
      // if (!serviceflag && this.state.equipmentinfo.serviceDetails.length > 0) {
      let bool = this.validateAndSetMessage(this.state.equipmentinfo.applicableServices, this.state.equipmentinfo.serviceDetails);
      if (!bool) {
        if (this.state.equipmentinfo?.quantity?.toString()?.charAt(0) != undefined && this.state.equipmentinfo?.toString()?.quantity?.charAt(0) === '0') {
          let value = this.state.equipmentinfo.quantity.replace(/\b0+/g, '');
          this.state.equipmentinfo.quantity = parseInt(value);
          if (this.state.isContractApplicableNo === true) {
            this.state.equipmentinfo.isContractApplicable = false;
          } else if (this.state.isContractApplicableYes == true) {
            this.state.equipmentinfo.isContractApplicable = true;
          }
          this.setState({})
          this.setState({
            ...this.state,
            equipmentinfo: {
              ...this.state.equipmentinfo,
              quantity: parseInt(this.state.equipmentinfo.quantity)
            }
          }, () => {
            this.state.equipmentArray[index] = this.state.equipmentinfo;
            this.props.dispatch({
              type: "getEquipmentArray",
              data: this.state.equipmentArray,
            });
            valueCheck = false;
            this.hideSidePanel();
          })
        } else {
          if (this.state.isContractApplicableNo === true) {
            this.state.equipmentinfo.isContractApplicable = false;
          } else if (this.state.isContractApplicableYes == true) {
            this.state.equipmentinfo.isContractApplicable = true;
          }
          this.setState({})
          this.setState({
            ...this.state,
            equipmentinfo: {
              ...this.state.equipmentinfo,
              quantity: parseInt(this.state.equipmentinfo.quantity)
            }
          }, () => {
            this.state.equipmentArray[index] = this.state.equipmentinfo;
            this.props.dispatch({
              type: "getEquipmentArray",
              data: this.state.equipmentArray,
            });
            valueCheck = false;
            this.hideSidePanel();
          })
        }
        console.log("equip", this.state.equipmentArray);
        // this.hideSidePanel();
        // } else {
        //   swal("Error!", "Service details is mandatory.", "warning");
        // }
        this.setState({});

        // this.setState({
        //   dropDown: {
        //     EquipmentName: "",
        //     EquipmentType: "",
        //     Category: "",
        //     Capacity: "",
        //     makeId: 0,
        //     davitwinchMakeId: 0
        //   },
        // });
        console.log("equip", this.state.equipmentArray);
      }
      else {
        this.setState(prevState => ({
          equipmentinfo: {
            ...prevState.equipmentinfo, // spread the previous state to keep other properties intact
            serviceDetails: [] // update serviceDetails with an empty array
          }
        }));
      }
      // this.hideSidePanel();
    }
    else {
      if (
        this.state.equipmentinfo.equipmentName === "" ||
        this.state.equipmentinfo.equipmentType === "" ||
        this.state.equipmentinfo.capacity === "" ||
        this.state.equipmentinfo.category === "" ||
        this.state.equipmentinfo.dateOfBuild === "" ||
        this.state.equipmentinfo.quantity === "" ||
        isNumberValid(this.state.equipmentinfo.quantity) === false ||
        !this.state.equipmentinfo.quantity > 0 ||
        this.state.equipmentinfo.make === "" ||
        this.state.equipmentinfo.model === "" ||
        this.state.equipmentinfo.unit === "" ||
        this.state.modelValidation === true ||
        this.state.makeValidation === true 
      ) {
        this.state.equipmentinfo.equipmentName === ""
          ? $("#EquipmentErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#EquipmentErrMsg").text("");
        this.state.equipmentinfo.equipmentType === ""
          ? $("#equipmenttypeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#equipmenttypeErrMsg").text("");
        this.state.equipmentinfo.capacity === ""
          ? $("#capacityErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#capacityErrMsg").text("");
        this.state.equipmentinfo.category === ""
          ? $("#categoryErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#categoryErrMsg").text("");
        this.state.equipmentinfo.dateOfBuild === ""
          ? $("#ManufactureDateErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#ManufactureDateErrMsg").text("");
        if (this.state.equipmentinfo.quantity === "") {
          $("#EquipquantityErrMsg").text("");
          $("#EquipquantityErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
        } else if (isNumberValid(this.state.equipmentinfo.quantity)) {
          $("#EquipquantityErrMsg").text("")
        } else {
          $("#EquipquantityErrMsg").text("");
          $("#EquipquantityErrMsg").text(`${t("ErrorMessage.NumberMsg")}`)
        }
        this.state.equipmentinfo.make === ""
          ? $("#MakeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#MakeValidationErrMsg").text("")
          : $("#MakeErrMsg").text("");
        this.state.equipmentinfo.model === ""
          ? $("#ModelErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#ModelValidationErrMsg").text("")
          : $("#ModelErrMsg").text("");
        this.state.equipmentinfo.unit === ""
          ? $("#EquipunitErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#EquipunitErrMsg").text("");
        this.state.isContractApplicableNo === false && this.state.isContractApplicableYes === false ?
          $("#contractErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#contractErrMsg").text("");
        return;
      } else {
        $("#ModelValidationErrMsg").text("")
        $("#MakeValidationErrMsg").text("")
        $("#EquipmentErrMsg").text("");
        $("#categoryErrMsg").text("");
        $("#equipmenttypeErrMsg").text("");
        $("#capacityErrMsg").text("");
        $("#ManufactureDateErrMsg").text("");
        $("#MakeErrMsg").text("");
        $("#ModelErrMsg").text("");
        $("#EquipquantityErrMsg").text("");
        $("#EquipunitErrMsg").text("");
        $("#contractErrMsg").text("");
        $("#EquipmentTypeErrMsg").text('')
      }
      if (applicableServiceType && applicableServiceType.length > 0) {
        this.state.equipmentinfo.serviceDetails = [];
        for (var i = 0; i < applicableServiceType.length; i++) {
          this.state.Annual = {};
          var servicetype = applicableServiceType[i].serviceType.replace(
            / +/g,
            ""
          );
          if (
            this.state["lastDoneDate" + servicetype] ||
            this.state["nextDueDate" + servicetype] ||
            this.state["lastDonePort" + servicetype] ||
            this.state["lastDoneCountry" + servicetype] ||
            this.state["lastDoneServiceProvider" + servicetype]
          ) {
            this.state.Annual["lastDoneDate"] =
              this.state["lastDoneDate" + servicetype];
            this.state.Annual["lastDonePort"] =
              this.state["lastDonePort" + servicetype];
            this.state.Annual["portId"] =
              this.state["lastDonePortid" + servicetype];
            this.state.Annual["lastDoneServiceProvider"] =
              this.state["lastDoneServiceProvider" + servicetype];
            this.state.Annual["lastDoneCountry"] =
              this.state["lastDoneCountry" + servicetype];
            this.state.Annual["serviceProviderId"] =
              this.state["lastDoneServiceProvider" + servicetype] &&
                this.state["ServiceProviderId" + servicetype] &&
                this.state["ServiceProviderId" + servicetype].length !== 0
                ? this.state["ServiceProviderId" + servicetype][0]
                  .serviceProviderId
                : 0;
            this.state.Annual["nextDueDate"] =
              this.state["nextDueDate" + servicetype];
            this.state.Annual["serviceType"] =
              applicableServiceType[i].serviceType;
            this.state.Annual["attachmentName"] =
              this.state["attachmentName" + servicetype];
            this.state.Annual["attachmentGuid"] =
              this.state["attachmentGuid" + servicetype];
            this.state.equipmentinfo.serviceDetails.push(this.state.Annual);
          }
          // else {
          //   serviceflag = true;
          //   this.state.equipmentinfo.serviceDetails = [];
          // }
        }
      }
      // if (!serviceflag && this.state.equipmentinfo.serviceDetails.length > 0) {
      let bool = this.validateAndSetMessage(this.state.equipmentinfo.applicableServices, this.state.equipmentinfo.serviceDetails);
      if (!bool) {
        if (this.state.equipmentinfo?.quantity?.toString()?.charAt(0) != undefined && this.state.equipmentinfo?.toString()?.quantity?.charAt(0) === '0') {
          let value = this.state.equipmentinfo.quantity.replace(/\b0+/g, '');
          this.state.equipmentinfo.quantity = parseInt(value);
          if (this.state.isContractApplicableNo === true) {
            this.state.equipmentinfo.isContractApplicable = false;
          } else if (this.state.isContractApplicableYes == true) {
            this.state.equipmentinfo.isContractApplicable = true;
          }
          this.setState({})
          this.setState({
            ...this.state,
            equipmentinfo: {
              ...this.state.equipmentinfo,
              quantity: parseInt(this.state.equipmentinfo.quantity)
            }
          }, () => {
            this.state.equipmentArray[index] = this.state.equipmentinfo;
            this.props.dispatch({
              type: "getEquipmentArray",
              data: this.state.equipmentArray,
            });
            valueCheck = false;
            this.hideSidePanel();
          })
        } else {
          if (this.state.isContractApplicableNo === true) {
            this.state.equipmentinfo.isContractApplicable = false;
          } else if (this.state.isContractApplicableYes == true) {
            this.state.equipmentinfo.isContractApplicable = true;
          }
          this.setState({
            ...this.state,
            equipmentinfo: {
              ...this.state.equipmentinfo,
              quantity: parseInt(this.state.equipmentinfo.quantity)
            }
          }, () => {
            this.state.equipmentArray[index] = this.state.equipmentinfo;
            this.props.dispatch({
              type: "getEquipmentArray",
              data: this.state.equipmentArray,
            });
            valueCheck = false;
            this.hideSidePanel();
          })
        }
        console.log("equip", this.state.equipmentArray);
        // this.hideSidePanel();

        // } else {
        //   swal("Error!", "Service details is mandatory.", "warning");
        // }
        this.setState({});
        this.setState({
          dropDown: {
            EquipmentName: "",
            EquipmentType: "",
            Category: "",
            Capacity: "",
            makeId: 0,
            davitwinchMakeId: 0
          },
        });
      }
      else {
        this.setState(prevState => ({
          equipmentinfo: {
            ...prevState.equipmentinfo, // spread the previous state to keep other properties intact
            serviceDetails: [] // update serviceDetails with an empty array
          }
        }));
      }

      // const { equipmentinfo, annualIndex, biannualIndex, fiveyearlyIndex, tenyearlyIndex, index, Annual, Biannual, Fiveyearly, Tenyearly } = this.state;
      // if (this.state.annual) {
      //     if (Annual.lastDoneDate !== '' && Annual.nextDueDate !== ''
      //         && Annual.attachmentName !== '' && Annual.attachmentGuid !== '' && Annual.lastDonePort !== '') {
      //         //    this.state.equipmentinfo.serviceDetails.push(Annual);
      //         this.state.equipmentinfo.serviceDetails[annualIndex] = Annual;
      //     } else {
      //         serviceflag = true;
      //     }
      // }
      // if (this.state.biannual) {
      //     if (Biannual.lastDoneDate !== '' && Biannual.nextDueDate !== ''
      //         && Biannual.attachmentName !== '' && Biannual.attachmentGuid !== '' && Biannual.lastDonePort !== '') {
      //         // this.state.equipmentinfo.serviceDetails.push(Biannual);
      //         this.state.equipmentinfo.serviceDetails[biannualIndex] = Biannual;
      //     } else {
      //         serviceflag = true;
      //     }
      // }
      // if (this.state.fiveyearly) {
      //     if (Fiveyearly.lastDoneDate !== '' && Fiveyearly.nextDueDate !== ''
      //         && Fiveyearly.attachmentName !== '' && Fiveyearly.attachmentGuid !== '' && Fiveyearly.lastDonePort !== '') {
      //         // this.state.equipmentinfo.serviceDetails.push(Fiveyearly);
      //         this.state.equipmentinfo.serviceDetails[fiveyearlyIndex] = Fiveyearly;
      //     } else {
      //         serviceflag = true;
      //     }
      // }
      // if (this.state.tenyearly) {
      //     if (Tenyearly.lastDoneDate !== '' && Tenyearly.nextDueDate !== ''
      //         && Tenyearly.attachmentName !== '' && Tenyearly.attachmentGuid !== '' && Tenyearly.lastDonePort !== '') {
      //         // this.state.equipmentinfo.serviceDetails.push(Tenyearly);
      //         this.state.equipmentinfo.serviceDetails[tenyearlyIndex] = Tenyearly;
      //     } else {
      //         serviceflag = true;
      //     }
      // }
      // this.setState({});
      // if (!serviceflag && this.state.equipmentinfo.serviceDetails) {
      //     this.state.equipmentArray[index] = equipmentinfo;
      //     this.setState({});
      //     this.props.dispatch({ type: "getEquipmentArray", data: this.state.equipmentArray });
      //     this.hideSidePanel();
      // } else {
      //     swal('Error!', 'Service details is mandatory.', 'warning');
      // }
    }
  }

  // Equipment info

  isDuplicateShipEquipment(equipmentName, excludeIndex = -1) {
    const name = equipmentName?.trim().toLowerCase();
    if (!name) {
      return false;
    }
    const list = this.state.equipmentArray?.length
      ? this.state.equipmentArray
      : this.props.EquipmentArray || [];
    return list.some(
      (item, idx) =>
        idx !== excludeIndex &&
        item.equipmentName?.trim().toLowerCase() === name
    );
  }

  showDuplicateEquipmentWarning(t) {
    swal({
      title: t("SwalError.ErrorTitle"),
      text: t("SwalError.ShipEquipmentExist"),
      icon: "warning",
      buttons: {
        confirm: {
          text: t("confirmAlertMessage.Ok"),
        },
      },
    });
  }

  renderEquipmentTitle(state, val) {
    return (
      state?.equipmentName?.toLowerCase().indexOf(val?.toLowerCase()) !== -1
    );
  }

  handleInputChanges(e, field) {
    if (field === "isContractApplicableYes") {
      this.state.isContractApplicableYes = true;
      this.state.isContractApplicableNo = false;
      this.setState({})
    } else if (field === "isContractApplicableNo") {
      this.state.isContractApplicableYes = false;
      this.state.isContractApplicableNo = true;
      this.setState({})
    } else if (field === "equipmentName") {
      if (e.target.value?.trim() == "") {
        this.state.equipmentinfo.equipmentContractTypeId = 0;
        this.state.selectedEquipmentTypes = [];
      }
    }
    this.state.equipmentinfo[field] = e.target.value;
    this.setState({});
  }

  onEquipmentTypeChange = (event, id, values) => {
    console.log(values, "values")
    this.state.selectedEquipmentTypes = values ? values : [];
    this.state.equipmentinfo.equipmentContractTypeId = id ? id : 0;
    this.setState({});
    console.log(this.state, "this.state")
  };

  handleSelectChange(value, field, id, item) {
    const { dispatch, t, editEquipment } = this.props;
    if (field === "equipmentName") {
      const excludeIndex = editEquipment ? this.state.index : -1;
      if (this.isDuplicateShipEquipment(value, excludeIndex)) {
        this.showDuplicateEquipmentWarning(t);
        this.state.openEquipment = false;
        this.setState({});
        return;
      }
      this.state.dropDown.EquipmentName = value;
      this.state.dropDown.Category = "";
      this.state.dropDown.Capacity = "";
      this.state.dropDown.EquipmentType = "";
      this.state.dropDown.makeId = 0;
      this.state.dropDown.davitwinchMakeId = 0;
      this.state.equipmentinfo.make = "";
      this.state.equipmentinfo.equipmentId = id;
      this.state.equipmentinfo.model = "";
      this.state.equipmentinfo.makeId = 0;
      this.state.equipmentinfo.modelId = 0;
      this.state.equipmentinfo.serviceDetails = [];
      this.state.equipmentinfo.capacity = "";
      this.state.equipmentinfo.category = "";
      this.state.equipmentinfo.equipmentType = "";
      this.state.equipmentinfo.lifeboatMake = "";
      this.state.equipmentinfo.lifeboatMakeId = 0;
      this.state.equipmentinfo.lifeboatModel = "";
      this.state.equipmentinfo.lifeboatModelId = 0;
      this.state.equipmentinfo.davitwinchMake = "";
      this.state.equipmentinfo.davitwinchMakeId = 0;
      this.state.equipmentinfo.rescueboatMake = "";
      this.state.equipmentinfo.rescueboatMakeId = 0;
      this.state.equipmentinfo.rescueboatModel = "";
      this.state.equipmentinfo.rescueboatModelId = 0;
      this.state.equipmentinfo.rescueboatdavitwinchMake = "";
      this.state.equipmentinfo.rescueboatdavitwinchMakeId = 0;
      this.state.equipmentinfo.equipmentContractTypeId = item?.equipmentContractTypeId ? item?.equipmentContractTypeId : 0;
      const equipContractObj = this.state.equipemntConfigTypeList?.filter(r => r.lookUpId == item?.equipmentContractTypeId)[0];
      this.state.selectedEquipmentTypes = equipContractObj ? equipContractObj : [];
      // let url = `${API.ServiceTypeInterval}?equipmentId=${id}`;
      // axios
      //   .get(url)
      //   .then((response) => {
      //     dispatch({
      //       type: "getServiceTypeIntervalListSuccess",
      //       data: response.data,
      //     });
      //     if (response.data) {
      //       response.data.map((f, index) => {
      //         let interval = f.interval;
      //         let type = f.serviceType.replace(/ +/g, "");
      //         this.state.interval = f.interval;
      //         let port = {
      //           port: this.state["lastDonePort" + type],
      //           country: this.state["lastDoneCountry" + type],
      //           serviceProvider: this.state["lastDoneServiceProvider" + type],
      //           type: type,
      //         };
      //         dispatch(getShipPortAndCountry(port));
      //       });
      //     }
      //   })
      //   .catch((error) => {
      //     dispatch({
      //       type: "getServiceTypeIntervalListFailure",
      //       data: "error",
      //     });
      //   });
      dispatch(getEquipmentDropDownList(this.state.dropDown));
    }
    this.state.equipmentinfo[field] = value;
    this.setState({}, () => {
      if (this.state.equipmentinfo?.equipmentName?.toLowerCase().includes("lifeboat")
      ) {
        $("#ModelHide").addClass("none");
        $("#MakeHide").addClass("none");
        // $("#categoryequiptype").addClass("categorylifeboat");
        $("#LifeBoatEquipment").removeClass("lifeBoat-hide");
        $("#LifeBoatEquipment1").removeClass("lifeBoat-hide");
        $("#LifeBoatEquipment2").removeClass("lifeBoat-hide");
        $("#LifeBoatEquipment3").removeClass("lifeBoat-hide");
        $("#rescueboatEquipment").addClass("lifeBoat-hide");
        $("#rescueboatEquipment1").addClass("lifeBoat-hide");
        $("#rescueboatEquipment2").addClass("lifeBoat-hide");
        $("#rescueboatEquipment3").addClass("lifeBoat-hide");
      } else if (this.state.equipmentinfo.equipmentName.toLowerCase().includes("rescue boat")) {
        $("#ModelHide").addClass("none");
        $("#MakeHide").addClass("none");
        $("#LifeBoatEquipment").addClass("lifeBoat-hide");
        $("#LifeBoatEquipment1").addClass("lifeBoat-hide");
        $("#LifeBoatEquipment2").addClass("lifeBoat-hide");
        $("#LifeBoatEquipment3").addClass("lifeBoat-hide");
        $("#rescueboatEquipment").removeClass("lifeBoat-hide");
        $("#rescueboatEquipment1").removeClass("lifeBoat-hide");
        $("#rescueboatEquipment2").removeClass("lifeBoat-hide");
        $("#rescueboatEquipment3").removeClass("lifeBoat-hide");
      } else {
        $("#ModelHide").removeClass("none");
        $("#MakeHide").removeClass("none");
        $("#categoryequiptype").removeClass("categorylifeboat");
        $("#LifeBoatEquipment").addClass("lifeBoat-hide");
        $("#LifeBoatEquipment1").addClass("lifeBoat-hide");
        $("#LifeBoatEquipment2").addClass("lifeBoat-hide");
        $("#LifeBoatEquipment3").addClass("lifeBoat-hide");
        $("#rescueboatEquipment").addClass("lifeBoat-hide");
        $("#rescueboatEquipment1").addClass("lifeBoat-hide");
        $("#rescueboatEquipment2").addClass("lifeBoat-hide");
        $("#rescueboatEquipment3").addClass("lifeBoat-hide");
      }
    });
  }
  handleInputChange(e) {
    const { dispatch, EquipmentDropDownList } = this.props;
    let nodeName = e.target.name;
    if (nodeName === "equipmentName") {
      this.state.dropDown.EquipmentName = e.target.value;
      this.state.dropDown.Category = "";
      this.state.dropDown.Capacity = "";
      this.state.dropDown.EquipmentType = "";
      this.state.equipmentinfo.serviceDetails = [];
      this.state.equipmentinfo.capacity = "";
      this.state.equipmentinfo.category = "";
      this.state.equipmentinfo.equipmentType = "";
      this.state.equipmentinfo.equipmentId = 0;
      let url = `${API.ServiceTypeInterval}?equipmentId=${e.target.value}`;
      axios
        .get(url)
        .then((response) => {
          dispatch({
            type: "getServiceTypeIntervalListSuccess",
            data: response.data,
          });
          if (response.data) {
            response.data.map((f, index) => {
              let interval = f.interval;
              let type = f.serviceType.replace(/ +/g, "");
              this.state.interval = f.interval;
              let port = {
                port: this.state["lastDonePort" + type],
                country: this.state["lastDoneCountry" + type],
                serviceProvider: this.state["lastDoneServiceProvider" + type],
                type: type,
              };
              //dispatch(
              // getServiceDates(
              //  Moment(new Date()).format("YYYY-MM-DD"),
              //  interval,
              //  type
              // )
              // );
              dispatch(getShipPortAndCountry(port));
            });
          }
        })
        .catch((error) => {
          dispatch({
            type: "getServiceTypeIntervalListFailure",
            data: "error",
          });
        });
      dispatch(getEquipmentDropDownList(this.state.dropDown));
      // this.setState({ annual: false, biannual: false, fiveyearly: false, tenyearly: false });
      // dispatch(getApplicableServiceTypeListWithInterval(e.target.value));
      // dispatch(getEquipmentDropDownList(this.state.dropDown));
    }
    if (nodeName === "category") {
      this.state.dropDown.EquipmentName = this.state.dropDown.EquipmentName;
      this.state.dropDown.Category = e.target.value;
      this.state.dropDown.EquipmentType = "";
      this.state.equipmentinfo.serviceDetails = [];
      this.state.equipmentinfo.capacity = "";
      this.state.equipmentinfo.category = "";
      this.state.equipmentinfo.equipmentType = "";
      // this.setState({ annual: false, biannual: false, fiveyearly: false, tenyearly: false });
      // dispatch(getApplicableServiceTypeList(e.target.value));
      dispatch(getEquipmentDropDownList(this.state.dropDown));
    }
    if (nodeName === "capacity") {
      this.state.dropDown.EquipmentName = this.state.dropDown.EquipmentName;
      this.state.dropDown.Category = this.state.dropDown.Category;
      this.state.dropDown.EquipmentType = this.state.dropDown.EquipmentType;
      this.state.dropDown.Capacity = e.target.value;
      let value = e.target.value;
      let item = EquipmentDropDownList.find((o) => o.capacity === value);
      let equipId = item.equipmentId;

      /*    let url = `${API.ServiceTypeInterval}?equipmentId=${equipId}`;
      axios
        .get(url)
        .then((response) => {
          dispatch({
            type: "getServiceTypeIntervalListSuccess",
            data: response.data,
          });
         /*  this.setState({ openOwnerRequirement: true }); 
          if (response.data) {
            response.data.map((f, index) => {
              let interval = f.interval;
              let type = f.serviceType.replace(/ +/g, "");
              this.state.interval = f.interval;
              let port = {
                port: this.state["lastDonePort" + type],
                country: this.state["lastDoneCountry" + type],
                serviceProvider: this.state["lastDoneServiceProvider" + type],
                type: type,
              };
              dispatch(getShipPortAndCountry(port));
            });
          }
        })
        .catch((error) => {
          dispatch({
            type: "getServiceTypeIntervalListFailure",
            data: "error",
          });
        }); */
      dispatch(getEquipmentDropDownList(this.state.dropDown));
    }
    this.state.equipmentinfo[nodeName] = e.target.value;
    this.setState({});
  }
  handleMakeSearchChanges(e, field) {
    this.state.make = e.target.value;
    this.state.equipmentinfo.make = e.target.value;
    this.setState({});
  }
  handleModelSearchChanges(e, field) {
    this.state.equipmentinfo.model = e.target.value;
    this.setState({});
  }
  handleEquipmentTypeSearchChanges(e, field) {
    const { dispatch } = this.props;
    this.state.equipmentinfo.equipmentType = e.target.value;
    this.setState({})
    if (e.target.value === "") {
      if (this.state.equipmentinfo?.equipmentName.toLowerCase().includes("lifeboat")) {
        this.state.equipmentinfo.lifeboatMake = "";
        this.state.equipmentinfo.lifeboatMake = "";
        this.state.equipmentinfo.lifeboatModel = "";
        this.state.equipmentinfo.davitwinchMake = "";
        this.state.equipmentinfo.lifeboatMakeId = 0;
        this.state.equipmentinfo.lifeboatModelId = 0;
        this.state.equipmentinfo.davitwinchMakeId = 0;
      } else if (this.state.equipmentinfo?.equipmentName.toLowerCase().includes("rescue boat")) {
        this.state.equipmentinfo.rescueboatMake = "";
        this.state.equipmentinfo.rescueboatModel = "";
        this.state.equipmentinfo.rescueboatdavitwinchMake = "";
        this.state.equipmentinfo.rescueboatMakeId = 0;
        this.state.equipmentinfo.rescueboatModelId = 0;
        this.state.equipmentinfo.rescueboatdavitwinchMakeId = 0;
      } else {
        this.state.equipmentinfo.make = "";
        this.state.equipmentinfo.makeId = 0;
        this.state.equipmentinfo.model = "";
        this.state.equipmentinfo.modelId = 0;
      }
      this.state.dropDown.EquipmentType = "";
      this.setState({})
      dispatch(getEquipmentDropDownList(this.state.dropDown));
    }
  }
  handleEquipmentTypeSelectChange(value, field, id) {
    const { dispatch } = this.props;
    if (field === "equipmentType") {
      this.state.dropDown.EquipmentName = this.state.dropDown.EquipmentName;
      this.state.dropDown.Category = this.state.dropDown.Category;
      this.state.dropDown.EquipmentType = value;
      this.state.equipmentinfo.serviceDetails = [];
      this.state.equipmentinfo.capacity = "";
      this.state.equipmentinfo.category = this.state.dropDown.Category;
      this.state.equipmentinfo.equipmentType = value;
      if (this.state.equipmentinfo.equipmentName.toLowerCase().includes("lifeboat")) {
        this.state.equipmentinfo.lifeboatMake = "";
        this.state.equipmentinfo.lifeboatMake = "";
        this.state.equipmentinfo.lifeboatModel = "";
        this.state.equipmentinfo.davitwinchMake = "";
        this.state.equipmentinfo.lifeboatMakeId = 0;
        this.state.equipmentinfo.lifeboatModelId = 0;
        this.state.equipmentinfo.davitwinchMakeId = 0;
      } else if (this.state.equipmentinfo.equipmentName.toLowerCase().includes("rescue boat")) {
        this.state.equipmentinfo.rescueboatMake = "";
        this.state.equipmentinfo.rescueboatModel = "";
        this.state.equipmentinfo.rescueboatdavitwinchMake = "";
        this.state.equipmentinfo.rescueboatMakeId = 0;
        this.state.equipmentinfo.rescueboatModelId = 0;
        this.state.equipmentinfo.rescueboatdavitwinchMakeId = 0;
      } else {
        this.state.equipmentinfo.make = "";
        this.state.equipmentinfo.makeId = 0;
        this.state.equipmentinfo.model = "";
        this.state.equipmentinfo.modelId = 0;
      }
      this.setState({})
      dispatch(getEquipmentDropDownList(this.state.dropDown));
    }
  }
  handleModelSelectChange(value, field, id) {
    const { dispatch, EquipmentDropDownList, match } = this.props;
    var ShipId = 0;
    if (field === "modelId") {
      this.state.equipmentinfo.model = value;
      this.state.equipmentinfo.modelId = id;
      this.setState({});
      if (EquipmentDropDownList !== null && this.state.dropDown.EquipmentName !== "") {
        let result = this.state.dropDown.EquipmentName;
        let item = EquipmentDropDownList.find((o) => o.equipmentName === result);
        let equipId = item.equipmentId;
        let makeId = this.state.equipmentinfo.makeId
        let modelId = id
        let url = `${API.ServiceTypeInterval}V2?equipmentId=${equipId}&makeId=${makeId}&modelId=${modelId}&flagId=${this.props.flagclass.flag}&classIds=${this.props.flagclass.class}`;
        if (equipId !== 0 && makeId !== 0) {
          axios
            .get(url)
            .then((response) => {
              console.log(response.data, 'tesxt')
              dispatch({
                type: "getServiceTypeIntervalListSuccess",
                data: response.data,
              });
              response.data.forEach((i, index) => {
                if (this.state.applicableServiceEquipType[index]) {
                  this.state.applicableServiceEquipType[index].applicableEquipType = { lookUpId: this.state.selectedEquipmentTypes.lookUpId, lookUpName: this.state.selectedEquipmentTypes.lookUpName };
                  this.state.applicableServiceEquipType[index].serviceType = i.serviceType;
                  this.state.applicableServiceEquipType[index].applicableEquipType.serviceTypeId = i.serviceTypeId;
                } else {
                  // Initialize an object if it doesn't exist at the current index
                  this.state.applicableServiceEquipType[index] = { applicableEquipType: { lookUpId: this.state.selectedEquipmentTypes.lookUpId, lookUpName: this.state.selectedEquipmentTypes.lookUpName }, serviceType: i.serviceType, serviceTypeId: i.serviceTypeId };
                }
              });
              this.setState({ openOwnerRequirement: true });
              if (response.data) {
                response.data.map((f, index) => {
                  let interval = f.interval;
                  let type = f.serviceType.replace(/ +/g, "");
                  this.state.interval = f.interval;
                  let port = {
                    port: this.state["lastDonePort" + type],
                    country: this.state["lastDoneCountry" + type],
                    serviceProvider: this.state["lastDoneServiceProvider" + type],
                    type: type,
                  };
                  dispatch(getShipPortAndCountry(port));
                });
              }
            })
            .catch((error) => {
              dispatch({
                type: "getServiceTypeIntervalListFailure",
                data: "error",
              });
            });
        }
      }
    }
    // this.props.applicableServiceType.map(service=>{
    //   console.log(service,'litmus')
    // })
  }
  handleMakeSelectChange(value, field, id) {
    const { dispatch } = this.props;
    if (field === "makeId") {
      this.state.dropDown.EquipmentName = this.state.dropDown.EquipmentName
      this.state.dropDown.makeId = id;
      if (value === "others") {
        dispatch(getModelsOtherList(value))
        this.state.modelOthers = true;
        this.setState({})
      } else {
        this.state.modelOthers = false;
        this.setState({})
      }
      dispatch(getModelsList(value));
      dispatch(getEquipmentDropDownList(this.state.dropDown));
      this.state.make = value;
      this.state.equipmentinfo.make = value;
      this.state.equipmentinfo.makeId = id;
      this.state.equipmentinfo.model = "";
      this.state.equipmentinfo.modelId = 0;
      this.setState({});
    }
  }

  handleLifeBoatMakeSearchChanges(e, field) {
    if (field === "lifeboatMakeId") {
      this.state.equipmentinfo.lifeboatMake = e.target.value;
      this.setState({});
    } else {
      this.state.equipmentinfo.davitwinchMake = e.target.value;
      this.setState({});
    }
  }
  handleLifeBoatMakeSelectChange(value, field, id) {
    const { dispatch } = this.props;
    if (field === "lifeboatMakeId") {
      this.state.dropDown.makeId = id;
      if (value === "others") {
        dispatch(getModelsOtherList(value))
        this.state.modelOthers = true;
        this.setState({})
      } else {
        this.state.modelOthers = false;
        this.setState({})
      }
      dispatch(getEquipmentDropDownList(this.state.dropDown));
      this.state.equipmentinfo.lifeboatMake = value;
      this.state.equipmentinfo.lifeboatMakeId = id;
      this.state.equipmentinfo.lifeboatModel = "";
      this.state.equipmentinfo.lifeboatModelId = 0;
      this.setState({});
    } else if (field === "davitwinchMakeId") {
      this.state.dropDown.davitwinchMakeId = id;
      if (value === "others") {
        dispatch(getModelsOtherList(value))
        this.state.modelOthers = true;
        this.setState({})
      } else {
        this.state.modelOthers = false;
        this.setState({})
      }
      dispatch(getEquipmentDropDownList(this.state.dropDown));
      this.state.equipmentinfo.davitwinchMake = value;
      this.state.equipmentinfo.davitwinchMakeId = id;
      this.state.equipmentinfo.lifeboatModel = "";
      this.state.equipmentinfo.lifeboatModelId = 0;
      this.setState({});
    }

  }
  handleLifeBoatModelSearchChanges(e, field) {
    this.state.equipmentinfo.lifeboatModel = e.target.value;
    this.setState({});
  }
  handleLifeBoatModelSelectChange(value, field, id) {
    const { dispatch, EquipmentDropDownList, match } = this.props;
    if (field === "lifeboatModelId") {
      this.state.equipmentinfo.lifeboatModel = value;
      this.state.equipmentinfo.lifeboatModelId = id;
      this.setState({});
      if (EquipmentDropDownList !== null && this.state.dropDown.EquipmentName !== "") {
        let result = this.state.dropDown.EquipmentName;
        let item = EquipmentDropDownList.find((o) => o.equipmentName === result);
        let equipId = item.equipmentId;
        let makeId = this.state.equipmentinfo.lifeboatMakeId;
        let modelId = id
        let url = `${API.EquipmentServiceIntervalList}V2?equipmentId=${equipId}&makeId=${makeId}&modelId=${modelId}&flagId=${this.props.flagclass.flag}&classIds=${this.props.flagclass.class}`;
        if (equipId !== 0 && makeId !== 0) {
          axios
            .get(url)
            .then((response) => {
              console.log(response.data, 'tesxt')
              dispatch({
                type: "getServiceTypeIntervalListSuccess",
                data: response.data,
              });
              response.data.forEach((i, index) => {
                if (this.state.applicableServiceEquipType[index]) {
                  this.state.applicableServiceEquipType[index].applicableEquipType = { lookUpId: this.state.selectedEquipmentTypes.lookUpId, lookUpName: this.state.selectedEquipmentTypes.lookUpName };
                  this.state.applicableServiceEquipType[index].serviceType = i.serviceType;
                  this.state.applicableServiceEquipType[index].applicableEquipType.serviceTypeId = i.serviceTypeId;
                } else {
                  // Initialize an object if it doesn't exist at the current index
                  this.state.applicableServiceEquipType[index] = { applicableEquipType: { lookUpId: this.state.selectedEquipmentTypes.lookUpId, lookUpName: this.state.selectedEquipmentTypes.lookUpName }, serviceType: i.serviceType, serviceTypeId: i.serviceTypeId };
                }
              });
              this.state.applicableServiceEquipType = [];
              this.setState({ openOwnerRequirement: true });
              if (response.data) {
                response.data.map((f, index) => {
                  let interval = f.interval;
                  let type = f.serviceType.replace(/ +/g, "");
                  this.state.interval = f.interval;
                  let port = {
                    port: this.state["lastDonePort" + type],
                    country: this.state["lastDoneCountry" + type],
                    serviceProvider: this.state["lastDoneServiceProvider" + type],
                    type: type,
                  };
                  dispatch(getShipPortAndCountry(port));
                });
              }
            })
            .catch((error) => {
              dispatch({
                type: "getServiceTypeIntervalListFailure",
                data: "error",
              });
            });
        }
      }
    }
  }

  handleRescueBoatMakeSearchChanges(e, field) {
    if (field === "rescueboatMakeId") {
      this.state.equipmentinfo.rescueboatMake = e.target.value;
      this.setState({});
    } else {
      this.state.equipmentinfo.rescueboatdavitwinchMake = e.target.value;
      this.setState({});
    }
  }
  handleRescueBoatMakeSelectChange(value, field, id) {

    const { dispatch } = this.props;
    if (field === "rescueboatMakeId") {
      this.state.dropDown.makeId = id;
      if (value === "others") {
        dispatch(getModelsOtherList(value))
        this.state.modelOthers = true;
        this.setState({})
      } else {
        this.state.modelOthers = false;
        this.setState({})
      }
      dispatch(getEquipmentDropDownList(this.state.dropDown));
      this.state.equipmentinfo.rescueboatMake = value;
      this.state.equipmentinfo.rescueboatMakeId = id;
      this.state.equipmentinfo.rescueboatModel = "";
      this.state.equipmentinfo.rescueboatModelId = 0;
      this.setState({});
    } else if (field === "rescueboatdavitwinchMakeId") {
      this.state.dropDown.davitwinchMakeId = id;
      if (value === "others") {
        dispatch(getModelsOtherList(value))
        this.state.modelOthers = true;
        this.setState({})
      } else {
        this.state.modelOthers = false;
        this.setState({})
      }
      dispatch(getEquipmentDropDownList(this.state.dropDown));
      this.state.equipmentinfo.rescueboatdavitwinchMake = value;
      this.state.equipmentinfo.rescueboatdavitwinchMakeId = id;
      this.state.equipmentinfo.rescueboatModel = "";
      this.state.equipmentinfo.rescueboatModelId = 0;
      this.setState({});
    }

  }
  handleRescueBoatModelSearchChanges(e, field) {
    this.state.equipmentinfo.rescueboatModel = e.target.value;
    this.setState({});
  }
  handleRescueBoatModelSelectChange(value, field, id) {
    const { dispatch, EquipmentDropDownList, match } = this.props;
    if (field === "rescueboatModelId") {
      this.state.equipmentinfo.rescueboatModel = value;
      this.state.equipmentinfo.rescueboatModelId = id;
      this.setState({});
      if (EquipmentDropDownList !== null && this.state.dropDown.EquipmentName !== "") {
        let result = this.state.dropDown.EquipmentName;
        let item = EquipmentDropDownList.find((o) => o.equipmentName === result);
        let equipId = item.equipmentId;
        let makeId = this.state.equipmentinfo.rescueboatMakeId;
        let modelId = id
        let url = `${API.EquipmentServiceIntervalList}V2?equipmentId=${equipId}&makeId=${makeId}&modelId=${modelId}&flagId=${this.props.flagclass.flag}&classIds=${this.props.flagclass.class}`;
        if (equipId !== 0 && makeId !== 0) {
          axios
            .get(url)
            .then((response) => {
              console.log(response.data, 'tesxt')
              dispatch({
                type: "getServiceTypeIntervalListSuccess",
                data: response.data,
              });
              response.data.forEach((i, index) => {
                if (this.state.applicableServiceEquipType[index]) {
                  this.state.applicableServiceEquipType[index].applicableEquipType = { lookUpId: this.state.selectedEquipmentTypes.lookUpId, lookUpName: this.state.selectedEquipmentTypes.lookUpName };
                  this.state.applicableServiceEquipType[index].serviceType = i.serviceType;
                  this.state.applicableServiceEquipType[index].applicableEquipType.serviceTypeId = i.serviceTypeId;
                } else {
                  // Initialize an object if it doesn't exist at the current index
                  this.state.applicableServiceEquipType[index] = { applicableEquipType: { lookUpId: this.state.selectedEquipmentTypes.lookUpId, lookUpName: this.state.selectedEquipmentTypes.lookUpName }, serviceType: i.serviceType, serviceTypeId: i.serviceTypeId };
                }
              });
              this.state.applicableServiceEquipType = [];
              this.setState({ openOwnerRequirement: true });
              if (response.data) {
                response.data.map((f, index) => {
                  let interval = f.interval;
                  let type = f.serviceType.replace(/ +/g, "");
                  this.state.interval = f.interval;
                  let port = {
                    port: this.state["lastDonePort" + type],
                    country: this.state["lastDoneCountry" + type],
                    serviceProvider: this.state["lastDoneServiceProvider" + type],
                    type: type,
                  };
                  dispatch(getShipPortAndCountry(port));
                });
              }
            })
            .catch((error) => {
              dispatch({
                type: "getServiceTypeIntervalListFailure",
                data: "error",
              });
            });
        }
      }
    }
  }


  handleManufacturingDate(date) {
    this.state.equipmentinfo.dateOfBuild = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      DatePickerIsOpen: false,
    });
  }

  handleBlur() {
    this.setState({
      DatePickerIsOpen: false,
    });
  }

  openDatePicker() {
    this.setState({
      DatePickerIsOpen: !this.state.DatePickerIsOpen,
      lastannualDatePickerIsOpen: false,
      nextannualDatePickerIsOpen: false,
      lastbiannualDatePickerIsOpen: false,
      nextbiannualDatePickerIsOpen: false,
      lastFiveYearDatePickerIsOpen: false,
      nextFiveYearDatePickerIsOpen: false,
      lastTenYearDatePickerIsOpen: false,
      nextTenYearDatePickerIsOpen: false,
    });
  }
  // Annual service info
  handleAnnualInputChange(e, index) {
    const { dispatch } = this.props;
    let nodeName = e.target.name;
    if (nodeName === "lastannualServiceCertificate") {
      dispatch(postAnnualCertificate(e.target.files[0], index));
      this.setState({
        ["lastannualServiceCertificate" + index]: e.target.files[0].name,
        ["file" + index]: e.target.files[0],
      });
    } else {
      var fieldname = nodeName + index;
      this.state[fieldname] = e.target.value;
      this.setState({});
      // this.setState({
      //     [""+fieldname]:e.target.value
      // })
    }

    // if (nodeName === "lastannualServiceCertificate") {
    //     this.setState({
    //         lastannualServiceCertificate: e.target.files[0].name,
    //         file1: e.target.files[0]
    //     });
    // } else {
    //     this.state.Annual[nodeName] = e.target.value;
    //     this.setState({});
    // }
  }

  confirmChooseFile = (fieldName, e, index) => {
    const {t}=this.props;
    this.setState({ openAlert: true });
    confirmAlert({
      message:
        // "Documents once uploaded can't be remove, please verify the documents before uploading.",
        t('confirmAlertMessage.FileuploadMsg'),
      buttons: [
        {
          label: "Ok",
          onClick: () => {
            this.state[fieldName] = this.state[fieldName]
              ? [...this.state[fieldName], ...e]
              : [...e];
            this.setState({ openAlert: false });
            this.props.dispatch(
              uploadAttachments(this.state[fieldName], index)
            );
          },
        },
        {
          label: "Cancel",
          onClick: () => {
            this.setState({ openAlert: false });
          },
        },
      ],
      onClickOutside: () => {
        this.setState({ openAlert: false });
      },
    });
  };

  handleAnnualInputChangeMultiple(e, index) {
    const { dispatch } = this.props;
    let nodeName = e.target.name;
    var fieldName = nodeName + index;
    // dispatch(postAnnualCertificate(e.target.files[0], index));
    this.confirmChooseFile(fieldName, e.target.files, index);
  }
  onRemoveChange(item, name) {
    this.state[name] = item;
    this.setState({});
  }

  handleAnnualSearchChange(e, index, name) {
    const { dispatch } = this.props;
    let nodeName = name;
    let port = {
      port:
        name === "lastDonePort"
          ? e.target.value
          : this.state["lastDonePort" + index],
      country:
        name === "lastDoneCountry"
          ? e.target.value
          : this.state["lastDoneCountry" + index],
      serviceProvider:
        name === "lastDoneServiceProvider"
          ? e.target.value
          : this.state["lastDoneServiceProvider" + index],
      type: index,
    };
    if (e.target.value === "" && name === "lastDonePort") {
      this.state["lastDonePort" + index] = "";
      this.state["lastDoneCountry" + index] = "";
      this.state["lastDoneServiceProvider" + index] = "";
      this.setState({});
      let portdata = {
        port: "",
        country: "",
        serviceProvider: "",
        type: index,
      };
      this.props.dispatch(getShipPortAndCountry(portdata));
    } else {
      this.props.dispatch(getShipPortAndCountry(port));
    }
    var fieldname = nodeName + index;
    this.state[fieldname] = e.target.value;
    this.setState({});
  }

  handleAnnualSelectChange(e, index, name, id) {
    const { dispatch } = this.props;
    let nodeName = name;
    var fieldname = nodeName + index;
    let port = {
      port: name === "lastDonePort" ? e : this.state["lastDonePort" + index],
      country:
        name === "lastDoneCountry" ? e : this.state["lastDoneCountry" + index],
      serviceProvider:
        name === "lastDoneServiceProvider"
          ? e
          : this.state["lastDoneServiceProvider" + index],
      type: index,
    };
    dispatch(getShipPortAndCountry(port));
    this.state[fieldname] = e;
    this.state[nodeName + "id" + index] = id;
    this.setState({});
  }
  renderServiceProviderTitle(state, val) {
    return (
      state?.serviceProvider?.toLowerCase().indexOf(val?.toLowerCase()) !== -1
    );
  }
  renderCountryTitle(state, val) {
    return state?.country?.toLowerCase().indexOf(val.toLowerCase()) !== -1;
  }
  renderPortTitle(state, val) {
    return state?.port?.toLowerCase().indexOf(val.toLowerCase()) !== -1;
  }
  renderMakeTitle(state, val) {
    return state?.name?.toLowerCase().indexOf(val.toLowerCase()) !== -1;
  }
  renderEquipmentTypeTitle(state, val) {
    return state?.toLowerCase().indexOf(val.toLowerCase()) !== -1;
  }
  renderModelTitle(state, val) {
    return state?.name?.toLowerCase().indexOf(val.toLowerCase()) !== -1;
  }

  // handleAnnualServiceDate(date) {
  //     this.state.Annual.lastDoneDate = Moment(new Date(Date.parse(date))).format(
  //         "YYYY-MM-DD"
  //     );
  //     this.setState({
  //         lastannualDatePickerIsOpen: false,
  //     });
  // }
  handleServiceDateChange(value, field, intervalValue) {
    let date1 = Moment(new Date(Date.parse(value))).format("YYYY-MM-DD");
    this.setState({
      ["lastDoneDate" + field]: date1,
      ["lastannualDatePickerIsOpen" + field]: false,
    });
    this.props.dispatch(getServiceDates(date1, intervalValue, field));
  }
  openannualDatePicker(field) {
    this.setState({
      ["lastannualDatePickerIsOpen" + field]:
        !this.state["lastannualDatePickerIsOpen" + field],
      ["nextannualDatePickerIsOpen" + field]: false,
    });

    // this.setState({
    //     lastannualDatePickerIsOpen: !this.state.lastannualDatePickerIsOpen,
    //     DatePickerIsOpen: false,
    //     nextannualDatePickerIsOpen: false,
    //     lastbiannualDatePickerIsOpen: false,
    //     nextbiannualDatePickerIsOpen: false,
    //     lastFiveYearDatePickerIsOpen: false,
    //     nextFiveYearDatePickerIsOpen: false,
    //     lastTenYearDatePickerIsOpen: false,
    //     nextTenYearDatePickerIsOpen: false,
    // });
  }
  handlenextServiceDateChange(value, field) {
    let date1 = Moment(new Date(Date.parse(value))).format("YYYY-MM-DD");
    this.setState({
      ["nextDueDate" + field]: date1,
      ["nextannualDatePickerIsOpen" + field]: false,
    });
  }
  // handlenextAnnualServiceDate(date) {
  //     this.state.Annual.nextDueDate = Moment(new Date(Date.parse(date))).format(
  //         "YYYY-MM-DD"
  //     );
  //     this.setState({
  //         nextannualDatePickerIsOpen: false,
  //     });
  // }
  nextannualDatePicker(field) {
    this.setState({
      ["nextannualDatePickerIsOpen" + field]:
        !this.state["nextannualDatePickerIsOpen" + field],
      ["lastannualDatePickerIsOpen" + field]: false,
    });
    // this.setState({
    //     nextannualDatePickerIsOpen: !this.state.nextannualDatePickerIsOpen,
    //     DatePickerIsOpen: false,
    //     lastannualDatePickerIsOpen: false,
    //     lastbiannualDatePickerIsOpen: false,
    //     nextbiannualDatePickerIsOpen: false,
    //     lastFiveYearDatePickerIsOpen: false,
    //     nextFiveYearDatePickerIsOpen: false,
    //     lastTenYearDatePickerIsOpen: false,
    //     nextTenYearDatePickerIsOpen: false,
    // });
  }
  // Biannual service info
  // handleBiannualInputChange(e) {
  //     let nodeName = e.target.name;
  //     if (nodeName === "lastbiannualServiceCertificate") {
  //         this.setState({
  //             lastbiannualServiceCertificate: e.target.files[0].name,
  //             file2: e.target.files[0]
  //         });
  //     } else {
  //         this.state.Biannual[nodeName] = e.target.value;
  //         this.setState({});
  //     }
  // }
  // handleBiannualServiceDate(date) {
  //     this.state.Biannual.lastDoneDate = Moment(new Date(Date.parse(date))).format(
  //         "YYYY-MM-DD"
  //     );
  //     this.setState({
  //         lastbiannualDatePickerIsOpen: false,
  //     });
  // }
  // openbiannualDatePicker() {
  //     this.setState({
  //         lastbiannualDatePickerIsOpen: !this.state.lastbiannualDatePickerIsOpen,
  //         DatePickerIsOpen: false,
  //         lastannualDatePickerIsOpen: false,
  //         nextannualDatePickerIsOpen: false,
  //         nextbiannualDatePickerIsOpen: false,
  //         lastFiveYearDatePickerIsOpen: false,
  //         nextFiveYearDatePickerIsOpen: false,
  //         lastTenYearDatePickerIsOpen: false,
  //         nextTenYearDatePickerIsOpen: false,
  //     });
  // }
  // handlenextBiannualServiceDate(date) {
  //     this.state.Biannual.nextDueDate = Moment(new Date(Date.parse(date))).format(
  //         "YYYY-MM-DD"
  //     );
  //     this.setState({
  //         nextbiannualDatePickerIsOpen: false,
  //     });
  // }
  // nextbiannualDatePicker() {
  //     this.setState({
  //         nextbiannualDatePickerIsOpen: !this.state.nextbiannualDatePickerIsOpen,
  //         DatePickerIsOpen: false,
  //         lastannualDatePickerIsOpen: false,
  //         nextannualDatePickerIsOpen: false,
  //         lastbiannualDatePickerIsOpen: false,
  //         lastFiveYearDatePickerIsOpen: false,
  //         nextFiveYearDatePickerIsOpen: false,
  //         lastTenYearDatePickerIsOpen: false,
  //         nextTenYearDatePickerIsOpen: false,
  //     });
  // }
  // Five yearly service info
  // handleFiveYearlyInputChange(e) {
  //     let nodeName = e.target.name;
  //     if (nodeName === "last5yearlyServiceCertificate") {
  //         this.setState({
  //             last5yearlyServiceCertificate: e.target.files[0].name,
  //             file3: e.target.files[0]
  //         });
  //     } else {
  //         this.state.Fiveyearly[nodeName] = e.target.value;
  //         this.setState({});
  //     }
  // }
  // handle5YearServiceDate(date) {
  //     this.state.Fiveyearly.lastDoneDate = Moment(new Date(Date.parse(date))).format(
  //         "YYYY-MM-DD"
  //     );
  //     this.setState({
  //         lastFiveYearDatePickerIsOpen: false,
  //     });
  // }
  // open5YearDatePicker() {
  //     this.setState({
  //         lastFiveYearDatePickerIsOpen: !this.state.lastFiveYearDatePickerIsOpen,
  //         DatePickerIsOpen: false,
  //         lastannualDatePickerIsOpen: false,
  //         nextannualDatePickerIsOpen: false,
  //         lastbiannualDatePickerIsOpen: false,
  //         nextbiannualDatePickerIsOpen: false,
  //         nextFiveYearDatePickerIsOpen: false,
  //         lastTenYearDatePickerIsOpen: false,
  //         nextTenYearDatePickerIsOpen: false,
  //     });
  // }
  // handlenext5YearServiceDate(date) {
  //     this.state.Fiveyearly.nextDueDate = Moment(new Date(Date.parse(date))).format(
  //         "YYYY-MM-DD"
  //     );
  //     this.setState({
  //         nextFiveYearDatePickerIsOpen: false,
  //     });
  // }
  // next5YearDatePicker() {
  //     this.setState({
  //         nextFiveYearDatePickerIsOpen: !this.state.nextFiveYearDatePickerIsOpen,
  //         DatePickerIsOpen: false,
  //         lastannualDatePickerIsOpen: false,
  //         nextannualDatePickerIsOpen: false,
  //         lastbiannualDatePickerIsOpen: false,
  //         nextbiannualDatePickerIsOpen: false,
  //         lastFiveYearDatePickerIsOpen: false,
  //         lastTenYearDatePickerIsOpen: false,
  //         nextTenYearDatePickerIsOpen: false,
  //     });
  // }
  // Ten yearly service info
  // handleTenYearlyInputChange(e) {
  //     let nodeName = e.target.name;
  //     if (nodeName === "last10yearlyServiceCertificate") {
  //         this.setState({
  //             last10yearlyServiceCertificate: e.target.files[0].name,
  //             file4: e.target.files[0]
  //         });
  //     } else {
  //         this.state.Tenyearly[nodeName] = e.target.value;
  //         this.setState({});
  //     }
  // }
  // handle10YearServiceDate(date) {
  //     this.state.Tenyearly.lastDoneDate = Moment(new Date(Date.parse(date))).format(
  //         "YYYY-MM-DD"
  //     );
  //     this.setState({
  //         lastTenYearDatePickerIsOpen: false,
  //     });
  // }
  // open10YearDatePicker() {
  //     this.setState({
  //         lastTenYearDatePickerIsOpen: !this.state.lastTenYearDatePickerIsOpen,
  //         DatePickerIsOpen: false,
  //         lastannualDatePickerIsOpen: false,
  //         nextannualDatePickerIsOpen: false,
  //         lastbiannualDatePickerIsOpen: false,
  //         nextbiannualDatePickerIsOpen: false,
  //         lastFiveYearDatePickerIsOpen: false,
  //         nextFiveYearDatePickerIsOpen: false,
  //         nextTenYearDatePickerIsOpen: false,
  //     });
  // }
  // handlenext10YearServiceDate(date) {
  //     this.state.Tenyearly.nextDueDate = Moment(new Date(Date.parse(date))).format(
  //         "YYYY-MM-DD"
  //     );
  //     this.setState({
  //         nextTenYearDatePickerIsOpen: false,
  //     });
  // }
  // next10YearDatePicker() {
  //     this.setState({
  //         nextTenYearDatePickerIsOpen: !this.state.nextTenYearDatePickerIsOpen,
  //         DatePickerIsOpen: false,
  //         lastannualDatePickerIsOpen: false,
  //         nextannualDatePickerIsOpen: false,
  //         lastbiannualDatePickerIsOpen: false,
  //         nextbiannualDatePickerIsOpen: false,
  //         lastFiveYearDatePickerIsOpen: false,
  //         nextFiveYearDatePickerIsOpen: false,
  //         lastTenYearDatePickerIsOpen: false,
  //     });
  // }
  ClearInput(id) {

    this.props.dispatch(deleteAttachmentInBucket(this.state.equipmentinfo.attachmentGuid, this.state.equipmentinfo.attachmentName));
    this.state["lastannualServiceCertificate" + id] = "";
    this.state["attachmentName" + id] = "";
    this.state["attachmentGuid" + id] = "";
    this.setState({});
  }
  ClearInput1(id) {

    this.state["lastannualServicePhoto" + id] = "";
    this.state["attachmentName" + id] = "";
    this.state["attachmentGuid" + id] = "";
    this.setState({});
  }
  resetServiceDetails = (serviceType) => {
    let type = serviceType.replace(/ +/g, "");
    this.ClearInput(type);
    this.state["lastDoneDate" + type] = "";
    this.state["nextDueDate" + type] = "";
    this.state["lastDonePort" + type] = "";
    this.state["lastDoneCountry" + type] = "";
    this.state["lastDoneServiceProvider" + type] = "";
    this.state["lastannualServiceCertificate" + type] = "";
    this.state["lastannualServicePhoto" + type] = "";
    this.setState({});
  };
  /*  handleRadioButtonChanges = (e, i) => {
    var lineitems = this.state.AddServiceYear;
    lineitems[i][e.target.name] = e.target.value;
    if (e.target.value === "Shore") {
      lineitems[i]["isShore"] = true;
    }
    if(e.target.value==="Ship"){
      lineitems[i]["isShip"] = true;
    }
    this.setState({ AddServiceYear: lineitems });
  };
  miscChargeValidation() {
    let validateField = [];
    let inValidComponent = [];
    let length = this.state.AddServiceYear.length;
    let miscCharges = this.state.AddServiceYear.filter(
      (item) => item.isDeleted === false
    );
    if (
      $("#chargeDescription0").val() === "" ||
      miscCharges[0].radioButton === ""
    ) {
      if ($("#chargeDescription0").val() === "") {
        $("#chargeDescription0ErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`);
      } else {
        $("#chargeDescription0ErrMsg").text("");
      }
    if (miscCharges[0].radioButton === "") {
        $("#isUnitPrice0ErrMsg").text("This field is required");
      } else {
        $("#isUnitPrice0ErrMsg").text("");
      }
      return;
    } else {
      $("#chargeDescription0ErrMsg").text("");
      $("#isUnitPrice0ErrMsg").text("");
    }
    let indexFrom = $("#chargeDescription0").val() === "" && miscCharges[0].radioButton === "" ? 1 : 0;
    miscCharges.forEach((row, index) => {
      if (index >= indexFrom) {
        validateField.push(
          { Id: `chargeDescription${index}`, Type: "text" }
        );
        if (row.radioButton === "") {
          inValidComponent.push(`isUnitPrice${index}`);
          $("#isUnitPrice" + index + "ErrMsg").text("This field is required");
        } else {
          $("#isUnitPrice" + index + "ErrMsg").text("");
          var itemIndex = inValidComponent.indexOf(`isUnitPrice${index}`);
          if (itemIndex != -1) {
            inValidComponent.splice(itemIndex, 1);
          }
        }
      }
    });
    const validationResult = validateFields(validateField, true);
    validationResult.InValidFields.forEach((element, index) => {
      $("#" + element.Id + "ErrMsg").text("This field is required");
    });
    validationResult.ValidFields.forEach((element, index) => {
      $("#" + element.Id + "ErrMsg").text("");
    });
    if (validationResult.IsValid === true && inValidComponent.length === 0) {
      return true;
    } else {
      return false;
    }
  
  }
  addApplicableType = () => {
    const { dispatch } = this.props;
    if (this.state.AddServiceYear.length > 0) {
      let isValidMiscCharge = this.miscChargeValidation();
      if (!isValidMiscCharge) {
        return;
      }
      console.log(this.state.AddServiceYear)
    } 
      this.setState({ modalIsOpen: false }, () => {
        this.ClearServiceYear();
      });
  };
  AddNewServiceYear() {
 const {applicableServiceType}=this.props;
     let isValidMiscCharge = this.miscChargeValidation();
     if (!isValidMiscCharge) {
       return;
     }
     let result = [];
     let result1 = this.state.ServiceTypeList;
     let result2 = this.state.selectedServiceYears;
     console.log("selected", this.state.selectedServiceYears);
     result = result1.filter(function (obj) {
       return result2.indexOf(obj.item) === -1;
     });
     var arrayStroage = this.state.AddServiceYear;
     var arrayLength = 0;
     if (applicableServiceType.length > 0) {
       arrayLength = applicableServiceType.length;
     } else {
       arrayLength = this.state.AddServiceYear.length;
     }
     console.log("service years:", result);
     this.setState({
       AddServiceYear: [
         ...this.state.AddServiceYear,
         {
          shipId:this.state.AddServiceYear[0].shipId,
          equipmentId:this.state.AddServiceYear[0].equipmentId,
           Id: arrayLength + 1,
           serviceTypeId: 0,
           servicetypelist: result,
           isShore: false,
           IsShip:false,
           radioButton: "",
           isDeleted: false,
         },
       ],
     });
   }
   handleSelectYear = (e, i) => {
    let value = parseInt(e.target.value);
    let ServiceTypeList = this.state.ServiceTypeList.filter(
      (i) => i.item === value
    );
    let x = this.state.selectedServiceYears;
    x.push(value);
    this.setState({ selectedServiceYears: x });
    console.log("selected", this.state.selectedServiceYears);
    let AddServiceYear = this.state.AddServiceYear;
    AddServiceYear[i][e.target.name] = parseInt(e.target.value);
    AddServiceYear[i]["serviceType"] = ServiceTypeList[0].serviceTypes;
    this.setState({ AddServiceYear });
  };
  DeleteServiceYear(index) {
    const serviceCharges = [...this.state.AddServiceYear];
    serviceCharges.splice(index, 1);
    if(this.state.selectedServiceYears.length > 1)
    {
    const selectedServiceYear = [...this.state.selectedServiceYears];
    selectedServiceYear.splice(index, 1);
    this.state.selectedServiceYears = selectedServiceYear;
    this.setState({})
    }
    this.state.AddServiceYear = serviceCharges;
    this.setState({});
  }
  showModal = (ModelId, isModelNew) => {
   this.setState(
        {
          modalIsOpen: !this.state.modalIsOpen,
           openAlert: true 
        },
        () => {
          this.ClearServiceYear();
        }
      );
  };
  ClearServiceYear() {
    var arrayStroage = this.props.applicableServiceType;
    var arrayLength = arrayStroage.length;
    this.setState({
      AddServiceYear: [
      
        {shipId:this.state.AddServiceYear[0].shipId,
          equipmentId:this.state.AddServiceYear[0].equipmentId,
          Id: arrayLength >= 0 ? arrayLength + 1 : 0,
          serviceTypeId: 0,
          serviceTypeName: "",
          servicetypelist: this.state.ServiceTypeList,
          isShore: false,
          isShip:false,
          radioButton: "",
          isDeleted:false
        },
      ],
      selectedServiceYears: [],
    });
  } */

  render() {
    return (
      <div className="pb-3">
        {/*  <Modal
          size="md"
          show={this.state.modalIsOpen}
          onHide={() => {
            this.showModal(0, true);
          }}
         aria-labelledby="example-modal-sizes-title-sm"
          backdrop="static"
          centered="true"
          animation="true"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-sm">
              Service Type
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.AddServiceYear.map((x, index) => {
              return (
                <>
                  <div className="row pt-2">
                    <div className="col-sm-5">
                      <select
                        className="form-control"
                        name="serviceTypeId"
                        id={`chargeDescription${index}`}
                        value={x.serviceTypeId == 0 ? "" : x.serviceTypeId}
                        onChange={(e) => this.handleSelectYear(e, index, false)}
                      >
                        <option value="">Service Year</option>
                        {x &&
                          x?.servicetypelist?.map((name) => (
                            <option value={name.item}>
                              {name.serviceTypes}
                            </option>
                          ))}
                      </select>
                      <span
                        id={`chargeDescription${index}ErrMsg`}
                        className="spanErrMsg ml-2"
                      ></span>
                    </div>
                    <div className="col-sm-5" style={{ lineHeight: "0px" }}>
                      <RadioGroup
                        className="radio-value"
                        row
                        name="radioButton"
                        id={`isUnitPrice${index}`}
                        value={x.radioButton}
                        onChange={(e) =>
                          this.handleRadioButtonChanges(e, index)
                        }
                      >
                        <FormControlLabel
                          className="mt-0"
                          style={{ marginBottom: "11px" }}
                          value="Ship"
                          control={<Radio color="default" size="small" />}
                          label="Ship"
                        />
                        <FormControlLabel
                          className="mt-0"
                          style={{ marginBottom: "11px" }}
                          value="Shore"
                          control={<Radio color="default" size="small" />}
                          label="Shore"
                        />
                      </RadioGroup>
                      <span
                        id={`isUnitPrice${index}ErrMsg`}
                        className="spanErrMsg ml-2"
                      ></span>
                    </div>
                    <div
                      className={`col-sm-2 ${
                        this.state.isOwner ? "" : "d-none"
                      }`}
                    >
                      <div
                        className={`mr-3 pl-1 ${index === 0 ? "d-none" : ""}`}
                      >
                        <div
                          className="flex"
                          onClick={() => this.DeleteServiceYear(index)}
                        >
                          <MinusIcon />
                        </div>
                      </div>
                      <div
                        className={`mr-3 pl-1 ${index === 0 ? "" : "d-none"}`}
                      >
                        <div
                          className="flex"
                          onClick={() => this.AddNewServiceYear()}
                        >
                          <AddIcon />
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
            <div
              className="form-group search-btn-col mt-4"
              style={{ textAlign: "end" }}
            >
              <button
                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                type="submit"
                onClick={() => this.addApplicableType()}
              >
                {"SUBMIT"}
              </button>
              <button
                className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                type="button"
                onClick={() => this.showModal(0, true)}
              >
                {" "}
                Cancel{" "}
              </button>
            </div>
          </Modal.Body>
        </Modal> */}

        {this.renderCardData()}
      </div>
    );
  }
  renderCardData() {
    const {
      showSidePane,
      editEquipment,
      EquipmentDropDownList,
      EquipmentNameList,
      PortNameList,
      applicableServiceType,
      PortList,
      CountryList,
      Loading,
      EquipmentNameListAndId,
      MakeList,
      ModelList,
      ModelOthersList,
      t
    } = this.props;
    const isArabic = i18n.language === 'arab'
    const { openAlert, MakeModelList } = this.state;
    let EquipmentTypeList =
      EquipmentDropDownList &&
      EquipmentDropDownList?.map((r) => r.equipmentType);
    let CategoryList =
      EquipmentDropDownList && EquipmentDropDownList?.map((r) => r.category);
    let CapacityList =
      EquipmentDropDownList && EquipmentDropDownList?.map((r) => r.capacity);
    /* let MakeTypeList=EquipmentDropDownList && EquipmentDropDownList.map((r) => r.category);
let ModelTypeList=EquipmentDropDownList && EquipmentDropDownList.map((r) => r.category); */
    CategoryList = [...new Set(CategoryList)];
    EquipmentTypeList = [...new Set(EquipmentTypeList)];

    var result = EquipmentNameListAndId.reduce((unique, o) => {
      if (!unique.some((obj) => obj.equipmentName === o.equipmentName)) {
        unique.push(o);
      }
      return unique;
    }, []);
    return (
      <div className="row">
        <div className="full-height">
          <div className="row pt-3">
            <div className="col-lg-12">
              <div className="panel-box search-filter-box">
                <button
                  className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                  onClick={() => this.hideSidePanel()}
                >
                  &larr; {t("CommonText.Return")}
                </button>
                <div className="row">
                  <div className="col-lg-12">
                    <div
                      className="card mt-2 MM-card-header"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1a3464",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title ml-2 mt-2"
                          style={{ color: "092a51" }}
                        >
                          {t("ShipDetailsScreen.EquipmentDetails")}
                        </h5>
                      </div>
                    </div>
                    <div className="row pt-2 pb-4 search-filter-box">
                      {/* <div className="col-lg-6">
                      <label className="form-label">Equipment Name</label>
                      <br></br>
                      <select
                        className="form-control"
                        name="equipmentName"
                        value={this.state.equipmentinfo.equipmentName}
                        onChange={(e) => this.handleInputChange(e)}
                      >
                        <option value="">Select Equipment Name </option>
                        {EquipmentNameList &&
                          EquipmentNameList.equipment.map((equipment) => (
                            <option value={equipment}>{equipment}</option>
                          ))}
                      </select>
                    </div> */}
                      <div className="col-lg-6">
                        <div
                          className="autocomplete-wrappers"
                          style={{
                            zIndex: openAlert ? 99 : this.state.openEquipment && !Loading ? 99999 : null
                          }}>
                          <label className="form-label fontstyle required">
                            {t("ShipEquipmentStatusScreen.EquipmentName")}
                          </label>
                          <br></br>
                          <Autocomplete
                            contentEditable={true}
                            onMenuVisibilityChange={(isOpen) => {
                              this.state.openEquipment = isOpen;
                              this.setState({});
                            }}
                            open={!Loading ? this.state.openEquipment : false}
                            value={this.state.equipmentinfo.equipmentName}
                            renderInput={(props) => {
                              return (
                                <input
                                  className="form-control equipment"
                                  id="exampleFormControlInput1"
                                  {...props}
                                />
                              );
                            }}
                            inputProps={{
                              placeholder: `${t("EditEquipmentScreenContent.SelectEquipmentName")}`,
                            }}
                            items={result ?? []}
                            getItemValue={(item) => item.equipmentName}
                            shouldItemRender={this.renderEquipmentTitle.bind(
                              this
                            )}
                            renderMenu={(item) => (
                              <div className="dropdown">{item}</div>
                            )}
                            renderItem={(item, isHighlighted) => (
                              <div
                                className={`items ${isHighlighted ? "selected-items" : ""
                                  }`}
                              >
                                {item.equipmentName}
                                {/* &nbsp; ({(item.category && (item.capacity || item.equipmentType)) ? item.category + "," : item.category ? item.category : ""}&nbsp; {(item.capacity && (item.category || item.equipmentType)) ? item.capacity + "," : item.capacity ? item.capacity : ""}&nbsp; {item.equipmentType ? item.equipmentType : ""}) */}
                              </div>
                            )}
                            onChange={(e) =>
                              this.handleInputChanges(e, "equipmentName")
                            }
                            onSelect={(value, item) =>
                              this.handleSelectChange(
                                value,
                                "equipmentName",
                                item.equipmentId,
                                item
                              )
                            }
                          />
                          <span
                            id="EquipmentErrMsg"
                            className="spanErrMsg ml-2"
                          ></span>
                        </div>
                      </div>
                      {/* <div className="col-lg-6">
                        <label className="form-label">{t("EquipmentTypeScreen.Title")}</label>
                        <br></br>
                        <MaterialAutocomplete
                          value={this.state?.selectedEquipmentTypes}
                          options={this.state?.equipemntConfigTypeList ?? []}
                          getOptionLabel={(item) => item?.lookUpName || ""}
                          style={{ marginTop: "-17px" }}
                          noOptionsText={t("CommonText.NoOption")}
                          size={"small"}
                          onChange={(e, value) => this.onEquipmentTypeChange(e, value?.lookUpId, value)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder={t("EquipmentManagementScreenContent.SelectEquipmentType")}
                              margin="normal"
                            />
                          )}
                        />
                      </div> */}
                      <div className="col-lg-6">
                        <label className="form-label fontstyle required" >
                          {t("TopPaneContent.Category")}
                        </label>
                        <br></br>
                        <select
                          className="form-control"
                          name="category"
                          value={this.state.equipmentinfo.category}
                          onChange={(e) => this.handleInputChange(e)}
                        >
                          <option value="">{t("EquipmentManagementScreenContent.SelectCategory")}</option>
                          {CategoryList &&
                            CategoryList.map((categoryname) => (
                              <option value={categoryname}>
                                {categoryname}
                              </option>
                            ))}
                        </select>
                        <span
                          id="categoryErrMsg"
                          className="spanErrMsg ml-2"
                        ></span>
                      </div>
                      <div className="col-lg-6">
                        <div className="autocomplete-wrappers"
                          style={{
                            zIndex: openAlert
                              ? 99 : this.state.openEquipmentType && !Loading ? 99999 : null,
                          }}>
                          <label className="form-label fontstyle required">
                            {t("ShipEquipmentStatusScreen.Type")}
                          </label>
                          <br></br>
                          <Autocomplete
                            contentEditable={true}
                            onMenuVisibilityChange={(isOpen) => {
                              this.state.openEquipmentType = isOpen;
                              this.setState({});
                            }}

                            open={!Loading ? this.state.openEquipmentType : false}
                            value={this.state.equipmentinfo.equipmentType}
                            renderInput={(props) => {
                              return (
                                <input className="form-control equipment" id="exampleFormControlInput1" {...props}
                                />
                              );
                            }}
                            inputProps={{
                              placeholder: `${t("EditEquipmentScreenContent.SelectType")}`,
                            }}
                            items={EquipmentTypeList ?? []}
                            getItemValue={(item) => item}
                            shouldItemRender={this.renderEquipmentTypeTitle.bind(this)}
                            renderMenu={(item) => (
                              <div className="dropdown">{item}</div>
                            )}

                            renderItem={(item, isHighlighted) => (
                              <div className={`items ${isHighlighted ? "selected-items" : ""}`}>
                                {item}
                              </div>
                            )}
                            onChange={(e) => this.handleEquipmentTypeSearchChanges(e, "equipmentType")}
                            onSelect={(value, item) => this.handleEquipmentTypeSelectChange(value, "equipmentType")}
                          />
                          <span
                            id="equipmenttypeErrMsg"
                            className="spanErrMsg ml-2"
                          ></span>
                        </div>
                      </div>


                      <div className="col-lg-6">
                        <label className="form-label fontstyle required">
                          {t("ShipEquipmentStatusScreen.Capacity")} /{t("ShipEquipmentStatusScreen.Size")}
                        </label>
                        <br></br>
                        <select
                          className="form-control"
                          name="capacity"
                          value={this.state.equipmentinfo.capacity}
                          onChange={(e) => this.handleInputChange(e)}
                        >
                          <option value="">{t("EditEquipmentScreenContent.SelectCapacity")}</option>
                          {CapacityList &&
                            CapacityList.map((CapacityValue) => (
                              <option value={CapacityValue}>
                                {CapacityValue}
                              </option>
                            ))}
                        </select>
                        <span
                          id="capacityErrMsg"
                          className="spanErrMsg ml-2"
                        ></span>
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label fontstyle required">
                          {t("ShipEquipmentStatusScreen.ManufacturingDate")}
                        </label>
                        <br></br>
                        <div
                          className="input-group add-on date datepicker"
                          data-date-format="yyyy-mm-dd"
                          style={{
                            zIndex:
                              !Loading && this.state.equipmentinfo.dateOfBuild
                                ? 99
                                : this.state.DatePickerIsOpen
                                  ? 99999
                                  : 99,
                          }}
                        >
                          <input
                            type="text"
                            className="form-control date-picker"
                            placeholder={t("ShipEquipmentStatusScreen.ManufacturingDate")}
                            value={this.state.equipmentinfo.dateOfBuild}
                          ></input>
                          <DatePicker
                            showMonthDropdown
                            showYearDropdown
                            onChange={this.handleManufacturingDate}
                            open={this.state.DatePickerIsOpen}
                            onClickOutside={this.handleBlur}
                            dropdownMode="select"
                            popperPlacement="top-end"
                            className="form-control date-picker w-5 hide-date"
                          />
                          <div
                            className="input-group-btn calendar-icon"
                            onClick={this.openDatePicker}
                          >
                            <button
                              className="btn btn-default"
                              style={{ height: "100%" }}
                            >
                              <i className="fa fa-calendar mt-1"></i>
                            </button>
                          </div>
                        </div>
                        <span
                          id="ManufactureDateErrMsg"
                          className="spanErrMsg ml-2"
                        ></span>
                      </div>
                      <div
                        id="LifeBoatEquipment"
                        className="col-lg-6 lifeBoat-hide">
                        <div className="autocomplete-wrappers" style={{
                          zIndex: openAlert ? 99 : this.state.openLifeMake && !Loading ? 99999 : null
                        }}>
                          <label className="form-label fontstyle required">
                            {t("EditEquipmentScreenContent.LifeboatMake")}
                          </label>
                          <br></br>
                          <Autocomplete
                            contentEditable={true}
                            value={this.state.equipmentinfo.lifeboatMake}
                            onMenuVisibilityChange={(isOpen) => {
                              this.state.openLifeMake = isOpen;
                              this.setState({});
                            }}
                            open={!Loading ? this.state.openLifeMake : false}
                            renderInput={(props) => {
                              return (
                                <input className="form-control equipment" id="exampleFormControlInput1" {...props} />
                              );
                            }}
                            inputProps={{ placeholder: `${t("EditEquipmentScreenContent.LifeboatMake")}` }}
                            items={MakeList?.length === 0 ? MakeModelList : MakeList ?? []}
                            getItemValue={(item) => item.name}
                            shouldItemRender={this.renderMakeTitle.bind(this)}
                            renderMenu={(item) => (<div className="dropdown">{item}</div>)}
                            renderItem={(item, isHighlighted) => (
                              <div className={`items ${isHighlighted ? "selected-items" : ""}`}>
                                {item.name}</div>)}
                            onChange={(e) => this.handleLifeBoatMakeSearchChanges(e, "lifeboatMakeId")}
                            onSelect={(value, item) => this.handleLifeBoatMakeSelectChange(value, "lifeboatMakeId", item.id)} />
                          <span
                            id="lifeboatmakeErrMsg"
                            className="spanErrMsg ml-2"></span>
                          <span
                            id="LifeMakeValidationErrMsg"
                            className="spanErrMsg ml-2"></span>
                        </div>

                      </div>
                      <div
                        id="LifeBoatEquipment1"
                        className="col-lg-6 lifeBoat-hide">
                        <div className="autocomplete-wrappers" style={{
                          zIndex: openAlert ? 99 : this.state.openDavitMake && !Loading ? 99999 : null
                        }}>
                          <label className="form-label fontstyle required">
                            {t("EditEquipmentScreenContent.Davit/winchMake")}</label>
                          <br></br>
                          <Autocomplete
                            contentEditable={true}
                            value={this.state.equipmentinfo.davitwinchMake}
                            onMenuVisibilityChange={(isOpen) => {
                              this.state.openDavitMake = isOpen;
                              this.setState({});
                            }}
                            open={!Loading ? this.state.openDavitMake : false}
                            renderInput={(props) => {
                              return (
                                <input className="form-control equipment" id="exampleFormControlInput1" {...props} />
                              );
                            }}
                            inputProps={{ placeholder: `${t("EditEquipmentScreenContent.Davit/winchMake")}` }}
                            items={MakeList?.length === 0 ? MakeModelList : MakeList ?? []}
                            getItemValue={(item) => item.name}
                            shouldItemRender={this.renderMakeTitle.bind(this)}
                            renderMenu={(item) => (<div className="dropdown">{item}</div>)}
                            renderItem={(item, isHighlighted) => (
                              <div className={`items ${isHighlighted ? "selected-items" : ""}`}>
                                {item.name}</div>)}
                            onChange={(e) => this.handleLifeBoatMakeSearchChanges(e, "davitwinchMakeId")}
                            onSelect={(value, item) => this.handleLifeBoatMakeSelectChange(value, "davitwinchMakeId", item.id)} />
                          <span
                            id="davitwinchmakeErrMsg"
                            className="spanErrMsg ml-2"></span>
                          <span
                            id="LifeDavitValidationErrMsg"
                            className="spanErrMsg ml-2"></span>
                        </div>
                      </div>
                      <div
                        id="LifeBoatEquipment3"
                        className="col-lg-6 lifeBoat-hide">
                        <div className="autocomplete-wrappers" style={{
                          zIndex: openAlert ? 99 : this.state.openLifeBoatModel && !Loading ? 99999 : null
                        }}>
                          <label className="form-label fontstyle required">
                            {t("EditEquipmentScreenContent.LifeboatModel")}
                          </label>
                          <br></br>
                          <Autocomplete
                            contentEditable={true}
                            onMenuVisibilityChange={(isOpen) => {
                              this.state.openLifeBoatModel = isOpen;
                              this.setState({});
                            }}
                            open={!Loading ? this.state.openLifeBoatModel : false}
                            value={this.state.equipmentinfo.lifeboatModel}
                            renderInput={(props) => {
                              return (
                                <input
                                  className="form-control equipment" id="exampleFormControlInput1" {...props}
                                />);
                            }}
                            inputProps={{ placeholder: `${t("EditEquipmentScreenContent.LifeboatModel")}` }}
                            items={ModelList?.length === 0 ? MakeModelList ?? [] : ModelList ?? []}
                            getItemValue={(item) => item.name}
                            shouldItemRender={this.renderModelTitle.bind(this)}
                            renderMenu={(item) => (
                              <div className="dropdown">{item}</div>)}
                            renderItem={(item, isHighlighted) => (
                              <div className={`items ${isHighlighted ? "selected-items" : ""}`}>
                                {item.name}</div>)}
                            onChange={(e) => this.handleLifeBoatModelSearchChanges(e, "lifeboattModelId")}
                            onSelect={(value, item) => this.handleLifeBoatModelSelectChange(value, "lifeboatModelId", item.id
                            )} />
                          <span id="lifeboatmodelErrMsg" className="spanErrMsg ml-2"></span>
                          <span id="LifeModelValidationErrMsg" className="spanErrMsg ml-2"></span>
                        </div>
                      </div>
                      <div
                        id="LifeBoatEquipment2"
                        className="col-lg-6 lifeBoat-hide"
                      >
                        <label className="form-label fontstyle required">
                          {t("EditEquipmentScreenContent.LifeboatRelease")}
                        </label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="lifeboatRelease"
                          id="lifeboatrelease"
                          placeholder={t("EditEquipmentScreenContent.LifeboatRelease")}
                          value={this.state.equipmentinfo.lifeboatRelease}
                          onChange={(e) => this.handleInputChange(e)}
                        ></input>
                        <span
                          id="lifeboatreleaseErrMsg"
                          className="spanErrMsg ml-2"
                        ></span>
                      </div>
                      <div
                        id="rescueboatEquipment"
                        className="col-lg-6 lifeBoat-hide">
                        <div className="autocomplete-wrappers" style={{
                          zIndex: openAlert ? 99 : this.state.openRescueMake && !Loading ? 99999 : null
                        }}>
                          <label className="form-label fontstyle required">
                            {t("EditEquipmentScreenContent.rescueboatMake")}</label>
                          <br></br>
                          <Autocomplete
                            contentEditable={true}
                            value={this.state.equipmentinfo.rescueboatMake}
                            onMenuVisibilityChange={(isOpen) => {
                              this.state.openRescueMake = isOpen;
                              this.setState({});
                            }}
                            open={!Loading ? this.state.openRescueMake : false}
                            renderInput={(props) => {
                              return (
                                <input className="form-control equipment" id="exampleFormControlInput1" {...props} />
                              );
                            }}
                            inputProps={{ placeholder: `${t("EditEquipmentScreenContent.rescueboatMake")}` }}
                            items={MakeList?.length === 0 ? MakeModelList : MakeList ?? []}
                            getItemValue={(item) => item.name}
                            shouldItemRender={this.renderMakeTitle.bind(this)}
                            renderMenu={(item) => (<div className="dropdown">{item}</div>)}
                            renderItem={(item, isHighlighted) => (
                              <div className={`items ${isHighlighted ? "selected-items" : ""}`}>
                                {item.name}</div>)}
                            onChange={(e) => this.handleRescueBoatMakeSearchChanges(e, "rescueboatMakeId")}
                            onSelect={(value, item) => this.handleRescueBoatMakeSelectChange(value, "rescueboatMakeId", item.id)} />
                          <span
                            id="rescueboatmakeErrMsg"
                            className="spanErrMsg ml-2"
                          ></span>
                          <span id="rescueMakeValidationErrMsg" className="spanErrMsg ml-2"></span>
                        </div>
                      </div>
                      <div
                        id="rescueboatEquipment1"
                        className="col-lg-6 lifeBoat-hide">
                        <div className="autocomplete-wrappers" style={{
                          zIndex: openAlert ? 99 : this.state.rescueWinchMake && !Loading ? 99999 : null
                        }}>
                          <label className="form-label fontstyle required">
                            {t("EditEquipmentScreenContent.rescueboatDavit/winchMake")}</label>
                          <br></br>
                          <Autocomplete
                            contentEditable={true}
                            onMenuVisibilityChange={(isOpen) => {
                              this.state.rescueWinchMake = isOpen;
                              this.setState({});
                            }}
                            open={!Loading ? this.state.rescueWinchMake : false}
                            value={this.state.equipmentinfo.rescueboatdavitwinchMake}
                            renderInput={(props) => {
                              return (
                                <input className="form-control equipment" id="exampleFormControlInput1" {...props} />
                              );
                            }}
                            inputProps={{ placeholder: `${t("EditEquipmentScreenContent.rescueboatDavit/winchMake")}`, }}
                            items={MakeList?.length === 0 ? MakeModelList : MakeList ?? []}
                            getItemValue={(item) => item.name}
                            shouldItemRender={this.renderMakeTitle.bind(this)}
                            renderMenu={(item) => (<div className="dropdown">{item}</div>)}
                            renderItem={(item, isHighlighted) => (
                              <div className={`items ${isHighlighted ? "selected-items" : ""}`}>
                                {item.name}</div>)}
                            onChange={(e) => this.handleRescueBoatMakeSearchChanges(e, "rescueboatdavitwinchMakeId")}
                            onSelect={(value, item) => this.handleRescueBoatMakeSelectChange(value, "rescueboatdavitwinchMakeId", item.id)} />
                          <span
                            id="rescueboatdavitwinchmakeErrMsg"
                            className="spanErrMsg ml-2"
                          ></span>
                          <span id="rescueDavitValidationErrMsg" className="spanErrMsg ml-2"></span>
                        </div>
                      </div>
                      <div
                        id="rescueboatEquipment3"
                        className="col-lg-6 lifeBoat-hide">
                        <div className="autocomplete-wrappers" style={{
                          zIndex: openAlert ? 99 : this.state.openModel && !Loading ? 99999 : null
                        }}>
                          <label className="form-label fontstyle required">
                            {t("EditEquipmentScreenContent.rescueboatModel")}
                          </label>
                          <br></br>
                          <Autocomplete
                            contentEditable={true}
                            onMenuVisibilityChange={(isOpen) => {
                              this.state.openModel = isOpen;
                              this.setState({});
                            }}
                            open={!Loading ? this.state.openModel : false}
                            value={this.state.equipmentinfo.rescueboatModel}
                            renderInput={(props) => {
                              return (
                                <input
                                  className="form-control equipment" id="exampleFormControlInput1" {...props}
                                />);
                            }}
                            inputProps={{ placeholder: `${t("EditEquipmentScreenContent.rescueboatModel")}` }}
                            items={ModelList?.length === 0 ? MakeModelList ?? [] : ModelList ?? []}
                            getItemValue={(item) => item.name}
                            shouldItemRender={this.renderModelTitle.bind(this)}
                            renderMenu={(item) => (
                              <div className="dropdown">{item}</div>)}
                            renderItem={(item, isHighlighted) => (
                              <div className={`items ${isHighlighted ? "selected-items" : ""}`}>
                                {item.name}</div>)}
                            onChange={(e) => this.handleRescueBoatModelSearchChanges(e, "rescueboatModelId")}
                            onSelect={(value, item) => this.handleRescueBoatModelSelectChange(value, "rescueboatModelId", item.id
                            )} />
                          <span
                            id="rescueboatmodelErrMsg"
                            className="spanErrMsg ml-2"
                          ></span>
                          <span id="rescueModelValidationErrMsg" className="spanErrMsg ml-2"></span>
                        </div>
                      </div>

                      <div
                        id="rescueboatEquipment2"
                        className="col-lg-6 lifeBoat-hide"
                      >
                        <label className="form-label fontstyle required">
                          {t("EditEquipmentScreenContent.rescueboatRelease")}
                        </label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="rescueboatRelease"
                          id="rescueboatrelease"
                          placeholder={t("EditEquipmentScreenContent.rescueboatRelease")}
                          value={this.state.equipmentinfo.rescueboatRelease}
                          onChange={(e) => this.handleInputChange(e)}
                        ></input>
                        <span
                          id="rescueboatreleaseErrMsg"
                          className="spanErrMsg ml-2"
                        ></span>
                      </div>

                      <div className="col-lg-6" id="MakeHide">
                        <div
                          className="autocomplete-wrappers"
                          style={{ zIndex: openAlert ? 99 : 999 }}
                        >
                          <label className="form-label fontstyle required">
                            {t("ShipEquipmentStatusScreen.Make")}
                          </label>
                          <br></br>
                          <Autocomplete
                            contentEditable={true}
                            value={this.state.equipmentinfo.make}
                            renderInput={(props) => {
                              return (
                                <input
                                  className="form-control equipment"
                                  id="exampleFormControlInput1"
                                  {...props}
                                />
                              );
                            }}
                            inputProps={{
                              placeholder: `${t("MakeAndModelScreen.SelectMake")}`,
                            }}
                            items={
                              MakeList.length === 0 ? MakeModelList : MakeList
                            }
                            getItemValue={(item) => item.name}
                            shouldItemRender={this.renderMakeTitle.bind(this)}
                            renderMenu={(item) => (
                              <div className="dropdown">{item}</div>
                            )}
                            renderItem={(item, isHighlighted) => (
                              <div
                                className={`items ${isHighlighted ? "selected-items" : ""
                                  }`}
                              >
                                {item.name}
                              </div>
                            )}
                            onChange={(e) =>
                              this.handleMakeSearchChanges(e, "makeId")
                            }
                            onSelect={(value, item) =>
                              this.handleMakeSelectChange(
                                value,
                                "makeId",
                                item.id
                              )
                            }
                          />
                          <span
                            id="MakeErrMsg"
                            className="spanErrMsg ml-2"
                          ></span>
                          <span
                            id="MakeValidationErrMsg"
                            className="spanErrMsg ml-2"
                          ></span>
                        </div>
                      </div>
                      <div className="col-lg-6" id="ModelHide">
                        <div
                          className="autocomplete-wrappers"
                          style={{ zIndex: openAlert ? 99 : 99 }}
                        >
                          <label className="form-label fontstyle required">
                            {t("ShipEquipmentStatusScreen.Model")}
                          </label>
                          <br></br>
                          <Autocomplete
                            contentEditable={true}
                            value={this.state.equipmentinfo.model}
                            renderInput={(props) => {
                              return (
                                <input
                                  className="form-control equipment"
                                  id="exampleFormControlInput1"
                                  {...props}
                                />
                              );
                            }}
                            inputProps={{
                              placeholder: `${t("MakeAndModelScreen.SelectModel")}`,
                            }}
                            items={
                              ModelList.length === 0 ? MakeModelList ?? [] : ModelList ?? []
                            }
                            getItemValue={(item) => item.name}
                            shouldItemRender={this.renderModelTitle.bind(this)}
                            renderMenu={(item) => (
                              <div className="dropdown">{item}</div>
                            )}
                            renderItem={(item, isHighlighted) => (
                              <div
                                className={`items ${isHighlighted ? "selected-items" : ""
                                  }`}
                              >
                                {item.name}
                              </div>
                            )}
                            onChange={(e) =>
                              this.handleModelSearchChanges(e, "modelId")
                            }
                            onSelect={(value, item) =>
                              this.handleModelSelectChange(
                                value,
                                "modelId",
                                item.id
                              )
                            }
                          />
                          <span
                            id="ModelErrMsg"
                            className="spanErrMsg ml-2"
                          ></span>
                          <span
                            id="ModelValidationErrMsg"
                            className="spanErrMsg ml-2"
                          ></span>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label fontstyle required" id="categoryequiptype">
                          {t("ShipEquipmentStatusScreen.Quantity")}
                        </label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="quantity"
                          id="quantity"
                          placeholder={t("ShipEquipmentStatusScreen.Quantity")}
                          value={this.state.equipmentinfo.quantity}
                          onChange={(e) => this.handleInputChange(e)}
                        ></input>
                        <span
                          id="EquipquantityErrMsg"
                          className="spanErrMsg"
                        ></span>
                        {/* <span id="quantityErrMsg" className="spanErrMsg"></span> */}
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label fontstyle required">
                          {t("ShipEquipmentStatusScreen.Unit-Quantity")}
                        </label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="unit"
                          placeholder={t("ShipEquipmentStatusScreen.Unit-Quantity")}
                          value={this.state.equipmentinfo.unit}
                          onChange={(e) => this.handleInputChange(e)}
                        ></input>
                        <span
                          id="EquipunitErrMsg"
                          className="spanErrMsg"
                        ></span>
                      </div>
                      {/* <div className="col-lg-6 ">
                        <label className="form-label fontstyle required">{t("EquipmentManagementScreenContent.isContract")} </label>
                        <br></br>
                        <div className="row">
                          <div className={"col-sm-3 mt-2 clsm-3"}>
                            <input
                              type="radio"
                              checked={this.state.isContractApplicableYes}
                              onChange={(e) => this.handleInputChanges(e, "isContractApplicableYes")}></input>
                            <span className="ml-1">{t("confirmAlertMessage.Yes")}</span>
                          </div>
                          <div className={"col-sm-9 mt-2 clsm-9"}>
                            <input
                              type="radio"
                              checked={this.state.isContractApplicableNo}
                              onChange={(e) => this.handleInputChanges(e, "isContractApplicableNo")}></input>
                            <span className="ml-1">{t("confirmAlertMessage.No")}</span>
                          </div>
                        </div>
                        <span id="contractErrMsg" className="spanErrMsg"></span>
                      </div> */}
                    </div>
                  </div>
                </div>
                <div className="row pb-4">
                  <div className="col-lg-12">
                    <div
                      className="card mt-2 MM-card-header"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1a3464",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title ml-2 mt-2 f2"
                          style={{ color: "092a51" }}
                        >
                          {t("ApplicableServiceType.Title")}
                        </h5>
                        {/* {this.state.openOwnerRequirement ? (
                          <div
                            className="m-1 flex"
                            onClick={() => this.showModal(0, true)}
                          >
                            <span className="mt-1">{t("ShipManagementContent.Add")}</span>
                            <AddIcon />
                          </div>
                        ) : null} */}
                      </div>
                    </div>

                    {
                      applicableServiceType && applicableServiceType.length
                        ? applicableServiceType.map((servicename, index) => (
                          <div className="row justify-content-end search-filter-box pb-0">
                            <div className="col-lg-6">
                              <label className="form-label">
                                {t('ApplicableServiceType.ServiceType')}
                              </label>
                              <br></br>
                              {/* <TextField
                                placeholder={`${servicename.serviceType} Service Done`}
                                margin="normal"
                                disabled
                              /> */}
                              <div className="input-group">
                                <input
                                  className="form-control"
                                  type="text"
                                  value={`${servicename.serviceType} ${t("ServiceDetails.ServiceDone")}`}
                                  disabled
                                ></input>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <label className="form-label">{t("EquipmentTypeScreen.Title")}</label>
                              <br></br>
                              {console.log(servicename, 'check2')}
                              <MaterialAutocomplete
                                // value={this.state?.selectedEquipmentTypes}
                                value={this.state.applicableServiceEquipType[index]?.applicableEquipType || null}
                                options={this.state?.equipemntConfigTypeList ?? []}
                                getOptionLabel={(item) => item?.lookUpName || ""}
                                style={{ marginTop: "-17px" }}
                                noOptionsText={t("CommonText.NoOption")}
                                size={"small"}
                                onChange={(e, value) => this.onEquipTypeChange(e, value, index, servicename)}
                                // onChange={(e, value) => this.onEquipmentTypeChange(e, value?.lookUpId, value)}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder={t("EquipmentManagementScreenContent.SelectEquipmentType")}
                                    margin="normal"
                                  />
                                )}
                              />
                              <span id={`equipmentContractTypeError${index}`} className="spanErrMsg ml-2"></span>
                            </div>
                          </div>
                        )) : ''}
                    {/* <span
                      id="EquipmentTypeErrMsg"
                      className="spanErrMsg ml-2"
                    ></span> */}

                  </div>

                </div>
                <div className="row pb-3">
                  <div className="col-lg-12">
                    <div
                      className="card mt-2 MM-card-header"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1a3464",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title ml-2 mt-2 f2"
                          style={{ color: "092a51" }}
                        >
                          {t("EditEquipmentScreenContent.ServiceDetails")}
                        </h5>
                        {this.state.openOwnerRequirement ? (
                          <div
                            className="m-1 flex"
                            onClick={() => this.showModal(0, true)}
                          >
                            <span className="mt-1">{t("ShipManagementContent.Add")}</span>
                            <AddIcon />
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {applicableServiceType && applicableServiceType.length
                      ? applicableServiceType.map((servicename, index) => (
                        <div>
                          <div className="row justify-content-end search-filter-box pb-0">
                            <button
                              className="btn btn-primary text-uppercase txtside-btn text-right txtht-btn blue"
                              type="submit"
                              onClick={() =>
                                this.resetServiceDetails(
                                  servicename.serviceType
                                )
                              }
                            >
                              {" "}
                              <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                              <span>
                              {t("EditEquipmentScreenContent.Reset")} 
                              </span> 
                              </span>{" "}
                              <span>{servicename.serviceType}</span>
                            </button>
                          </div>
                          <div className="row  pt-2 pb-4 search-filter-box">
                            <div className="col-lg-6">
                              <label className="form-label">
                              <span className={`${isArabic ? 'arabic_ship' : ''}`}>{t("ServiceDetails.Last")}</span> {servicename.serviceType} {t("ServiceDetails.ServiceDone")}
                              </label>
                              <br></br>
                              <div
                                className="input-group add-on date datepicker"
                                data-date-format="yyyy-mm-dd"
                                style={{
                                  zIndex:
                                    !Loading &&
                                      this.state[
                                      "lastannualDatePickerIsOpen" +
                                      servicename.serviceType.replace(
                                        / +/g,
                                        ""
                                      )
                                      ]
                                      ? 99999
                                      : 99,
                                }}
                              >
                                <input
                                  type="text"
                                  className="form-control date-picker"
                                  placeholder={`${t("ServiceDetails.Last")} ${servicename.serviceType} ${t("ServiceDetails.ServiceDone")}`}
                                  value={
                                    this.state[
                                    "lastDoneDate" +
                                    servicename.serviceType.replace(
                                      / +/g,
                                      ""
                                    )
                                    ]
                                  }
                                ></input>
                                <DatePicker
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  popperPlacement="top-end"
                                  onChange={(e) =>
                                    this.handleServiceDateChange(
                                      e,
                                      servicename.serviceType.replace(
                                        / +/g,
                                        ""
                                      ),
                                      servicename.interval
                                    )
                                  }
                                  open={
                                    this.state[
                                    "lastannualDatePickerIsOpen" +
                                    servicename.serviceType.replace(
                                      / +/g,
                                      ""
                                    )
                                    ]
                                  }
                                  className="form-control date-picker w-5 hide-date"
                                />
                                <div
                                  className="input-group-btn calendar-icon"
                                  onClick={() =>
                                    this.openannualDatePicker(
                                      servicename.serviceType.replace(
                                        / +/g,
                                        ""
                                      )
                                    )
                                  }
                                >
                                  <button
                                    className="btn btn-default"
                                    style={{ height: "100%" }}
                                  >
                                    <i className="fa fa-calendar mt-1"></i>
                                  </button>
                                </div>
                              </div>
                              <span id={`lastDoneDateError${index}`} className="spanErrMsg ml-2"></span>
                            </div>
                            <div className="col-lg-6">
                              <label className="form-label">
                              <span className={`${isArabic ? 'arabic_ship' : ''}`}>{t("ServiceDetails.Next")}</span>  {servicename.serviceType} {t("ServiceDetails.ServiceDue")}
                              </label>
                              <br></br>
                              <div
                                className="input-group add-on date datepicker"
                                data-date-format="yyyy-mm-dd"
                                style={{
                                  zIndex:
                                    !Loading &&
                                      this.state[
                                      "nextannualDatePickerIsOpen" +
                                      servicename.serviceType.replace(
                                        / +/g,
                                        ""
                                      )
                                      ]
                                      ? 99999
                                      : 99,
                                }}
                              >
                                <input
                                  type="text"
                                  className="form-control date-picker"
                                  placeholder={`${t("ServiceDetails.Next")} ${servicename.serviceType} ${t("ServiceDetails.ServiceDue")}`}
                                  value={
                                    this.state[
                                    "nextDueDate" +
                                    servicename.serviceType.replace(
                                      / +/g,
                                      ""
                                    )
                                    ]
                                  }
                                ></input>
                                <DatePicker
                                  showMonthDropdown
                                  showYearDropdown
                                  popperPlacement="top-end"
                                  onChange={(e) =>
                                    this.handlenextServiceDateChange(
                                      e,
                                      servicename.serviceType.replace(
                                        / +/g,
                                        ""
                                      )
                                    )
                                  }
                                  open={
                                    this.state[
                                    "nextannualDatePickerIsOpen" +
                                    servicename.serviceType.replace(
                                      / +/g,
                                      ""
                                    )
                                    ]
                                  }
                                  dropdownMode="select"
                                  className="form-control date-picker w-5 hide-date"
                                />
                                <div
                                  className="input-group-btn calendar-icon"
                                  onClick={() =>
                                    this.nextannualDatePicker(
                                      servicename.serviceType.replace(
                                        / +/g,
                                        ""
                                      )
                                    )
                                  }
                                >
                                  <button
                                    className="btn btn-default"
                                    style={{ height: "100%" }}
                                  >
                                    <i className="fa fa-calendar mt-1"></i>
                                  </button>
                                </div>
                              </div>
                              <span id={`nextDueDateError${index}`} className="spanErrMsg ml-2"></span>
                            </div>
                            <div className="col-lg-6">
                              <div
                                className="autocomplete-wrappers"
                                style={{ zIndex: openAlert ? 99 : 9999 }}
                              >
                                <label className="form-label">
                                <span className={`${isArabic ? 'arabic_ship' : ''}`}>{t("ServiceDetails.Last")}</span> {servicename.serviceType} {t("ServiceDetails.ServicePort")}
                                </label>
                                <br></br>
                                <Autocomplete
                                  contentEditable={true}
                                  value={
                                    this.state[
                                    "lastDonePort" +
                                    servicename.serviceType.replace(
                                      / +/g,
                                      ""
                                    )
                                    ]
                                  }
                                  inputProps={{
                                    placeholder: t("VendorManagementScreenContent.SelectPort"),
                                  }}
                                  items={
                                    this.state[
                                    "PortList" +
                                    servicename.serviceType.replace(
                                      / +/g,
                                      ""
                                    )
                                    ] ?? []
                                  }
                                  getItemValue={(item) => item.port}
                                  shouldItemRender={this.renderPortTitle.bind(
                                    this
                                  )}
                                  renderMenu={(item) => (
                                    <div className="dropdown">{item}</div>
                                  )}
                                  renderItem={(item, isHighlighted) => (
                                    <div
                                      className={`items ${isHighlighted ? "selected-items" : ""
                                        }`}
                                    >
                                      {item.port}
                                    </div>
                                  )}
                                  onChange={(e) =>
                                    this.handleAnnualSearchChange(
                                      e,
                                      servicename.serviceType.replace(
                                        / +/g,
                                        ""
                                      ),
                                      "lastDonePort"
                                    )
                                  }
                                  onSelect={(e, item) =>
                                    this.handleAnnualSelectChange(
                                      e,
                                      servicename.serviceType.replace(
                                        / +/g,
                                        ""
                                      ),
                                      "lastDonePort",
                                      item.portId
                                    )
                                  }
                                />
                                <span id={`lastDonePortError${index}`} className="spanErrMsg ml-2"></span>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div
                                className="autocomplete-wrappers"
                                style={{ zIndex: openAlert ? 99 : 9999 }}
                              >
                                <label className="form-label">
                                <span className={`${isArabic ? 'arabic_ship' : ''}`}>{t("ServiceDetails.Last")}</span> {servicename.serviceType} {t("ServiceDetails.ServiceCountry")}
                                </label>
                                <br></br>
                                <Autocomplete
                                  contentEditable={true}
                                  value={
                                    this.state[
                                    "lastDoneCountry" +
                                    servicename.serviceType.replace(
                                      / +/g,
                                      ""
                                    )
                                    ]
                                  }
                                  inputProps={{
                                    placeholder: t("VendorManagementScreenContent.SelectCountry"),
                                  }}
                                  items={
                                    this.state[
                                    "CountryList" +
                                    servicename.serviceType.replace(
                                      / +/g,
                                      ""
                                    )
                                    ] ?? []
                                  }
                                  getItemValue={(item) => item.country}
                                  shouldItemRender={this.renderCountryTitle.bind(
                                    this
                                  )}
                                  renderMenu={(item) => (
                                    <div className="dropdown">{item}</div>
                                  )}
                                  renderItem={(item, isHighlighted) => (
                                    <div
                                      className={`items ${isHighlighted ? "selected-items" : ""
                                        }`}
                                    >
                                      {item.country}
                                    </div>
                                  )}
                                  onChange={(e) =>
                                    this.handleAnnualSearchChange(
                                      e,
                                      servicename.serviceType.replace(
                                        / +/g,
                                        ""
                                      ),
                                      "lastDoneCountry"
                                    )
                                  }
                                  onSelect={(e) =>
                                    this.handleAnnualSelectChange(
                                      e,
                                      servicename.serviceType.replace(
                                        / +/g,
                                        ""
                                      ),
                                      "lastDoneCountry"
                                    )
                                  }
                                />
                                <span id={`lastDoneCountryError${index}`} className="spanErrMsg ml-2"></span>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div
                                className="autocomplete-wrappers"
                                style={{ zIndex: openAlert ? 99 : 999 }}
                              >
                                <label className="form-label">
                                <span className={`${isArabic ? 'arabic_ship' : ''}`}>{t("ServiceDetails.Last")}</span> {servicename.serviceType} {t("ServiceDetails.ServiceProvider")}
                                </label>
                                <br></br>
                                <Autocomplete
                                  contentEditable={true}
                                  value={
                                    this.state[
                                    "lastDoneServiceProvider" +
                                    servicename.serviceType.replace(
                                      / +/g,
                                      ""
                                    )
                                    ]
                                  }
                                  inputProps={{
                                    placeholder: t("content.Select")+" "+t("EquipmentView.ServiceProvider"),
                                  }}
                                  items={
                                    this.state[
                                    "ServiceProviderList" +
                                    servicename.serviceType.replace(
                                      / +/g,
                                      ""
                                    )
                                    ] ?? []
                                  }
                                  getItemValue={(item) =>
                                    item.serviceProvider
                                  }
                                  shouldItemRender={this.renderServiceProviderTitle.bind(
                                    this
                                  )}
                                  renderMenu={(item) => (
                                    <div className="dropdown">{item}</div>
                                  )}
                                  renderItem={(item, isHighlighted) => (
                                    <div
                                      className={`items ${isHighlighted ? "selected-items" : ""
                                        }`}
                                    >
                                      {item.serviceProvider}
                                    </div>
                                  )}
                                  onChange={(e) =>
                                    this.handleAnnualSearchChange(
                                      e,
                                      servicename.serviceType.replace(
                                        / +/g,
                                        ""
                                      ),
                                      "lastDoneServiceProvider"
                                    )
                                  }
                                  onSelect={(e) =>
                                    this.handleAnnualSelectChange(
                                      e,
                                      servicename.serviceType.replace(
                                        / +/g,
                                        ""
                                      ),
                                      "lastDoneServiceProvider"
                                    )
                                  }
                                />
                                <span id={`lastDoneServiceProviderError${index}`} className="spanErrMsg ml-2"></span>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <label className="form-label">
                                {servicename.serviceType} {t("ServiceDetails.ServiceType")}
                              </label>
                              <br></br>
                              <span>{ }</span>
                            </div>
                            <div className="col-lg-12">
                              <label className="form-label">
                              <span className={`${isArabic ? 'arabic_ship' : ''}`}>{t("ServiceDetails.Last")}</span> {servicename.serviceType} {t("ServiceDetails.ServiceCertificate")}{" "}
                              </label>
                              <br></br>
                              <div class="input-group ">
                                <div class="input-group-prepend">
                                  <span class="input-group-text">
                                  {t("ServiceDetails.BrowseFile")}
                                    <input
                                      type="file"
                                      id="files"
                                      style={{ marginRight: 40 }}
                                      name="lastannualServiceCertificate"
                                      onChange={(e) =>
                                        this.handleAnnualInputChange(
                                          e,
                                          servicename.serviceType.replace(
                                            / +/g,
                                            ""
                                          )
                                        )
                                      }
                                      onClick={(event) => {
                                        event.currentTarget.value = null;
                                      }}
                                    />
                                  </span>
                                </div>
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder=""
                                  value={
                                    this.state[
                                    "lastannualServiceCertificate" +
                                    servicename.serviceType.replace(
                                      / +/g,
                                      ""
                                    )
                                    ]
                                  }
                                />
                                {this.state[
                                  "lastannualServiceCertificate" +
                                  servicename.serviceType.replace(/ +/g, "")
                                ] ? (
                                  <div
                                    class="input-group-append"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i
                                      class="fa fa-times input-group-text"
                                      aria-hidden="true"
                                      onClick={() =>
                                        this.ClearInput(
                                          servicename.serviceType.replace(
                                            / +/g,
                                            ""
                                          )
                                        )
                                      }
                                    ></i>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                            <div className="col-lg-12 hide-pic-option">
                              <label className="form-label">
                              <span className={`${isArabic ? 'arabic_ship' : ''}`}>{t("ServiceDetails.Last")}</span> {servicename.serviceType} {t("ServiceDetails.ServicePhotos")}{" "}
                              </label>
                              <br></br>
                              <div class="input-group ">
                                <div class="input-group-prepend">
                                  <span class="input-group-text">
                                  {t("ServiceDetails.BrowseFile")}
                                    <input
                                      type="file"
                                      multiple
                                      id="files"
                                      accept="image/*"
                                      name="lastannualServicePhoto"
                                      onChange={(e) =>
                                        this.handleAnnualInputChangeMultiple(
                                          e,
                                          servicename.serviceType.replace(
                                            / +/g,
                                            ""
                                          )
                                        )
                                      }
                                      onClick={(event) => {
                                        event.currentTarget.value = null;
                                      }}
                                    />
                                  </span>
                                </div>
                                <input
                                  multiple
                                  type="text"
                                  class="form-control"
                                  placeholder=""
                                  value={
                                    this.state[
                                    "lastannualServicePhoto" +
                                    servicename.serviceType.replace(
                                      / +/g,
                                      ""
                                    )
                                    ]
                                  }
                                />
                                {/* <div className="mui-select">
                                  <Multiselect
                                    isObject={true}
                                    showArrow={true}
                                    displayValue="name"
                                    emptyRecordMsg=""
                                    style={{
                                      // multiselectContainer: {
                                      //   width: "80%",
                                      //   marginRight: "-8px",
                                      // },
                                      searchBox: {
                                        borderTopLeftRadius: "0px",
                                        borderBottomLeftRadius: "0px",
                                      },
                                      option: {
                                        "margin-right": 0,
                                        display: "block",
                                        "font-weight": "normal",
                                      },
                                      chips: {
                                        "background-color": "#1a3464",
                                      },
                                    }}
                                    // onSelect={(item) => this.onSelectChange(item)}
                                    onRemove={(item) =>
                                      this.onRemoveChange(
                                        item,
                                        "lastannualServicePhoto" +
                                        servicename.serviceType.replace(
                                          / +/g,
                                          ""
                                        )
                                      )
                                    }
                                    selectedValues={
                                      this.state[
                                      "lastannualServicePhoto" +
                                      servicename.serviceType.replace(
                                        / +/g,
                                        ""
                                      )
                                      ]
                                    }
                                    placeholder={""}
                                    closeIcon="cancel"
                                  />
                                </div> */}
                                {this.state[
                                  "lastannualServicePhoto" +
                                  servicename.serviceType.replace(/ +/g, "")
                                ] ? (
                                  <div class="input-group-append">
                                    <i
                                      class="fa fa-times input-group-text"
                                      aria-hidden="true"
                                      onClick={() =>
                                        this.ClearInput1(
                                          servicename.serviceType.replace(
                                            / +/g,
                                            ""
                                          )
                                        )
                                      }
                                    ></i>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                      : null}
                  </div>
                </div>


                <div className="row ">
                  <div className="col-lg-12 pl-3 pr-3 pb-3">
                    <div
                      className=" search-btn-col"
                      style={{ textAlign: "end" }}
                    >
                      {editEquipment ? (
                        <button
                          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                          type="submit"
                          onClick={() => this.UpdateEquipment()}
                        >
                          {" "}
                          {t("EquipmentServiceTypes.Update")}{" "}
                        </button>
                      ) : (
                        <button
                          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                          type="submit"
                          onClick={() => this.AddEquipment()}
                        >
                          {" "}
                          {t("ShipManagementContent.Add")}{" "}
                        </button>
                      )}
                      <button
                        className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                        type="button"
                        onClick={() => this.hideSidePanel()}
                      >
                        {" "}
                        {t("ComplianceandBudgetScreen.Cancel")}{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  hideSidePanel() {
    valueCheck = false;
    this.setState({
      dropDown: {
        EquipmentName: "",
        EquipmentType: "",
        Category: "",
        Capacity: "",
        makeId: 0,
        davitwinchMakeId: 0
      },
    });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/ShipManagementNewItem");
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.showSidePane,
    editEquipment: state.MasterScreenReducer.editEquipment,
    EquipmentNameList: state.MasterScreenReducer.EquipmentNameList,
    CategoryList: state.MasterScreenReducer.CategoryList,
    EquipmentTypeList: state.MasterScreenReducer.EquipmentTypeList,
    annualAttachment: state.MasterScreenReducer.annualAttachment,
    biannualAttachment: state.MasterScreenReducer.biannualAttachment,
    fiveyearlyAttachment: state.MasterScreenReducer.fiveyearlyAttachment,
    tenyearlyAttachment: state.MasterScreenReducer.tenyearlyAttachment,
    EquipmentArray: state.MasterScreenReducer.EquipmentArray,
    PortNameList: state.MasterScreenReducer.PortNameList,
    applicableServiceType: state.MasterScreenReducer.applicableServiceTypeInterval,
    ServiceDate: state.MasterScreenReducer.ServiceDate,
    EquipmentObject: state.MasterScreenReducer.EquipmentObject,
    EquipmentDropDownList: state.MasterScreenReducer.EquipmentDropDownList,
    PortList: state.MasterScreenReducer.ShipPortList || [],
    CountryList: state.MasterScreenReducer.ShipCountryList || [],
    ServiceProviderPortList:
      state.MasterScreenReducer.ShipServiceProviderPortList || [],
    ServiceProviderId: state.MasterScreenReducer.ShipServiceProviderID || [],
    Loading: state.PageLoaderReducer.loading,
    EquipmentNameListAndId:
      state.MasterScreenReducer.EquipmentNameListAndId || [],
    serviceAttachment: state.MasterScreenReducer.serviceAttachment,
    MakeList: state.MasterScreenReducer.MakeEquipmentList,
    ModelList: state.MasterScreenReducer.ModelEquipmentList,
    ModelOthersList: state.MasterScreenReducer.ModelOthersList,
    flagclass: state.ShipEquipmentReducer.FlagClass
  };
}
export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(newEquipment)));
